/**
 * Oriëntatieruimte — kandidaten links, productdetail rechts, gedeelde m²-calc.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-uf-orient]');
  if (!root) return;

  var collectionHandle = root.getAttribute('data-uf-orient-collection') || 'pvc';
  var moneyFormat =
    root.getAttribute('data-uf-orient-money-format') ||
    (window.money_format || '{{amount}}');
  var enableGroupColors = root.getAttribute('data-uf-orient-enable-colors') !== 'false';
  var matchSoortForColors = root.getAttribute('data-uf-orient-match-soort') !== 'false';
  var colorOptionLabel =
    root.getAttribute('data-uf-orient-color-label') || 'Kleur';
  var LS_WISHLIST = 'user_wishlist';
  var LS_WISHLIST_META = 'user_wishlist_meta';
  var LS_COMPARE = 'uf_orient_compare';
  var LS_AREA_M2 =
    (window.UfRoomState && window.UfRoomState.KEYS && window.UfRoomState.KEYS.area) ||
    'uf_orient_area_m2';
  /* PDP-calculator leest dezelfde keys (netto m² + diy/pro/custom + %). */
  var LS_WASTE_MODE =
    (window.UfRoomState && window.UfRoomState.KEYS && window.UfRoomState.KEYS.mode) ||
    'uf_orient_waste_mode';
  var LS_WASTE_PCT =
    (window.UfRoomState && window.UfRoomState.KEYS && window.UfRoomState.KEYS.pct) ||
    'uf_orient_waste_pct';
  var wasteFromUrl = false;
  var COMPARE_LIMIT = 3;
  var galleryController = null;
  var lastDetailImages = [];
  var lastDetailProduct = null;
  var lastDetailShopify = null;
  var browseControllers = [];
  var browseObserver = null;
  var browseLoadMoreObserver = null;
  var browseLoadingMore = false;
  var browseProducts = [];
  var browseShown = 0;
  var browseDialogHome = null;
  var browseSyncTimer = null;
  var listControllers = [];
  var listObserver = null;
  var listSyncTimer = null;
  var BROWSE_PAGE = 15;
  var BROWSE_SLIDE_MS = 3000;
  var LIST_CARD_IMG = 240;
  var SLIDESHOW_MS = 4000;
  var slideshowTimer = null;
  var slideshowPlaying = false;

  var els = {
    list: root.querySelector('[data-uf-orient-list]'),
    scrollHint: root.querySelector('[data-uf-orient-scroll-hint]'),
    count: root.querySelector('[data-uf-orient-count]'),
    empty: root.querySelector('[data-uf-orient-empty]'),
    error: root.querySelector('[data-uf-orient-error]'),
    sort: root.querySelector('[data-uf-orient-sort]'),
    reset: root.querySelector('[data-uf-orient-reset]'),
    chips: root.querySelector('[data-uf-orient-chips]'),
    filterToggle: root.querySelector('[data-uf-orient-filter-toggle]'),
    filterPanel: root.querySelector('[data-uf-orient-filter-panel]'),
    filterBackdrop: root.querySelector('[data-uf-orient-filter-backdrop]'),
    filterClose: root.querySelector('[data-uf-orient-filter-close]'),
    filterApply: root.querySelector('[data-uf-orient-filter-apply]'),
    filterApplyCount: root.querySelector('[data-uf-orient-filter-apply-count]'),
    filterResultCount: root.querySelector('[data-uf-orient-filter-result-count]'),
    filterCount: root.querySelector('[data-uf-orient-filter-count]'),
    filterTabs: root.querySelector('[data-uf-orient-filter-tabs]'),
    share: root.querySelector('[data-uf-orient-share]'),
    workspace: root.querySelector('[data-uf-orient-workspace]'),
    detail: root.querySelector('[data-uf-orient-detail]'),
    detailEmpty: root.querySelector('[data-uf-orient-detail-empty]'),
    detailBody: root.querySelector('[data-uf-orient-detail-body]'),
    detailSkeleton: root.querySelector('[data-uf-orient-detail-skeleton]'),
    detailScroll: root.querySelector('[data-uf-orient-detail-scroll]'),
    wishlistThumbs: root.querySelector('[data-uf-orient-wishlist-thumbs]'),
    wishlistCount: root.querySelector('[data-uf-orient-wishlist-count]'),
    slidePrev: root.querySelector('[data-uf-orient-slide-prev]'),
    slideNext: root.querySelector('[data-uf-orient-slide-next]'),
    slideToggle: root.querySelector('[data-uf-orient-slide-toggle]'),
    favBadge: root.querySelector('[data-uf-orient-fav-badge]'),
    compareOpen: root.querySelector('[data-uf-orient-compare-open]'),
    compareCount: root.querySelector('[data-uf-orient-compare-count]'),
    compareDialog: root.querySelector('[data-uf-orient-compare-dialog]'),
    compareBody: root.querySelector('[data-uf-orient-compare-body]'),
    offerteOpen: root.querySelector('[data-uf-orient-offerte-open]'),
    offerteCount: root.querySelector('[data-uf-orient-offerte-count]'),
    offerteDialog: root.querySelector('[data-uf-orient-offerte-dialog]'),
    offerteBody: root.querySelector('[data-uf-orient-offerte-body]'),
    reviewsOpen: root.querySelector('[data-uf-orient-reviews-open]'),
    reviewsScore: root.querySelector('[data-uf-orient-reviews-score]'),
    reviewsDialog: root.querySelector('[data-uf-orient-reviews-dialog]'),
    reviewsBody: root.querySelector('[data-uf-orient-reviews-body]'),
    browseOpen: root.querySelector('[data-uf-orient-browse-open]'),
    browseDialog: root.querySelector('[data-uf-orient-browse-dialog]'),
    browseBody: root.querySelector('[data-uf-orient-browse-body]'),
    browseCount: root.querySelector('[data-uf-orient-browse-count]'),
    browseArea: root.querySelector('[data-uf-orient-browse-area]'),
    browseWasteBtns: root.querySelectorAll('[data-uf-orient-browse-waste-mode]'),
    browseSort: root.querySelector('[data-uf-orient-browse-sort]'),
    mobileSwitch: root.querySelector('[data-uf-orient-mobile-switch]'),
    settingsOpen: root.querySelector('[data-uf-orient-settings-open]'),
    settingsDot: root.querySelector('[data-uf-orient-settings-dot]'),
    sheetHead: root.querySelector('[data-uf-orient-sheet-head]'),
    sheetClose: root.querySelector('[data-uf-orient-sheet-close]'),
    sheetDock: root.querySelector('[data-uf-orient-sheet-dock]'),
    spec: root.querySelector('[data-uf-orient-spec]'),
    area: root.querySelector('[data-uf-orient-area]'),
    actieBar: root.querySelector('[data-uf-orient-actie]'),
    actieHome: root.querySelector('[data-uf-orient-actie-home]'),
    wasteModeBtns: root.querySelectorAll('[data-uf-orient-waste-mode]'),
    roomDialog: root.querySelector('[data-uf-orient-room-dialog]'),
    roomArea: root.querySelector('[data-uf-orient-room-area]'),
    roomLen: root.querySelector('[data-uf-orient-room-len]'),
    roomWid: root.querySelector('[data-uf-orient-room-wid]'),
    roomDims: root.querySelector('[data-uf-orient-room-dims]'),
    roomDimsResult: root.querySelector('[data-uf-orient-room-dims-result]'),
    roomToggleDims: root.querySelector('[data-uf-orient-room-toggle-dims]'),
    roomWasteBtns: root.querySelectorAll('[data-uf-orient-room-waste-mode]'),
    roomWasteHint: root.querySelector('[data-uf-orient-room-waste-hint]'),
    roomConfirm: root.querySelector('[data-uf-orient-room-confirm]'),
    roomError: root.querySelector('[data-uf-orient-room-error]'),
    filterLists: {
      pvctype: root.querySelector('[data-uf-orient-filter-list="pvctype"]'),
      soort: root.querySelector('[data-uf-orient-filter-list="soort"]'),
      kleur: root.querySelector('[data-uf-orient-filter-list="kleur"]'),
      merk: root.querySelector('[data-uf-orient-filter-list="merk"]'),
      lengte: root.querySelector('[data-uf-orient-filter-list="lengte"]'),
      breedte: root.querySelector('[data-uf-orient-filter-list="breedte"]'),
      dikte: root.querySelector('[data-uf-orient-filter-list="dikte"]'),
      slijtlaag: root.querySelector('[data-uf-orient-filter-list="slijtlaag"]'),
      onderlaag: root.querySelector('[data-uf-orient-filter-list="onderlaag"]'),
      vgroeven: root.querySelector('[data-uf-orient-filter-list="vgroeven"]'),
      waterbestendig: root.querySelector('[data-uf-orient-filter-list="waterbestendig"]'),
      geluid: root.querySelector('[data-uf-orient-filter-list="geluid"]'),
      vvw: root.querySelector('[data-uf-orient-filter-list="vvw"]'),
    },
    filterGroups: {
      pvctype: root.querySelector('[data-uf-orient-filter-group="pvctype"]'),
      soort: root.querySelector('[data-uf-orient-filter-group="soort"]'),
      kleur: root.querySelector('[data-uf-orient-filter-group="kleur"]'),
      merk: root.querySelector('[data-uf-orient-filter-group="merk"]'),
      lengte: root.querySelector('[data-uf-orient-filter-group="lengte"]'),
      breedte: root.querySelector('[data-uf-orient-filter-group="breedte"]'),
      dikte: root.querySelector('[data-uf-orient-filter-group="dikte"]'),
      slijtlaag: root.querySelector('[data-uf-orient-filter-group="slijtlaag"]'),
      onderlaag: root.querySelector('[data-uf-orient-filter-group="onderlaag"]'),
      vgroeven: root.querySelector('[data-uf-orient-filter-group="vgroeven"]'),
      waterbestendig: root.querySelector('[data-uf-orient-filter-group="waterbestendig"]'),
      geluid: root.querySelector('[data-uf-orient-filter-group="geluid"]'),
      vvw: root.querySelector('[data-uf-orient-filter-group="vvw"]'),
    },
  };

  var FILTER_GROUPS = [
    'pvctype',
    'soort',
    'kleur',
    'merk',
    'lengte',
    'breedte',
    'dikte',
    'slijtlaag',
    'onderlaag',
    'vgroeven',
    'waterbestendig',
    'geluid',
    'vvw',
  ];

  var FILTER_PANES = ['type', 'kleur', 'merk', 'meer'];
  var FILTER_ALWAYS_SHOW = { pvctype: 1, soort: 1, kleur: 1, merk: 1 };
  var FILTER_GROUP_PANE = {
    pvctype: 'type',
    soort: 'type',
    kleur: 'kleur',
    merk: 'merk',
    lengte: 'meer',
    breedte: 'meer',
    dikte: 'meer',
    slijtlaag: 'meer',
    onderlaag: 'meer',
    vgroeven: 'meer',
    waterbestendig: 'meer',
    geluid: 'meer',
    vvw: 'meer',
  };

  var LAYOUT_OPTIONS = [
    { key: 'hongaarse punt', label: 'Hongaarse punt' },
    { key: 'rechte plank', label: 'Rechte plank' },
    { key: 'tegel', label: 'Tegel' },
    { key: 'visgraat', label: 'Visgraat' },
    { key: 'walvisgraat xl', label: 'Walvisgraat XL' },
    { key: 'weense punt', label: 'Weense punt' },
  ];

  var emptyFilters = function () {
    return {
      pvctype: [],
      soort: [],
      kleur: [],
      merk: [],
      lengte: [],
      breedte: [],
      dikte: [],
      slijtlaag: [],
      onderlaag: [],
      vgroeven: [],
      waterbestendig: [],
      geluid: [],
      vvw: [],
    };
  };

  var wasteMatrix = readWasteMatrix();
  var catalog = [];
  var catalogById = {};
  var productCache = {};
  var kleurThumbByKey = {};
  var popularityScores = {};
  var popularityReady = false;
  var writingUrl = false;
  var lastFocusBeforeDialog = null;
  var reviewsCache = null;
  var reviewsLoading = false;
  var reviewsTab = 'all';
  var REVIEWS_API =
    root.getAttribute('data-uf-orient-reviews-api') ||
    'https://tracker.urbanfloors.nl/api/reviews';

  var state = {
    selectedProductId: null,
    filters: emptyFilters(),
    areaM2: 0,
    wasteMode: 'diy',
    patternHint: 'rechte',
    favoriteProductIds: [],
    comparisonProductIds: [],
    sortBy: 'featured',
    filtersOpen: false,
    filterPane: 'type',
    roomSetupDone: false,
    roomUseDims: false,
  };

  function trackOrient(name, props) {
    var payload = props || {};
    var tries = 0;
    function send() {
      if (typeof window.ufTrack === 'function') {
        window.ufTrack(name, payload);
        return;
      }
      tries += 1;
      if (tries > 20) return;
      setTimeout(send, 250);
    }
    send();
  }

  function trackOrientModal(action, choice, extra) {
    trackOrient(
      'orient_modal_' + action,
      Object.assign({ step: 'Modal', choice: choice || '' }, extra || {})
    );
  }

  var areaTrackTimer = null;
  function trackOrientArea(source) {
    if (areaTrackTimer) window.clearTimeout(areaTrackTimer);
    areaTrackTimer = window.setTimeout(function () {
      areaTrackTimer = null;
      trackOrient('orient_area', {
        step: 'Oppervlakte',
        choice:
          state.areaM2 > 0
            ? String(state.areaM2).replace('.', ',') + ' m²'
            : 'leeg',
        source: source || 'toolbar',
      });
    }, 600);
  }

  function currentOrientHandle() {
    var product =
      lastDetailProduct || catalogById[Number(state.selectedProductId)];
    return (product && product.handle) || '';
  }

  function trackOrientDetail(choice, extra) {
    trackOrient(
      'orient_detail_click',
      Object.assign(
        {
          step: 'Detail',
          choice: choice || '',
          handle: currentOrientHandle(),
        },
        extra || {}
      )
    );
  }

  function filterSummary() {
    return FILTER_GROUPS.map(function (group) {
      var values = state.filters[group] || [];
      if (!values.length) return '';
      return group + ': ' + values.join(', ');
    })
      .filter(Boolean)
      .join(' · ')
      .slice(0, 180);
  }

  function readWasteMatrix() {
    var node = document.querySelector('[data-uf-pc-waste-matrix]');
    var fallback = {
      default: { pro: 10, diy: 15 },
      rechte: { pro: 10, diy: 15 },
      tegel: { pro: 10, diy: 15 },
      visgraat: { pro: 12.5, diy: 17.5 },
      hongaarse: { pro: 15, diy: 20 },
      weense: { pro: 15, diy: 20 },
    };
    if (!node) return fallback;
    try {
      return Object.assign({}, fallback, JSON.parse(node.textContent || '{}'));
    } catch (e) {
      return fallback;
    }
  }

  function roundPerM2Cents(c) {
    if (typeof window.ufRoundPerM2DisplayCents === 'function') {
      return window.ufRoundPerM2DisplayCents(c);
    }
    var n = Math.round(Number(c) || 0);
    return Math.round(n / 5) * 5;
  }

  function productCompareAtM2Cents(product) {
    var price = roundPerM2Cents((product && product.price) || 0);
    var cmp = roundPerM2Cents((product && product.compare_at_price) || 0);
    return cmp > price ? cmp : 0;
  }

  function headerCompareM2Cents(catalogProduct, shopifyProduct) {
    var fromCatalog = productCompareAtM2Cents(catalogProduct);
    if (fromCatalog > 0) return fromCatalog;
    var variants = (shopifyProduct && shopifyProduct.variants) || [];
    var variant = null;
    var i;
    for (i = 0; i < variants.length; i++) {
      if (variants[i] && variants[i].available) {
        variant = variants[i];
        break;
      }
    }
    if (!variant) variant = variants[0] || null;
    if (!variant) return 0;
    var pack = Number(variant.price) || 0;
    var rawCmp = Number(variant.compare_at_price) || 0;
    var m2 = roundPerM2Cents((catalogProduct && catalogProduct.price) || 0);
    if (!(rawCmp > pack) || !(pack > 0) || !(m2 > 0)) return 0;
    var cmp = roundPerM2Cents((rawCmp * m2) / pack);
    return cmp > m2 ? cmp : 0;
  }

  function formatMoney(cents) {
    var c = Math.round(Number(cents) || 0);
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(c, moneyFormat);
    }
    return '€' + (c / 100).toFixed(2).replace('.', ',');
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function wishlistHeartIconsHtml() {
    return (
      '<span class="uf-lf-wishlist__icon uf-lf-wishlist__icon--outline" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.15 16.927" width="22" height="20" fill="currentColor"><path d="M13.67 0a4.85 4.85 0 0 0-4.1 2.23A4.86 4.86 0 0 0 5.47 0 5.53 5.53 0 0 0 0 5.67c0 2.42 1.2 4.8 3.53 7.1a24.9 24.9 0 0 0 5.82 4.1.5.5 0 0 0 .46 0 24.94 24.94 0 0 0 5.82-4.1c2.34-2.3 3.53-4.68 3.53-7.1A5.53 5.53 0 0 0 13.67 0zm1.24 12.04a23.73 23.73 0 0 1-5.33 3.8 23.72 23.72 0 0 1-5.34-3.8C2.1 9.94 1 7.8 1 5.67A4.46 4.46 0 0 1 5.48 1c1.62 0 2.68.7 3.67 2.34a.5.5 0 0 0 .87 0C11 1.7 12.08 1 13.7 1a4.46 4.46 0 0 1 4.46 4.67c0 2.13-1.1 4.28-3.23 6.37z"/></svg></span>' +
      '<span class="uf-lf-wishlist__icon uf-lf-wishlist__icon--solid" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.15 16.927" width="22" height="20" fill="currentColor"><path d="M13.67 0a4.85 4.85 0 0 0-4.1 2.23A4.86 4.86 0 0 0 5.47 0 5.53 5.53 0 0 0 0 5.67c0 2.42 1.2 4.8 3.53 7.1a24.9 24.9 0 0 0 5.82 4.1.5.5 0 0 0 .46 0 24.94 24.94 0 0 0 5.82-4.1c2.34-2.3 3.53-4.68 3.53-7.1A5.53 5.53 0 0 0 13.67 0z"/></svg></span>'
    );
  }

  /** Leverancier-&lt;BR&gt; + Verpakking/Pakinhoud uit productbeschrijving. */
  function sanitizeProductHtml(html) {
    var out = String(html == null ? '' : html);
    if (!out) return '';
    out = out.replace(/(?:&lt;br\s*\/?\s*&gt;\s*){2,}/gi, '</p><p>');
    out = out.replace(/&lt;br\s*\/?\s*&gt;/gi, '<br>');
    out = out.replace(/&lt;b&gt;/gi, '<strong>').replace(/&lt;\/b&gt;/gi, '</strong>');
    out = out.replace(/&lt;strong&gt;/gi, '<strong>').replace(/&lt;\/strong&gt;/gi, '</strong>');
    out = out.replace(
      /<p\b[^>]*>\s*(?:<strong>|<b>)\s*Verpakking\s*:?\s*(?:<\/strong>|<\/b>)\s*[^<]*<\/p>\s*/gi,
      ''
    );
    out = out.replace(/<li\b[^>]*>\s*Pakinhoud\s*:?\s*[^<]*<\/li>\s*/gi, '');
    out = out.replace(/<ul\b[^>]*>\s*<\/ul>\s*/gi, '');
    return out;
  }

  function descriptionSentences(text) {
    var clean = String(text || '')
      .replace(/\u00a0/g, ' ')
      .replace(/([.!?])([A-ZÁÉÍÓÚÀÈÌÒÙÄËÏÖÜÂÊÎÔÛ])/g, '$1 $2')
      .replace(/\s+/g, ' ')
      .trim();
    if (!clean) return [];
    var parts = clean.split(/(?<=[.!?])\s+(?=[A-ZÁÉÍÓÚÀÈÌÒÙÄËÏÖÜÂÊÎÔÛ])/);
    return parts.length ? parts : [clean];
  }

  function appendDescriptionParagraphs(doc, parent, text) {
    var sentences = descriptionSentences(text);
    var i;
    for (i = 0; i < sentences.length; i += 3) {
      var chunk = sentences.slice(i, i + 3).join(' ').trim();
      if (!chunk) continue;
      var p = doc.createElement('p');
      p.textContent = chunk;
      parent.appendChild(p);
    }
  }

  /**
   * Maakt van leverancierstekst een kaart: specificaties in vakjes,
   * opsommingen als vinkjes, losse tekst in alinea's.
   */
  function formatDescriptionHtml(html) {
    var raw = sanitizeProductHtml(html);
    if (!raw) return '';
    if (typeof document === 'undefined' || !document.createElement) return raw;
    var tpl = document.createElement('template');
    tpl.innerHTML = raw;
    var root = tpl.content;
    var doc = document;

    Array.prototype.slice.call(root.querySelectorAll('ul')).forEach(function (ul) {
      var items = Array.prototype.filter.call(ul.children, function (node) {
        return node.tagName === 'LI';
      });
      if (!items.length) return;
      var specs = [];
      var allSpecs = items.every(function (li) {
        var strong = li.querySelector('strong, b');
        if (!strong) return false;
        var label = String(strong.textContent || '')
          .replace(/:\s*$/, '')
          .trim();
        var clone = li.cloneNode(true);
        var mark = clone.querySelector('strong, b');
        if (mark && mark.parentNode) mark.parentNode.removeChild(mark);
        var value = String(clone.textContent || '')
          .replace(/^:\s*/, '')
          .replace(/\s+/g, ' ')
          .trim();
        if (!label || !value) return false;
        specs.push({ label: label, value: value });
        return true;
      });
      if (!allSpecs) {
        ul.className = ((ul.className || '') + ' uf-orient__desc-points').trim();
        return;
      }
      var grid = doc.createElement('div');
      grid.className = 'uf-orient__desc-specs';
      specs.forEach(function (row) {
        var cell = doc.createElement('div');
        cell.className = 'uf-orient__desc-spec';
        var lab = doc.createElement('span');
        lab.className = 'uf-orient__desc-spec-label';
        lab.textContent = row.label;
        var val = doc.createElement('strong');
        val.className = 'uf-orient__desc-spec-value';
        val.textContent = row.value;
        cell.appendChild(lab);
        cell.appendChild(val);
        grid.appendChild(cell);
      });
      if (ul.parentNode) ul.parentNode.replaceChild(grid, ul);
    });

    var next = doc.createElement('div');
    var buffer = '';
    function flushText() {
      var text = buffer;
      buffer = '';
      appendDescriptionParagraphs(doc, next, text);
    }
    Array.prototype.slice.call(root.childNodes).forEach(function (node) {
      if (node.nodeType === 3 || (node.nodeType === 1 && node.tagName === 'BR')) {
        buffer += node.textContent || ' ';
        return;
      }
      flushText();
      if (node.nodeType !== 1) return;
      if (node.tagName === 'P' && !node.querySelector('*')) {
        appendDescriptionParagraphs(doc, next, node.textContent);
        return;
      }
      next.appendChild(node);
    });
    flushText();
    return next.innerHTML;
  }

  function tagHeadVal(tag) {
    var raw = String(tag || '');
    var i = raw.indexOf(':');
    if (i < 0) return { head: '', val: raw.trim() };
    return {
      head: raw.slice(0, i).trim().toLowerCase(),
      val: raw.slice(i + 1).trim(),
    };
  }

  function normalizeKey(s) {
    return String(s || '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
  }

  function displayLabel(key) {
    if (!key) return '';
    return key.replace(/\b\w/g, function (ch) {
      return ch.toUpperCase();
    });
  }

  function parseDecimal(raw) {
    if (raw == null || raw === '') return NaN;
    var s = String(raw).trim().replace(/\s/g, '').replace(',', '.');
    var n = parseFloat(s);
    return isFinite(n) ? n : NaN;
  }

  function headKey(head) {
    return String(head || '')
      .toLowerCase()
      .replace(/[\s_\-()]+/g, '');
  }

  function normalizePvctypeValue(val) {
    var k = normalizeKey(val);
    if (!k) return '';
    if (k.indexOf('click') !== -1 || k.indexOf('klik') !== -1) return 'click';
    if (k.indexOf('plak') !== -1) return 'plak';
    if (k.indexOf('loose') !== -1) return 'loose lay';
    return k;
  }

  function productPvctypeKeys(tags) {
    var out = [];
    (tags || []).forEach(function (t) {
      var tv = tagHeadVal(t);
      if (
        tv.head === 'soort filter' ||
        tv.head === 'pvctype' ||
        tv.head === 'assortiment' ||
        tv.head === 'type'
      ) {
        var k = normalizePvctypeValue(tv.val);
        if ((k === 'plak' || k === 'click' || k === 'loose lay') && out.indexOf(k) === -1) {
          out.push(k);
        }
      }
    });
    return out;
  }

  function productSoortKeys(tags) {
    var out = [];
    (tags || []).forEach(function (t) {
      var tv = tagHeadVal(t);
      if (tv.head === 'lay-out' || tv.head === 'layout') {
        var k = normalizeKey(tv.val);
        if (k && out.indexOf(k) === -1) out.push(k);
      }
    });
    return out;
  }

  function productKleurKeys(tags) {
    var out = [];
    (tags || []).forEach(function (t) {
      var tv = tagHeadVal(t);
      var low = String(t).toLowerCase();
      if (tv.head === 'kleur groep' || low.indexOf('kleur groep:') !== -1) {
        var val = tv.head === 'kleur groep' ? tv.val : low.split('kleur groep:')[1];
        var k = normalizeKey(val);
        if (k && out.indexOf(k) === -1) out.push(k);
      }
    });
    return out;
  }

  function productMerkKeys(tags, vendor) {
    var out = [];
    (tags || []).forEach(function (t) {
      var tv = tagHeadVal(t);
      if (tv.head === 'merk' && tv.val) {
        var k = normalizeKey(tv.val);
        if (k && out.indexOf(k) === -1) out.push(k);
      }
    });
    if (!out.length && vendor) {
      var vk = normalizeKey(vendor);
      if (vk) out.push(vk);
    }
    return out;
  }

  function productLengteKeys(tags) {
    var out = [];
    (tags || []).forEach(function (t) {
      var m = String(t).match(/plank lengte groep:\s*(.+)/i);
      if (m) {
        var k = normalizeKey(m[1]);
        if (k && out.indexOf(k) === -1) out.push(k);
      }
    });
    return out;
  }

  function productBreedteKeys(tags) {
    var out = [];
    (tags || []).forEach(function (t) {
      var m = String(t).match(/plank breedte groep:\s*(.+)/i);
      if (m) {
        var k = normalizeKey(m[1]);
        if (k && out.indexOf(k) === -1) out.push(k);
      }
    });
    return out;
  }

  function productDikteKeys(tags) {
    var out = [];
    (tags || []).forEach(function (t) {
      var tv = tagHeadVal(t);
      if (tv.head === 'dikte totaal mm' || headKey(tv.head) === 'diktetotaalmm') {
        var raw = String(tv.val || '')
          .toLowerCase()
          .replace(',', '.')
          .replace(/\s+/g, '')
          .replace(/mm/g, '');
        var n = parseFloat(raw);
        if (isFinite(n)) {
          var k = String(Math.round(n * 1000) / 1000);
          if (out.indexOf(k) === -1) out.push(k);
        }
      }
    });
    return out;
  }

  function productSlijtlaagKeys(tags) {
    var out = [];
    (tags || []).forEach(function (t) {
      var tv = tagHeadVal(t);
      var hk = headKey(tv.head);
      if (hk === 'diktetoplaagmm' || hk === 'slijtlaagmm' || hk === 'slijtlaag') {
        var raw = String(tv.val || '')
          .toLowerCase()
          .replace(',', '.')
          .replace(/\s+/g, '')
          .replace(/mm/g, '');
        var n = parseFloat(raw);
        if (isFinite(n)) {
          var k = String(Math.round(n * 1000) / 1000);
          if (out.indexOf(k) === -1) out.push(k);
        }
      }
    });
    return out;
  }

  function productOnderlaagKeys(tags) {
    var out = [];
    (tags || []).forEach(function (t) {
      var tv = tagHeadVal(t);
      if (tv.head === 'soort onderlaag') {
        var k = normalizeKey(tv.val);
        if (k && out.indexOf(k) === -1) out.push(k);
      }
    });
    return out;
  }

  function productVgroevenKeys(tags) {
    var out = [];
    (tags || []).forEach(function (t) {
      var tv = tagHeadVal(t);
      if (headKey(tv.head) === 'vgroeven') {
        var k = normalizeKey(tv.val);
        if (k && out.indexOf(k) === -1) out.push(k);
      }
    });
    return out;
  }

  function productWaterbestendigKeys(tags) {
    var out = [];
    (tags || []).forEach(function (t) {
      var low = String(t).toLowerCase().trim();
      if (low === 'waterbestendig' || low === 'waterbestendig: ja' || /waterbestendig:\s*ja\b/.test(low)) {
        if (out.indexOf('ja') === -1) out.push('ja');
      }
    });
    return out;
  }

  function productGeluidKeys(tags) {
    var out = [];
    (tags || []).forEach(function (t) {
      var low = String(t).toLowerCase();
      if (low.indexOf('contactgeluidreductie') === -1) return;
      var m = String(t).match(/(\d+[.,]?\d*)\s*d\s*b/i) || String(t).match(/:\s*(\d+[.,]?\d*)/);
      if (m) {
        var k = String(m[1]).replace(',', '.') + ' db';
        k = normalizeKey(k);
        if (k && out.indexOf(k) === -1) out.push(k);
      }
    });
    return out;
  }

  function productVvwKeys(tags) {
    var out = [];
    (tags || []).forEach(function (t) {
      var low = String(t).toLowerCase();
      if (low.indexOf('vloerverwarming') === -1) return;
      if (/geschikt|:\s*ja\b/.test(low)) {
        if (out.indexOf('ja') === -1) out.push('ja');
      }
    });
    return out;
  }

  var CHECK_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>';

  function truthyJa(val) {
    var v = String(val || '')
      .trim()
      .toLowerCase();
    return v === 'ja' || v === 'yes' || v === 'j' || v === 'true';
  }

  function collectSpecBullets(tags) {
    var showAntislip = false;
    var showVvw = false;
    var hasProductlijn = false;
    var dbDisplay = '';

    (tags || []).forEach(function (tag) {
      var raw = String(tag || '').trim();
      if (!raw) return;
      var low = raw.toLowerCase();
      var tv = tagHeadVal(raw);

      if (low === 'antislip') showAntislip = true;
      if (tv.head.indexOf('antislip') !== -1 && truthyJa(tv.val)) showAntislip = true;

      if (low === 'geschikt voor vloerverwarming') showVvw = true;
      if (low.indexOf('vloerverwarming') !== -1 && tv.head && truthyJa(tv.val)) showVvw = true;

      if (tv.head === 'productlijn' && tv.val) hasProductlijn = true;

      if (
        low.indexOf('contactgeluid') !== -1 &&
        low.indexOf('db') !== -1 &&
        raw.indexOf(':') !== -1
      ) {
        var parts = raw.split(':');
        var dbVal = String(parts[parts.length - 1] || '').trim();
        if (dbVal) {
          dbDisplay = /db/i.test(dbVal) ? dbVal : dbVal + ' dB';
        }
      }
    });

    // Fallback via bestaande filter-helpers
    if (!showVvw && productVvwKeys(tags).length) showVvw = true;
    if (!dbDisplay) {
      var gKeys = productGeluidKeys(tags);
      if (gKeys.length) {
        var g = gKeys[0].replace(/\s*db\b/i, '').trim();
        dbDisplay = g + ' dB';
      }
    }

    var items = [];
    if (showAntislip) items.push({ label: 'Antislip' });
    if (hasProductlijn) items.push({ label: 'Waterbestendig' });
    if (dbDisplay) items.push({ label: 'Geluidsreductie: ' + dbDisplay });
    if (showVvw) items.push({ label: 'Geschikt voor vloerverwarming' });
    items.push({
      label: 'Kwaliteitsgarantie',
      detail:
        'Deze vloer wordt specifiek voor jouw bestelling samengesteld uit één productiebatch, om kleurenverschillen binnen de bestelling te voorkomen.',
    });
    return items;
  }

  function buildSpecBulletsHtml(tags, opts) {
    var items = collectSpecBullets(tags);
    if (!items.length) return '';
    var titleOnly = !!(opts && opts.titleOnly);
    return (
      '<ul class="uf-orient__spec-bullets" role="list">' +
      items
        .map(function (it) {
          var showDetail = it.detail && !titleOnly;
          var labelHtml = showDetail
            ? '<span class="uf-orient__spec-bullets__label">' +
              '<span class="uf-orient__spec-bullets__title">' +
              escapeHtml(it.label) +
              '</span>' +
              '<span class="uf-orient__spec-bullets__detail">' +
              escapeHtml(it.detail) +
              '</span></span>'
            : '<span class="uf-orient__spec-bullets__label">' +
              escapeHtml(it.label) +
              '</span>';
          return (
            '<li class="uf-orient__spec-bullets__item' +
            (showDetail ? ' uf-orient__spec-bullets__item--quality' : '') +
            '">' +
            '<span class="uf-orient__spec-bullets__icon" aria-hidden="true">✓</span>' +
            labelHtml +
            '</li>'
          );
        })
        .join('') +
      '</ul>'
    );
  }

  function buildSpecCardSpecsHtml(product) {
    var install = detectInstallFromProduct(product);
    var installLabel =
      install === 'plak' ? 'Plak' : install === 'click' ? 'Click' : install === 'loose' ? 'Loose lay' : '';
    var slijtKeys = productSlijtlaagKeys(product && product.tags);
    var slijt = slijtKeys.length ? filterOptionLabel('slijtlaag', slijtKeys[0]) : '';
    var facts = '';
    if (installLabel) facts += specCalcRow('Type', installLabel);
    if (slijt) facts += specCalcRow('Slijtlaag', slijt);
    return (
      (facts ? '<div class="uf-orient__spec-facts">' + facts + '</div>' : '') +
      buildSpecBulletsHtml(product && product.tags, { titleOnly: true })
    );
  }

  function parseSpecificatieRows(tags) {
    var rows = [];
    var sorted = (tags || []).slice().sort(function (a, b) {
      return String(a).localeCompare(String(b), 'nl');
    });
    sorted.forEach(function (tag) {
      var raw = String(tag || '').trim();
      if (!raw || raw.indexOf(':') < 0) return;
      var low = raw.toLowerCase();
      if (low.indexOf('http') !== -1 || low.indexOf('www.') !== -1) return;
      var tv = tagHeadVal(raw);
      if (tv.head !== 'specificatie' || !tv.val) return;
      String(tv.val)
        .split('|||')
        .forEach(function (chunk) {
          var c = String(chunk || '').trim();
          if (!c) return;
          var ci = c.indexOf(':');
          if (ci >= 0) {
            var label = c.slice(0, ci).trim();
            var value = c.slice(ci + 1).trim();
            if (label && value) rows.push({ label: label, value: value, point: false });
            else if (value) rows.push({ label: '', value: value, point: true });
          } else {
            rows.push({ label: '', value: c, point: true });
          }
        });
    });
    return rows;
  }

  function buildSpecsTableHtml(tags, sku) {
    var rows = parseSpecificatieRows(tags);
    if (!rows.length && !sku) return '';
    var body = '';
    if (sku) {
      body +=
        '<tr class="uf-lf-specs__row"><th class="uf-lf-specs__label" scope="row">Artikelnummer</th><td class="uf-lf-specs__value">' +
        escapeHtml(sku) +
        '</td></tr>';
    }
    rows.forEach(function (row) {
      if (row.point) {
        body +=
          '<tr class="uf-lf-specs__row"><td class="uf-lf-specs__value" colspan="2">' +
          escapeHtml(row.value) +
          '</td></tr>';
      } else {
        body +=
          '<tr class="uf-lf-specs__row"><th class="uf-lf-specs__label" scope="row">' +
          escapeHtml(row.label) +
          '</th><td class="uf-lf-specs__value">' +
          escapeHtml(row.value) +
          '</td></tr>';
      }
    });
    return (
      '<div class="uf-lf-specs uf-lf-specs--leftcol">' +
      '<div class="uf-lf-specs__card">' +
      '<div class="uf-lf-specs__head"><h3 class="uf-lf-specs__title">Specificaties</h3></div>' +
      '<div class="uf-lf-specs__table-wrap"><table class="uf-lf-specs__table"><tbody>' +
      body +
      '</tbody></table></div></div></div>'
    );
  }

  function keysForGroup(group, product) {
    var tags = product && product.tags;
    switch (group) {
      case 'pvctype':
        return productPvctypeKeys(tags);
      case 'soort':
        return productSoortKeys(tags);
      case 'kleur':
        return productKleurKeys(tags);
      case 'merk':
        return productMerkKeys(tags, product && product.vendor);
      case 'lengte':
        return productLengteKeys(tags);
      case 'breedte':
        return productBreedteKeys(tags);
      case 'dikte':
        return productDikteKeys(tags);
      case 'slijtlaag':
        return productSlijtlaagKeys(tags);
      case 'onderlaag':
        return productOnderlaagKeys(tags);
      case 'vgroeven':
        return productVgroevenKeys(tags);
      case 'waterbestendig':
        return productWaterbestendigKeys(tags);
      case 'geluid':
        return productGeluidKeys(tags);
      case 'vvw':
        return productVvwKeys(tags);
      default:
        return [];
    }
  }

  function filterOptionLabel(group, key) {
    if (group === 'pvctype') {
      if (key === 'plak') return 'Plak';
      if (key === 'click') return 'Click';
      if (key === 'loose lay') return 'Loose Lay';
    }
    if (group === 'soort') {
      for (var i = 0; i < LAYOUT_OPTIONS.length; i++) {
        if (LAYOUT_OPTIONS[i].key === key) return LAYOUT_OPTIONS[i].label;
      }
    }
    if (group === 'dikte' || group === 'slijtlaag') return String(key).replace('.', ',') + ' mm';
    if (group === 'waterbestendig' && key === 'ja') return 'Ja';
    if (group === 'vvw' && key === 'ja') return 'Geschikt';
    if (group === 'geluid') return displayLabel(key.replace(' db', ' dB'));
    return displayLabel(key);
  }

  function inferPatternFromProduct(p) {
    var kinds = productSoortKeys(p && p.tags);
    var hay = kinds.join(' ') + ' ' + String((p && p.title) || '').toLowerCase();
    if (hay.indexOf('walvisgraat') !== -1) return 'visgraat';
    if (hay.indexOf('visgraat') !== -1 || hay.indexOf('herringbone') !== -1) return 'visgraat';
    if (hay.indexOf('hongaar') !== -1) return 'hongaarse';
    if (hay.indexOf('ween') !== -1) return 'weense';
    if (hay.indexOf('tegel') !== -1) return 'tegel';
    return 'rechte';
  }

  function patternLabel(pattern) {
    var map = {
      rechte: 'rechte plank',
      tegel: 'tegel',
      visgraat: 'visgraat',
      hongaarse: 'Hongaarse punt',
      weense: 'Weense punt',
    };
    return map[pattern] || pattern || 'rechte plank';
  }

  function wastePctForMode(pattern, mode) {
    var row = wasteMatrix[pattern] || wasteMatrix.default || { diy: 15, pro: 10 };
    var pct = mode === 'pro' ? Number(row.pro) : Number(row.diy);
    return isFinite(pct) ? pct : mode === 'pro' ? 10 : 15;
  }

  function wastePctFor(pattern) {
    return wastePctForMode(pattern, state.wasteMode);
  }

  function activeWastePct(product) {
    var pattern = product ? inferPatternFromProduct(product) : state.patternHint;
    return wastePctFor(pattern);
  }

  function wasteModeLabel() {
    return state.wasteMode === 'pro' ? 'professionele legger' : 'zelf leggen';
  }

  function nlNum(n, digits) {
    var d = digits == null ? 1 : digits;
    return Number(n).toFixed(d).replace('.', ',');
  }

  function packWord(n) {
    return Math.abs(Number(n) - 1) < 0.001 ? 'pak' : 'pakken';
  }

  function requiredArea(product) {
    var area = Number(state.areaM2) || 0;
    if (area <= 0) return 0;
    return area * (1 + activeWastePct(product) / 100);
  }

  function calcTotals(product) {
    var req = requiredArea(product);
    var m2Cents = roundPerM2Cents((product && product.price) || 0);
    var cmpM2 = productCompareAtM2Cents(product);
    if (req <= 0 || !m2Cents) {
      return {
        requiredArea: req,
        estimatedCents: 0,
        packCount: null,
        orderedArea: null,
        totalCents: 0,
        compareAtTotalCents: 0,
        savingsCents: 0,
        hasPack: false,
      };
    }
    var packArea = product && product.packAreaM2 ? Number(product.packAreaM2) : 0;
    var packPrice = product && product.packPrice ? Number(product.packPrice) : 0;
    var base;
    if (packArea > 0 && packPrice > 0) {
      var packCount = Math.ceil(req / packArea);
      var orderedArea = packCount * packArea;
      base = {
        requiredArea: req,
        estimatedCents: Math.round(m2Cents * req),
        packCount: packCount,
        orderedArea: orderedArea,
        totalCents: packCount * packPrice,
        hasPack: true,
      };
    } else {
      var est = Math.round(m2Cents * req);
      base = {
        requiredArea: req,
        estimatedCents: est,
        packCount: null,
        orderedArea: null,
        totalCents: est,
        hasPack: false,
      };
    }
    var areaForCmp = base.hasPack ? base.orderedArea : base.requiredArea;
    var compareAtTotalCents = cmpM2 > 0 ? Math.round(cmpM2 * areaForCmp) : 0;
    var savingsCents =
      compareAtTotalCents > base.totalCents ? compareAtTotalCents - base.totalCents : 0;
    base.compareAtTotalCents = compareAtTotalCents;
    base.savingsCents = savingsCents;
    return base;
  }

  function buildFloorPriceHtml(totals) {
    var priceCents = totals.hasPack ? totals.totalCents : totals.estimatedCents;
    var html =
      '<div class="uf-orient__stat uf-orient__stat--total">' +
      '<span class="uf-orient__stat-label">Totaal</span>' +
      '<strong class="uf-orient__stat-value">' +
      escapeHtml(formatMoney(priceCents)) +
      '</strong>';
    if (totals.savingsCents > 0) {
      html +=
        '<span class="uf-orient__stat-save">Je bespaart ' +
        escapeHtml(formatMoney(totals.savingsCents)) +
        '</span>';
    }
    html += '</div>';
    return html;
  }

  function buildM2PriceHtml(product, opts) {
    opts = opts || {};
    var m2 = roundPerM2Cents((product && product.price) || 0);
    var cmp = productCompareAtM2Cents(product);
    var html = '<span class="uf-orient__price-stack">';
    if (cmp > 0) {
      html +=
        '<s class="uf-orient__price-compare">' +
        escapeHtml(formatMoney(cmp)) +
        '</s>';
    }
    html +=
      '<span class="uf-orient__price-now">' +
      escapeHtml(formatMoney(m2)) +
      '</span>' +
      '<span class="uf-orient__price-unit">/ m²</span>';
    html += '</span>';
    if (opts.withSave && cmp > 0) {
      html +=
        '<span class="uf-orient__price-save">Je bespaart ' +
        escapeHtml(formatMoney(cmp - m2)) +
        '</span>';
    }
    return html;
  }

  function buildPdpPriceRow(product, shopifyProduct) {
    var m2 = roundPerM2Cents((product && product.price) || 0);
    var cmp = headerCompareM2Cents(product, shopifyProduct);
    var html =
      '<div class="uf-lf-product__price-row">' +
      '<span class="uf-lf-product__price">' +
      escapeHtml(formatMoney(m2)) +
      '</span>' +
      '<span class="uf-lf-product__price-unit">per m²</span>';
    if (cmp > 0) {
      html +=
        '<s class="uf-lf-product__compare">' +
        escapeHtml(formatMoney(cmp)) +
        '</s>';
    }
    html += '</div>';
    return html;
  }

  function readLocalJson(key, fallback) {
    try {
      var raw = localStorage.getItem(key);
      if (!raw) return fallback;
      var parsed = JSON.parse(raw);
      return parsed == null ? fallback : parsed;
    } catch (e) {
      return fallback;
    }
  }

  function writeLocalJson(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
      /* ignore */
    }
  }

  function persistAreaM2() {
    var pct = wastePctFor(state.patternHint);
    if (window.UfRoomState && typeof window.UfRoomState.persist === 'function') {
      window.UfRoomState.persist({
        areaM2: state.areaM2 > 0 ? state.areaM2 : null,
        clearArea: !(state.areaM2 > 0),
        wasteMode: state.wasteMode === 'pro' || state.wasteMode === 'diy' ? state.wasteMode : 'diy',
        wastePct: pct
      });
      return;
    }
    try {
      if (state.areaM2 > 0) {
        localStorage.setItem(
          LS_AREA_M2,
          String(Math.round(state.areaM2 * 100) / 100)
        );
      } else {
        localStorage.removeItem(LS_AREA_M2);
      }
      if (state.wasteMode === 'pro' || state.wasteMode === 'diy') {
        localStorage.setItem(LS_WASTE_MODE, state.wasteMode);
      }
      if (isFinite(pct)) {
        localStorage.setItem(LS_WASTE_PCT, String(pct));
      }
    } catch (e) {
      /* ignore */
    }
  }

  function loadStoredAreaM2() {
    if (window.UfRoomState && typeof window.UfRoomState.load === 'function') {
      var stored = window.UfRoomState.load();
      if (stored.areaM2 > 0) {
        state.areaM2 = stored.areaM2;
        state.roomSetupDone = true;
      }
      if (!wasteFromUrl && (stored.wasteMode === 'pro' || stored.wasteMode === 'diy')) {
        state.wasteMode = stored.wasteMode;
      }
      return;
    }
    try {
      var m2 = parseDecimal(localStorage.getItem(LS_AREA_M2));
      if (isFinite(m2) && m2 > 0) {
        state.areaM2 = Math.round(m2 * 100) / 100;
        state.roomSetupDone = true;
      }
      if (!wasteFromUrl) {
        var mode = localStorage.getItem(LS_WASTE_MODE);
        if (mode === 'pro' || mode === 'diy') state.wasteMode = mode;
      }
    } catch (e) {
      /* ignore */
    }
  }

  function productPageUrl(url) {
    if (!url) return '';
    try {
      var u = new URL(url, window.location.origin);
      if (state.areaM2 > 0) {
        u.searchParams.set('m2', String(Math.round(state.areaM2 * 100) / 100));
      }
      if (state.wasteMode === 'pro' || state.wasteMode === 'diy') {
        u.searchParams.set('waste', state.wasteMode);
      }
      return u.pathname + u.search + u.hash;
    } catch (e) {
      return url;
    }
  }

  function syncPdpLinkHrefs() {
    var links = document.querySelectorAll(
      'a.uf-orient__pdp-link, a.uf-orient__pack-help-link'
    );
    var i;
    for (i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href');
      if (!href) continue;
      links[i].setAttribute('href', productPageUrl(href));
    }
  }

  function loadFavorites() {
    var ids = readLocalJson(LS_WISHLIST, []);
    if (!Array.isArray(ids)) ids = [];
    state.favoriteProductIds = ids
      .map(function (id) {
        return Number(id);
      })
      .filter(function (id) {
        return isFinite(id) && id > 0;
      });
  }

  function saveFavorites() {
    writeLocalJson(LS_WISHLIST, state.favoriteProductIds);
    var meta = readLocalJson(LS_WISHLIST_META, {}) || {};
    state.favoriteProductIds.forEach(function (id) {
      var p = catalogById[id];
      if (p && p.handle) meta[String(id)] = p.handle;
    });
    writeLocalJson(LS_WISHLIST_META, meta);
    try {
      window.dispatchEvent(new CustomEvent('uf:wishlist-changed'));
    } catch (e) {
      /* ignore */
    }
  }

  function loadCompare() {
    var ids = readLocalJson(LS_COMPARE, []);
    if (!Array.isArray(ids)) ids = [];
    state.comparisonProductIds = ids
      .map(function (id) {
        return Number(id);
      })
      .filter(function (id) {
        return isFinite(id) && id > 0;
      })
      .slice(0, COMPARE_LIMIT);
  }

  function saveCompare() {
    writeLocalJson(LS_COMPARE, state.comparisonProductIds);
  }

  function isFavorite(id) {
    return state.favoriteProductIds.indexOf(Number(id)) !== -1;
  }

  function isCompare(id) {
    return state.comparisonProductIds.indexOf(Number(id)) !== -1;
  }

  function toggleFavorite(id, product) {
    id = Number(id);
    product = product || catalogById[id];
    var idx = state.favoriteProductIds.indexOf(id);
    if (idx === -1) {
      state.favoriteProductIds.push(id);
      if (product && product.handle) {
        var meta = readLocalJson(LS_WISHLIST_META, {}) || {};
        meta[String(id)] = product.handle;
        writeLocalJson(LS_WISHLIST_META, meta);
      }
    } else {
      state.favoriteProductIds.splice(idx, 1);
      var cidx = state.comparisonProductIds.indexOf(id);
      if (cidx !== -1) {
        state.comparisonProductIds.splice(cidx, 1);
        saveCompare();
      }
    }
    saveFavorites();
    renderWishlistBar();
    updateFavoriteUi();
    trackOrient(idx === -1 ? 'orient_wishlist_add' : 'orient_wishlist_remove', {
      step: idx === -1 ? 'Favoriet' : 'Favoriet weg',
      choice: (product && product.title) || String(id),
      handle: (product && product.handle) || '',
      productTitle: (product && product.title) || '',
    });
  }

  function toggleCompare(id) {
    id = Number(id);
    var idx = state.comparisonProductIds.indexOf(id);
    if (idx === -1) {
      if (state.comparisonProductIds.length >= COMPARE_LIMIT) return false;
      state.comparisonProductIds.push(id);
    } else {
      state.comparisonProductIds.splice(idx, 1);
    }
    saveCompare();
    renderWishlistBar();
    updateFavoriteUi();
    var compared = catalogById[id];
    trackOrient(idx === -1 ? 'orient_compare_add' : 'orient_compare_remove', {
      step: idx === -1 ? 'Vergelijken' : 'Vergelijken weg',
      choice: (compared && compared.title) || String(id),
      handle: (compared && compared.handle) || '',
      productTitle: (compared && compared.title) || '',
    });
    return true;
  }

  function isOfferteSelected(id) {
    return isFavorite(id) && isCompare(id);
  }

  function likeAndSelectForOfferte(id, product) {
    id = Number(id);
    product = product || catalogById[id];
    if (!isFavorite(id)) {
      toggleFavorite(id, product);
    }
    if (isCompare(id)) return true;
    if (!toggleCompare(id)) {
      flashCompareLimit();
      return false;
    }
    trackOrient('orient_offerte_select', {
      step: 'Offerte selectie',
      choice: (product && product.title) || String(id),
      handle: (product && product.handle) || '',
      productTitle: (product && product.title) || '',
    });
    return true;
  }

  function activeFilterCount() {
    var n = 0;
    var covered = {};
    liveAdvisorBundles().forEach(function (b) {
      n += 1;
      if (!covered[b.group]) covered[b.group] = {};
      b.values.forEach(function (v) {
        covered[b.group][v] = true;
      });
    });
    Object.keys(state.filters).forEach(function (g) {
      (state.filters[g] || []).forEach(function (val) {
        if (covered[g] && covered[g][val]) return;
        n += 1;
      });
    });
    return n;
  }

  function collectOptions(products) {
    var buckets = {};
    FILTER_GROUPS.forEach(function (g) {
      buckets[g] = {};
    });
    var thumbs = {};
    products.forEach(function (p) {
      FILTER_GROUPS.forEach(function (g) {
        keysForGroup(g, p).forEach(function (k) {
          buckets[g][k] = true;
          if (g === 'kleur' && !thumbs[k] && (p.thumb_144 || p.main_600)) {
            thumbs[k] = p.thumb_144 || p.main_600;
          }
        });
      });
    });
    kleurThumbByKey = thumbs;
    function sorted(obj) {
      return Object.keys(obj).sort(function (a, b) {
        var na = parseFloat(a);
        var nb = parseFloat(b);
        if (isFinite(na) && isFinite(nb) && String(na) === a && String(nb) === b) {
          return na - nb;
        }
        return a.localeCompare(b, 'nl', { sensitivity: 'base' });
      });
    }
    var out = {};
    FILTER_GROUPS.forEach(function (g) {
      if (g === 'soort') {
        out[g] = LAYOUT_OPTIONS.map(function (o) {
          return o.key;
        }).filter(function (k) {
          return !!buckets.soort[k];
        });
        if (!out[g].length) {
          out[g] = LAYOUT_OPTIONS.map(function (o) {
            return o.key;
          });
        }
      } else {
        out[g] = sorted(buckets[g]);
      }
    });
    return out;
  }

  function renderFilterList(group, keys) {
    var ul = els.filterLists[group];
    if (!ul) return;
    ul.innerHTML = '';
    var isKleur = group === 'kleur';
    keys.forEach(function (key) {
      var li = document.createElement('li');
      var id = 'uf-or-' + group + '-' + key.replace(/[^a-z0-9]+/gi, '-');
      var label = document.createElement('label');
      label.className =
        'uf-orient__filter-item' + (isKleur ? ' uf-orient__filter-item--kleur' : '');
      label.setAttribute('for', id);
      var inp = document.createElement('input');
      inp.type = 'checkbox';
      inp.id = id;
      inp.value = key;
      inp.setAttribute('data-uf-orient-filter', group);
      if (state.filters[group] && state.filters[group].indexOf(key) !== -1) {
        inp.checked = true;
      }
      inp.addEventListener('change', onFilterChange);
      label.appendChild(inp);

      if (isKleur) {
        var thumb = document.createElement('span');
        thumb.className = 'uf-orient__kleur-thumb';
        thumb.setAttribute('aria-hidden', 'true');
        var src = kleurThumbByKey[key];
        if (src) {
          var img = document.createElement('img');
          img.src = src;
          img.alt = '';
          img.width = 32;
          img.height = 32;
          img.loading = 'lazy';
          img.decoding = 'async';
          thumb.appendChild(img);
        } else {
          var ph = document.createElement('span');
          ph.className = 'uf-orient__kleur-thumb-ph';
          thumb.appendChild(ph);
        }
        label.appendChild(thumb);
      }

      var span = document.createElement('span');
      span.className = 'uf-orient__filter-label';
      span.setAttribute('data-uf-orient-filter-label', '');
      var baseLabel = filterOptionLabel(group, key);
      span.setAttribute('data-base-label', baseLabel);
      span.textContent = baseLabel;
      label.appendChild(span);
      li.appendChild(label);
      ul.appendChild(li);
    });
  }

  function syncFiltersFromDom() {
    Object.keys(els.filterLists).forEach(function (g) {
      var list = els.filterLists[g];
      if (!list) return;
      state.filters[g] = Array.prototype.slice
        .call(list.querySelectorAll('input[data-uf-orient-filter]:checked'))
        .map(function (inp) {
          return inp.value;
        });
    });
  }

  function onFilterChange() {
    syncFiltersFromDom();
    updateFilterChrome();
    updateFilterCounts();
    applyAndRender();
    writeUrl();
    trackOrient('orient_filter', { step: 'Filter', choice: filterSummary() });
  }

  function productMatches(p) {
    return productMatchesExcept(p, null);
  }

  function expandSoortSelected(selected) {
    var out = [];
    (selected || []).forEach(function (v) {
      var k = normalizeKey(v);
      if (k && out.indexOf(k) === -1) out.push(k);
      /* Weense punt → ook Hongaarse punt (catalogus mist Weense-tag) */
      if (k === 'weense punt' && out.indexOf('hongaarse punt') === -1) {
        out.push('hongaarse punt');
      }
    });
    return out;
  }

  function productMatchesExcept(p, exceptGroup) {
    for (var i = 0; i < FILTER_GROUPS.length; i++) {
      var group = FILTER_GROUPS[i];
      if (exceptGroup && group === exceptGroup) continue;
      var selected = state.filters[group] || [];
      if (!selected.length) continue;
      if (group === 'soort') selected = expandSoortSelected(selected);
      var keys = keysForGroup(group, p);
      var hit = false;
      for (var s = 0; s < selected.length; s++) {
        if (keys.indexOf(selected[s]) !== -1) {
          hit = true;
          break;
        }
      }
      if (!hit) return false;
    }
    return true;
  }

  function updateFilterCounts() {
    var total = 0;
    var optionCounts = {};
    FILTER_GROUPS.forEach(function (g) {
      optionCounts[g] = {};
    });

    catalog.forEach(function (p) {
      if (productMatches(p)) total += 1;

      FILTER_GROUPS.forEach(function (group) {
        if (!productMatchesExcept(p, group)) return;
        var keys = keysForGroup(group, p);
        for (var i = 0; i < keys.length; i++) {
          var k = keys[i];
          optionCounts[group][k] = (optionCounts[group][k] || 0) + 1;
        }
      });
    });

    FILTER_GROUPS.forEach(function (group) {
      var list = els.filterLists[group];
      if (!list) return;
      list.querySelectorAll('input[data-uf-orient-filter]').forEach(function (inp) {
        var key = inp.value;
        var count = optionCounts[group][key] || 0;
        var labelEl = inp.parentNode && inp.parentNode.querySelector('[data-uf-orient-filter-label]');
        if (!labelEl) return;
        var base = labelEl.getAttribute('data-base-label') || filterOptionLabel(group, key);
        labelEl.setAttribute('data-base-label', base);
        labelEl.textContent = base + ' (' + count + ')';
        var li = inp.closest('li');
        if (li && group !== 'pvctype' && group !== 'merk' && group !== 'soort') {
          li.hidden = count === 0 && !inp.checked;
        }
      });
    });

    var countText = '(' + total + ')';
    if (els.filterResultCount) els.filterResultCount.textContent = countText;
    if (els.filterApplyCount) els.filterApplyCount.textContent = countText;
    updateFilterTabCounts();
  }

  function paneForGroup(group) {
    return FILTER_GROUP_PANE[group] || 'meer';
  }

  function updateFilterTabCounts() {
    FILTER_PANES.forEach(function (pane) {
      var n = 0;
      FILTER_GROUPS.forEach(function (g) {
        if (paneForGroup(g) === pane) n += (state.filters[g] || []).length;
      });
      var badge = root.querySelector('[data-uf-orient-filter-tab-count="' + pane + '"]');
      if (!badge) return;
      if (n > 0) {
        badge.hidden = false;
        badge.textContent = String(n);
      } else {
        badge.hidden = true;
        badge.textContent = '';
      }
    });
  }

  function applyFilterGroupVisibility() {
    var pane = isOrientPanelLayout() ? state.filterPane || 'type' : null;
    FILTER_GROUPS.forEach(function (g) {
      var el = els.filterGroups[g];
      if (!el) return;
      var empty = el.getAttribute('data-uf-filter-empty') === '1';
      var alwaysShow = !!FILTER_ALWAYS_SHOW[g];
      if (!pane) {
        el.hidden = !alwaysShow && empty;
        return;
      }
      el.hidden = paneForGroup(g) !== pane || (!alwaysShow && empty);
    });
  }

  function setFilterPane(name) {
    var pane = FILTER_PANES.indexOf(name) >= 0 ? name : 'type';
    state.filterPane = pane;
    if (els.filterPanel) els.filterPanel.setAttribute('data-uf-orient-filter-pane', pane);
    root.querySelectorAll('[data-uf-orient-filter-tab]').forEach(function (tab) {
      var on = tab.getAttribute('data-uf-orient-filter-tab') === pane;
      tab.classList.toggle('is-active', on);
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    applyFilterGroupVisibility();
  }

  function popularityOf(product) {
    var handle = product && product.handle ? String(product.handle) : '';
    if (!handle) return 0;
    var n = Number(popularityScores[handle]);
    return isFinite(n) ? n : 0;
  }

  function advisorSoftScore(p) {
    var score = 0;
    advisorBundles.forEach(function (b) {
      if (!b.soft || !(b.values || []).length) return;
      var keys = keysForGroup(b.group, p);
      for (var i = 0; i < b.values.length; i++) {
        if (keys.indexOf(b.values[i]) !== -1) {
          score += 1;
          break;
        }
      }
    });
    return score;
  }

  function sortProducts(list) {
    var arr = list.slice();
    if (state.sortBy === 'price-asc') {
      arr.sort(function (a, b) {
        return (a.price || 0) - (b.price || 0);
      });
    } else if (state.sortBy === 'price-desc') {
      arr.sort(function (a, b) {
        return (b.price || 0) - (a.price || 0);
      });
    } else if (state.sortBy === 'title-asc') {
      arr.sort(function (a, b) {
        return String(a.title || '').localeCompare(String(b.title || ''), 'nl', {
          sensitivity: 'base',
        });
      });
    } else {
      // Aanbevolen: soft advisor-eisen eerst, daarna populariteit.
      // Stabiele tie-break op catalogusvolgorde.
      var indexById = {};
      for (var i = 0; i < catalog.length; i++) {
        indexById[Number(catalog[i].id)] = i;
      }
      arr.sort(function (a, b) {
        var softDiff = advisorSoftScore(b) - advisorSoftScore(a);
        if (softDiff) return softDiff;
        var scoreDiff = popularityOf(b) - popularityOf(a);
        if (scoreDiff) return scoreDiff;
        return (indexById[Number(a.id)] || 0) - (indexById[Number(b.id)] || 0);
      });
    }
    return arr;
  }

  function loadPopularityScores() {
    var endpoint = '';
    try {
      endpoint =
        (window.UF_ANALYTICS && window.UF_ANALYTICS.endpoint) ||
        'https://tracker.urbanfloors.nl';
    } catch (e) {
      endpoint = 'https://tracker.urbanfloors.nl';
    }
    endpoint = String(endpoint).replace(/\/$/, '') + '/api/analytics/popularity?days=28';
    return ufFetch(endpoint, {
      credentials: 'omit',
      headers: { Accept: 'application/json' },
    })
      .then(function (res) {
        if (!res.ok) throw new Error('popularity ' + res.status);
        return res.json();
      })
      .then(function (data) {
        var scores =
          data && data.popularity && data.popularity.scores
            ? data.popularity.scores
            : data && data.scores
              ? data.scores
              : {};
        popularityScores = scores && typeof scores === 'object' ? scores : {};
        popularityReady = true;
        if (state.sortBy === 'featured' || !state.sortBy) {
          applyAndRender({ skipDetail: true });
        }
      })
      .catch(function () {
        popularityScores = {};
        popularityReady = true;
      });
  }

  function brandOf(p) {
    var tags = (p && p.tags) || [];
    for (var i = 0; i < tags.length; i++) {
      var tv = tagHeadVal(tags[i]);
      if (tv.head === 'merk' && tv.val) return tv.val;
    }
    return (p && p.vendor) || '';
  }

  function resolvePackAreaM2(product) {
    var n = Number(product && product.packAreaM2);
    return isFinite(n) && n > 0 ? n : 0;
  }

  /** Actiekorting geldt voor PVC-vloeren en traprenovatie (niet plinten/accessoires). */
  function productActieEligible(product) {
    var tags = (product && product.tags) || [];
    var isTrap = false;
    for (var i = 0; i < tags.length; i++) {
      var tl = String(tags[i] || '')
        .trim()
        .toLowerCase();
      if (tl === 'segment: accessoire' || tl === 'segment: plint' || tl === 'segment: plinten') {
        return false;
      }
      if (tl === 'segment: traprenovatie' || tl === 'traprenovatie') isTrap = true;
    }
    if (isTrap) return true;
    return resolvePackAreaM2(product) > 0 || collectionHandle === 'pvc' || collectionHandle.indexOf('pvc') !== -1;
  }

  function compactCardSrc(src) {
    var s = String(src || '');
    if (!s) return '';
    s = s.replace(/_(?:\d+x(?:\d+)?)(?=\.|\?|$)/, '_' + LIST_CARD_IMG + 'x');
    s = s.replace(/([?&])width=\d+/gi, '$1width=' + LIST_CARD_IMG);
    return s;
  }

  function catalogCardImages(p) {
    var alt = (p && (p.main_alt || p.title)) || '';
    var out = [];
    var seen = {};
    function add(src) {
      var url = compactCardSrc(src);
      if (!url || seen[url]) return;
      if (url.toLowerCase().indexOf('facebook-meta') !== -1) return;
      seen[url] = true;
      out.push({ src: url, alt: alt });
    }
    var raw = p && p.images_600;
    if (raw) {
      String(raw)
        .split('||')
        .forEach(function (part) {
          if (out.length >= 8) return;
          add(String(part || '').trim());
        });
    }
    if (!out.length) add((p && (p.thumb_144 || p.hover_275 || p.main_600)) || '');
    return out;
  }

  function rowHtml(p) {
    var id = Number(p.id);
    var m2Cents = roundPerM2Cents(p.price || 0);
    var totals = calcTotals(p);
    var totalCents = totals.totalCents || totals.estimatedCents || 0;
    var cmpTotal = totals.compareAtTotalCents || 0;
    var cardImages = catalogCardImages(p);
    var img = (cardImages[0] && cardImages[0].src) || '';
    var selected = String(state.selectedProductId) === String(id);
    var favOn = isFavorite(id);
    var cmpOn = isCompare(id);
    var totalPriceHtml =
      totalCents > 0
        ? (cmpTotal > totalCents
            ? '<s class="uf-orient__row-price-compare">' +
              escapeHtml(formatMoney(cmpTotal)) +
              '</s>'
            : '') +
          '<span class="uf-orient__row-price-value">' +
          escapeHtml(formatMoney(totalCents)) +
          '</span>'
        : '<span class="uf-orient__row-price-value">' +
          escapeHtml(formatMoney(m2Cents)) +
          '</span><span class="uf-orient__row-price-unit">/ m²</span>';
    return (
      '<div class="uf-orient__row' +
      (selected ? ' is-selected' : '') +
      '" role="button" tabindex="0" data-uf-orient-row data-product-id="' +
      escapeHtml(String(id)) +
      '" aria-pressed="' +
      (selected ? 'true' : 'false') +
      '">' +
      '<div class="uf-orient__row-thumb" data-uf-orient-row-carousel>' +
      '<div class="uf-orient__row-viewport" data-uf-orient-row-viewport>' +
      (img
        ? '<img src="' +
          escapeHtml(img) +
          '" alt="' +
          escapeHtml(p.main_alt || p.title || '') +
          '" data-uf-orient-row-hero loading="lazy">'
        : '') +
      '</div></div>' +
      '<div class="uf-orient__row-meta">' +
      (brandOf(p)
        ? '<p class="uf-orient__row-brand">' + escapeHtml(brandOf(p)) + '</p>'
        : '') +
      '<p class="uf-orient__row-title">' +
      escapeHtml(p.title || '') +
      '</p>' +
      '<p class="uf-orient__row-price uf-orient__row-price--total">' +
      totalPriceHtml +
      '</p>' +
      '<p class="uf-orient__row-price uf-orient__row-price--m2">' +
      '<span class="uf-orient__row-price-value">' +
      escapeHtml(formatMoney(m2Cents)) +
      '</span>' +
      '<span class="uf-orient__row-price-unit">/ m²</span></p>' +
      '</div>' +
      '<div class="uf-orient__row-actions">' +
      '<button type="button" class="uf-orient__row-icon' +
      (favOn ? ' is-on' : '') +
      '" data-uf-orient-fav="' +
      escapeHtml(String(id)) +
      '" aria-label="Favoriet" title="Favoriet">' +
      (favOn ? '♥' : '♡') +
      '</button>' +
      '<button type="button" class="uf-orient__row-icon' +
      (cmpOn ? ' is-on' : '') +
      '" data-uf-orient-cmp="' +
      escapeHtml(String(id)) +
      '" aria-label="Vergelijken" title="Vergelijken">' +
      '⇄' +
      '</button>' +
      '</div></div>'
    );
  }

  function stopListSync() {
    if (listSyncTimer) {
      window.clearInterval(listSyncTimer);
      listSyncTimer = null;
    }
  }

  function startListSync() {
    if (listSyncTimer) return;
    if (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      return;
    }
    listSyncTimer = window.setInterval(function () {
      if (typeof document !== 'undefined' && document.hidden) return;
      listControllers.forEach(function (c) {
        if (c && typeof c.next === 'function') c.next();
      });
    }, BROWSE_SLIDE_MS);
  }

  function destroyListGalleries() {
    listControllers.forEach(function (c) {
      if (c && typeof c.destroy === 'function') c.destroy();
    });
    listControllers = [];
    stopListSync();
    if (listObserver) {
      listObserver.disconnect();
      listObserver = null;
    }
  }

  function bindListCarousel(row, images) {
    var viewport = row.querySelector('[data-uf-orient-row-viewport]');
    var imgEl = row.querySelector('[data-uf-orient-row-hero]');
    if (!viewport || !imgEl || !images || images.length < 2) return null;
    var idx = 0;
    var animating = false;
    var destroyed = false;

    function setIndexImmediate(i) {
      if (!images.length || !imgEl) return;
      idx = ((i % images.length) + images.length) % images.length;
      var item = images[idx];
      if (!item) return;
      imgEl.src = item.src;
      imgEl.alt = item.alt || '';
    }

    function slideToNext() {
      if (destroyed || animating || images.length <= 1 || !imgEl || !viewport) return;
      if (
        window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ) {
        setIndexImmediate(idx + 1);
        return;
      }
      var nextIdx = (idx + 1) % images.length;
      var item = images[nextIdx];
      if (!item) return;
      animating = true;
      var incoming = imgEl.cloneNode(false);
      incoming.removeAttribute('data-uf-orient-row-hero');
      incoming.className = 'uf-orient__row-hero--incoming';
      incoming.alt = item.alt || '';
      incoming.src = item.src;
      viewport.appendChild(incoming);
      imgEl.classList.remove('is-row-slide-out');
      window.requestAnimationFrame(function () {
        if (destroyed) return;
        imgEl.classList.add('is-row-slide-out');
        incoming.classList.add('is-row-slide-in');
      });
      var done = false;
      function finishSwap() {
        if (done || destroyed) return;
        done = true;
        animating = false;
        idx = nextIdx;
        if (imgEl && imgEl.parentNode) imgEl.remove();
        incoming.classList.remove('uf-orient__row-hero--incoming', 'is-row-slide-in');
        incoming.setAttribute('data-uf-orient-row-hero', '');
        imgEl = incoming;
      }
      incoming.addEventListener('transitionend', finishSwap, { once: true });
      window.setTimeout(finishSwap, 480);
    }

    setIndexImmediate(0);
    startListSync();
    return {
      next: slideToNext,
      destroy: function () {
        destroyed = true;
      },
    };
  }

  function hydrateListRow(row) {
    if (!row || row.getAttribute('data-row-hydrated') === '1') return;
    row.setAttribute('data-row-hydrated', '1');
    var id = row.getAttribute('data-product-id');
    var p = catalogById[id] || catalogById[Number(id)];
    if (!p) return;
    var ctrl = bindListCarousel(row, catalogCardImages(p));
    if (ctrl) listControllers.push(ctrl);
  }

  function bindListGalleries() {
    destroyListGalleries();
    if (!els.list) return;
    var rows = els.list.querySelectorAll('[data-uf-orient-row]');
    if (!rows.length) return;
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(rows, hydrateListRow);
      return;
    }
    listObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          hydrateListRow(entry.target);
          if (listObserver) listObserver.unobserve(entry.target);
        });
      },
      { root: els.list, rootMargin: '120px 0px', threshold: 0.01 }
    );
    Array.prototype.forEach.call(rows, function (row) {
      listObserver.observe(row);
    });
  }

  function updateFilterChrome() {
    var n = activeFilterCount();
    if (els.filterCount) {
      if (n > 0) {
        els.filterCount.hidden = false;
        els.filterCount.textContent = String(n);
      } else {
        els.filterCount.hidden = true;
      }
    }
    if (!els.chips) return;
    var chips = [];
    var covered = {};
    liveAdvisorBundles().forEach(function (b) {
      if (!covered[b.group]) covered[b.group] = {};
      b.values.forEach(function (v) {
        covered[b.group][v] = true;
      });
      chips.push(
        '<button type="button" class="uf-orient__chip" data-uf-orient-advisor-chip="' +
          escapeHtml(b.id) +
          '">' +
          escapeHtml(b.label) +
          ' ×</button>'
      );
    });
    Object.keys(state.filters).forEach(function (g) {
      (state.filters[g] || []).forEach(function (val) {
        if (covered[g] && covered[g][val]) return;
        chips.push(
          '<button type="button" class="uf-orient__chip" data-uf-orient-chip-remove="' +
            escapeHtml(g) +
            '" data-value="' +
            escapeHtml(val) +
            '">' +
            escapeHtml(filterOptionLabel(g, val)) +
            ' ×</button>'
        );
      });
    });
    els.chips.innerHTML = chips.join('');
  }

  function filteredCatalog() {
    return sortProducts(catalog.filter(productMatches));
  }

  function ensureSelection(filtered) {
    if (!filtered.length) {
      state.selectedProductId = null;
      return;
    }
    var stillThere = filtered.some(function (p) {
      return String(p.id) === String(state.selectedProductId);
    });
    if (!stillThere) {
      state.selectedProductId = filtered[0].id;
    }
  }

  function syncSlideshowUi() {
    root.classList.toggle('is-slideshow', slideshowPlaying);
    if (!els.slideToggle) return;
    els.slideToggle.setAttribute('aria-pressed', slideshowPlaying ? 'true' : 'false');
    els.slideToggle.setAttribute(
      'aria-label',
      slideshowPlaying ? 'Pauzeer slideshow' : 'Start slideshow'
    );
    els.slideToggle.setAttribute('title', slideshowPlaying ? 'Pauze' : 'Afspelen');
    els.slideToggle.textContent = slideshowPlaying ? '❚❚' : '▶';
  }

  function clearSlideshowTimer() {
    if (slideshowTimer) {
      window.clearInterval(slideshowTimer);
      slideshowTimer = null;
    }
  }

  function scrollSelectedRowIntoView() {
    if (!els.list || !state.selectedProductId) return;
    var row = els.list.querySelector(
      '[data-uf-orient-row][data-product-id="' + String(state.selectedProductId) + '"]'
    );
    if (row && typeof row.scrollIntoView === 'function') {
      row.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  }

  function slideBy(delta, opts) {
    opts = opts || {};
    var filtered = filteredCatalog();
    if (!filtered.length) return;
    var idx = filtered.findIndex(function (p) {
      return String(p.id) === String(state.selectedProductId);
    });
    if (idx < 0) idx = 0;
    var next = filtered[(idx + delta + filtered.length) % filtered.length];
    if (!next) return;
    showProduct(next.id, {
      keepListScroll: true,
      scrollDetailTop: true,
      fromTimer: !!opts.fromTimer,
      source: 'slideshow',
    });
    scrollSelectedRowIntoView();
    if (opts.fromTimer && slideshowPlaying) {
      /* interval already running */
    } else if (slideshowPlaying) {
      restartSlideshowTimer();
    }
  }

  function restartSlideshowTimer() {
    clearSlideshowTimer();
    if (!slideshowPlaying) return;
    slideshowTimer = window.setInterval(function () {
      slideBy(1, { fromTimer: true });
    }, SLIDESHOW_MS);
  }

  function stopSlideshow() {
    slideshowPlaying = false;
    clearSlideshowTimer();
    syncSlideshowUi();
  }

  function startSlideshow() {
    var filtered = filteredCatalog();
    if (!filtered.length) return;
    slideshowPlaying = true;
    syncSlideshowUi();
    slideBy(1, { fromTimer: true }); /* direct naar volgende; timer start vanaf nu 4s */
    trackOrient('orient_slideshow', { step: 'Slideshow', choice: 'play' });
  }

  function toggleSlideshow() {
    if (slideshowPlaying) {
      stopSlideshow();
      trackOrient('orient_slideshow', { step: 'Slideshow', choice: 'pause' });
      return;
    }
    startSlideshow();
  }

  function applyAndRender(opts) {
    opts = opts || {};
    var filtered = filteredCatalog();
    ensureSelection(filtered);

    if (els.count) {
      els.count.textContent =
        filtered.length === 1 ? '1 resultaat' : filtered.length + ' resultaten';
    }
    if (els.list) {
      els.list.innerHTML = filtered.map(rowHtml).join('');
      bindListGalleries();
      scheduleScrollHint();
    }
    if (els.empty) {
      els.empty.hidden = filtered.length > 0 || !catalog.length;
    }
    updateFilterChrome();
    updateFilterCounts();
    renderWishlistBar();

    if (!filtered.length && slideshowPlaying) {
      stopSlideshow();
    }

    if (opts.skipDetail) {
      if (slideshowPlaying) scrollSelectedRowIntoView();
      if (els.browseDialog && !els.browseDialog.hidden) renderBrowseBody();
      return;
    }
    if (state.selectedProductId) {
      showProduct(state.selectedProductId, { keepListScroll: true, scrollDetailTop: !!opts.scrollDetailTop });
      if (slideshowPlaying) scrollSelectedRowIntoView();
    } else {
      showNoSelection();
    }
    if (els.browseDialog && !els.browseDialog.hidden) renderBrowseBody();
  }

  function syncScrollHint() {
    var hint = els.scrollHint;
    var list = els.list;
    if (!hint || !list) return;
    var aside = list.parentElement;
    var foot = aside && aside.querySelector('.uf-orient__candidates-foot');
    var footH = 0;
    if (foot) {
      var footStyle = window.getComputedStyle(foot);
      if (footStyle.display !== 'none') footH = foot.offsetHeight;
    }
    if (aside) aside.style.setProperty('--uf-or-hint-bottom', footH + 'px');
    var desktopLandscape = window.matchMedia('(orientation: landscape) and (min-width: 1280px)').matches;
    var overflow = list.scrollHeight > list.clientHeight + 8;
    var scrolled = list.scrollTop > 12;
    hint.hidden = desktopLandscape || !overflow || scrolled;
  }

  function scheduleScrollHint() {
    if (typeof window.requestAnimationFrame === 'function') {
      window.requestAnimationFrame(syncScrollHint);
    } else {
      syncScrollHint();
    }
  }

  function showNoSelection() {
    parkActieBar();
    destroyGallery();
    lastDetailImages = [];
    lastDetailProduct = null;
    lastDetailShopify = null;
    if (els.detailEmpty) {
      els.detailEmpty.hidden = false;
      els.detailEmpty.setAttribute('aria-hidden', 'false');
    }
    if (els.detailBody) {
      els.detailBody.hidden = true;
      els.detailBody.innerHTML = '';
    }
    if (els.spec) {
      els.spec.hidden = false;
      els.spec.innerHTML =
        '<p class="uf-orient__spec-empty">Selecteer een vloer uit de kandidatenlijst.</p>';
    }
    if (els.detailSkeleton) els.detailSkeleton.hidden = true;
  }

  function setDetailLoading(on) {
    if (els.detailEmpty) {
      els.detailEmpty.hidden = true;
      els.detailEmpty.setAttribute('aria-hidden', 'true');
    }
    if (els.detailSkeleton) els.detailSkeleton.hidden = !on;
    if (els.detailBody) els.detailBody.hidden = on;
  }

  function fetchProductJs(handle) {
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return fetch('/products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin',
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Product laden mislukt');
        return res.json();
      })
      .then(function (data) {
        productCache[handle] = data;
        return data;
      });
  }

  function propFromTags(tags, heads) {
    for (var i = 0; i < (tags || []).length; i++) {
      var tv = tagHeadVal(tags[i]);
      for (var h = 0; h < heads.length; h++) {
        if (tv.head === heads[h] && tv.val) return tv.val;
      }
    }
    return '';
  }

  function productGroupKey(tags) {
    for (var i = 0; i < (tags || []).length; i++) {
      var raw = String(tags[i] || '').trim();
      var low = raw.toLowerCase();
      if (low.indexOf('productgroep') === -1 || raw.indexOf(':') === -1) continue;
      var tv = tagHeadVal(raw);
      if (tv.head.indexOf('productgroep') !== -1 && tv.val) return tv.val.trim();
    }
    return '';
  }

  function layoutFingerprintForSwatches(tags, title) {
    if (
      window.UF_LF_COLOR_SWATCHES &&
      typeof window.UF_LF_COLOR_SWATCHES.layoutFingerprint === 'function'
    ) {
      return window.UF_LF_COLOR_SWATCHES.layoutFingerprint(tags, title, '');
    }
    return productSoortKeys(tags).slice().sort().join('|');
  }

  function pvctypeFingerprintForSwatches(tags) {
    if (
      window.UF_LF_COLOR_SWATCHES &&
      typeof window.UF_LF_COLOR_SWATCHES.pvctypeFingerprint === 'function'
    ) {
      return window.UF_LF_COLOR_SWATCHES.pvctypeFingerprint(tags);
    }
    return productPvctypeKeys(tags).slice().sort().join('|');
  }

  function collectGalleryImages(sp, catalogProduct) {
    var title = (catalogProduct && catalogProduct.title) || '';
    var out = [];
    var media = (sp && sp.media) || [];
    if (media.length) {
      media.forEach(function (m) {
        if (!m) return;
        if (m.media_type && m.media_type !== 'image') return;
        var alt = m.alt || '';
        if (String(alt).indexOf('facebook-meta') !== -1) return;
        var src =
          m.src ||
          (m.preview_image && m.preview_image.src) ||
          '';
        if (!src) return;
        out.push({ src: src, alt: alt || title });
      });
    }
    if (!out.length && sp && sp.images && sp.images.length) {
      sp.images.forEach(function (img) {
        var src = typeof img === 'string' ? img : (img && img.src) || '';
        if (!src) return;
        out.push({ src: src, alt: title });
      });
    }
    if (!out.length && catalogProduct && catalogProduct.main_600) {
      out.push({ src: catalogProduct.main_600, alt: title });
    }
    return out;
  }

  function productHasColorGroup(product) {
    return !!(enableGroupColors && product && productGroupKey(product.tags));
  }

  function buildGalleryHtml(images, title, showActie, opts) {
    opts = opts || {};
    if (!images.length) {
      return '<div class="uf-lf-gallery" data-uf-orient-gallery></div>';
    }
    var actieBadge = showActie
      ? '<span class="uf-orient__photo-actie-check" title="Komt in aanmerking voor de lopende actie" aria-label="Komt in aanmerking voor de lopende actie">✓</span>'
      : '';
    var thumbs = images
      .map(function (item, i) {
        return (
          '<button type="button" class="uf-lf-gallery__thumb' +
          (i === 0 ? ' is-active' : '') +
          '" data-index="' +
          i +
          '" aria-label="Afbeelding ' +
          (i + 1) +
          '" aria-selected="' +
          (i === 0 ? 'true' : 'false') +
          '"><img src="' +
          escapeHtml(item.src) +
          '" alt="' +
          escapeHtml(item.alt || title || '') +
          '" loading="' +
          (i === 0 ? 'eager' : 'lazy') +
          '" decoding="async"></button>'
        );
      })
      .join('');
    var dots =
      images.length > 1
        ? '<div class="uf-lf-gallery__dots" role="tablist" aria-label="Afbeeldingen">' +
          images
            .map(function (_item, i) {
              return (
                '<button type="button" class="uf-lf-gallery__dot' +
                (i === 0 ? ' is-active' : '') +
                '" data-index="' +
                i +
                '" role="tab" aria-selected="' +
                (i === 0 ? 'true' : 'false') +
                '" aria-label="Afbeelding ' +
                (i + 1) +
                '"></button>'
              );
            })
            .join('') +
          '</div>'
        : '';
    var nav =
      images.length > 1
        ? '<button type="button" class="uf-lf-gallery__nav uf-lf-gallery__nav--prev" data-uf-orient-gallery-prev aria-label="Vorige afbeelding">' +
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 18l-6-6 6-6"/></svg>' +
          '</button>' +
          '<button type="button" class="uf-lf-gallery__nav uf-lf-gallery__nav--next" data-uf-orient-gallery-next aria-label="Volgende afbeelding">' +
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 18l6-6-6-6"/></svg>' +
          '</button>'
        : '';
    var colorCta = opts.showColorCta
      ? '<button type="button" class="uf-lf-gallery__cta uf-lf-gallery__cta--accent" data-uf-lf-color-preview-open="color">Kies kleur</button>'
      : '';
    var ctas =
      '<div class="uf-lf-gallery__ctas" data-uf-lf-gallery-ctas>' +
      '<button type="button" class="uf-lf-gallery__cta" data-uf-lf-color-preview-open="zoom">Vergroot</button>' +
      colorCta +
      '</div>';
    return (
      '<div class="uf-lf-gallery" data-uf-orient-gallery>' +
      '<div class="uf-lf-gallery__thumbs" role="tablist" aria-label="Productafbeeldingen">' +
      thumbs +
      '</div>' +
      '<div class="uf-lf-gallery__main-col">' +
      '<div class="uf-lf-gallery__viewport" data-uf-orient-gallery-viewport tabindex="0" aria-label="Productgalerij">' +
      nav +
      '<img class="uf-lf-gallery__hero" data-uf-orient-gallery-hero src="' +
      escapeHtml(images[0].src) +
      '" alt="' +
      escapeHtml(images[0].alt || title || '') +
      '" loading="eager" decoding="async">' +
      actieBadge +
      '</div>' +
      dots +
      ctas +
      '</div></div>'
    );
  }

  function parkActieBar() {
    var el = els.actieBar;
    var home = els.actieHome;
    if (!el || !home) return;
    if (el.parentNode !== home) home.appendChild(el);
  }

  function syncActieBarPlacement() {
    var el = els.actieBar;
    var home = els.actieHome;
    if (!el || !home) return;
    /* Actieteller blijft altijd in de orient-header (niet meer in het detailpaneel). */
    if (el.parentNode !== home) home.appendChild(el);
  }

  function syncColorPreviewOverlay(product) {
    var overlay = root.querySelector('[data-uf-lf-color-preview]');
    if (!overlay || !product) return;
    var pid =
      (lastDetailShopify && lastDetailShopify.id) || product.id || '';
    var url = product.url || (product.handle ? '/products/' + product.handle : '');
    overlay.setAttribute('data-uf-current-id', String(pid));
    overlay.setAttribute('data-uf-current-url', url);
    if (
      window.UF_LF_COLOR_PREVIEW &&
      overlay._ufLfColorPreview &&
      typeof overlay._ufLfColorPreview.syncColorCta === 'function'
    ) {
      overlay._ufLfColorPreview.syncColorCta();
    }
  }

  function buildColorPreviewStatsHtml(product, totals, pattern, waste) {
    totals = totals || calcTotals(product);
    pattern = pattern || inferPatternFromProduct(product);
    waste = waste != null ? waste : wastePctFor(pattern);
    if (!(Number(state.areaM2) > 0)) {
      return (
        '<ul class="uf-lf-spec-bullets uf-lf-spec-bullets--compact uf-lf-color-preview__fact-list uf-lf-color-preview__orient-stats" role="list">' +
        '<li class="uf-lf-spec-bullets__item"><span class="uf-lf-spec-bullets__label">Vul je m² in voor de berekening</span></li>' +
        '</ul>'
      );
    }
    var parts = packOverviewParts(product, totals, waste);
    var areaInput = nlNum(state.areaM2, 1).replace(/,0$/, '');
    var rows = [
      { label: 'Benodigde m²', value: areaInput + ' m²' },
      {
        label: 'Snijverlies',
        value:
          parts.packArea > 0
            ? nlNum(parts.wasteShown, 1) + ' · ' + wasteTitle(waste)
            : '—',
      },
    ];
    if (totals.hasPack) {
      var roundShown = roundPacks(parts.roundShown);
      rows.push({
        label: 'Afronding',
        value: (roundShown > 0 ? '+' : '') + nlNum(roundShown, 1),
      });
      rows.push({
        label: 'Totale pakken',
        value: String(totals.packCount || '—'),
      });
    }
    rows.push({
      label: 'Totale m²',
      value: nlNum(parts.totalM2, 1).replace(/,0$/, '') + ' m²',
    });
    var html =
      '<ul class="uf-lf-spec-bullets uf-lf-spec-bullets--compact uf-lf-color-preview__fact-list uf-lf-color-preview__orient-stats" role="list">';
    rows.forEach(function (row) {
      html +=
        '<li class="uf-lf-spec-bullets__item">' +
        '<span class="uf-lf-spec-bullets__label">' +
        escapeHtml(row.label) +
        ': ' +
        escapeHtml(row.value) +
        '</span></li>';
    });
    html += '</ul>';
    return html;
  }

  function buildColorPreviewPriceHtml(product, totals) {
    totals = totals || calcTotals(product);
    if (!(Number(state.areaM2) > 0)) return '';
    var parts = packOverviewParts(
      product,
      totals,
      wastePctFor(inferPatternFromProduct(product))
    );
    var cartPct = productActieEligible(product) ? activeCartDiscountPct() : 0;
    var html =
      '<span class="uf-lf-color-preview__orient-price-label">Totale prijs</span>';
    if (totals.savingsCents > 0) {
      html +=
        '<span class="uf-lf-color-preview__orient-save">Bespaar ' +
        escapeHtml(formatMoney(totals.savingsCents)) +
        '</span>';
    }
    if (cartPct > 0) {
      html +=
        '<span class="uf-lf-color-preview__orient-pct">' +
        escapeHtml(String(cartPct).replace('.', ',') + '%') +
        '</span>';
    }
    html +=
      '<span class="uf-lf-product__price uf-lf-color-preview__orient-total">Totaal ' +
      escapeHtml(formatMoney(parts.priceCents)) +
      '</span>';
    return html;
  }

  function buildColorPreviewCtaHtml(product) {
    var offerteOn = isOfferteSelected(product.id);
    return (
      '<div class="uf-lf-color-preview__orient-ctas">' +
      '<button type="button" class="uf-lf-color-preview__orient-cta uf-lf-color-preview__orient-cta--cart" data-uf-lf-color-preview-orient-atc>' +
      'Toevoegen aan winkelwagen' +
      '</button>' +
      '<button type="button" class="uf-lf-color-preview__orient-cta uf-lf-color-preview__orient-cta--offerte' +
      (offerteOn ? ' is-on' : '') +
      '" data-uf-lf-color-preview-orient-offerte aria-pressed="' +
      (offerteOn ? 'true' : 'false') +
      '">Offerte selectie</button></div>'
    );
  }

  function offerteIconHtml() {
    return (
      '<span class="uf-orient__btn-icon" aria-hidden="true">' +
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" focusable="false">' +
      '<path d="M12 4v11"/><path d="m7.5 11 4.5 4.5 4.5-4.5"/><path d="M6 20h12"/></svg></span>'
    );
  }

  function getColorPreviewCardInfo() {
    var product = lastDetailProduct || catalogById[Number(state.selectedProductId)];
    if (!product) {
      return { title: '', priceHtml: '', statsHtml: '', ctaHtml: '' };
    }
    var totals = calcTotals(product);
    var pattern = inferPatternFromProduct(product);
    var waste = wastePctFor(pattern);
    return {
      title: product.title || '',
      priceHtml: buildColorPreviewPriceHtml(product, totals),
      statsHtml: buildColorPreviewStatsHtml(product, totals, pattern, waste),
      ctaHtml: buildColorPreviewCtaHtml(product),
    };
  }

  window.UF_ORIENT_COLOR_PREVIEW = {
    getCardInfo: getColorPreviewCardInfo,
    navigateToSibling: function (detail) {
      detail = detail || {};
      var id = detail.productId;
      var hit =
        findCatalogByShopifyId(id) ||
        findCatalogByHandle(handleFromProductUrl(detail.url || ''));
      if (!hit) return;
      showProduct(hit.id, { scrollDetailTop: true, source: 'swatch' });
      if (isOrientPanelLayout() && !root.classList.contains('is-product-sheet-open')) {
        openProductSheet();
      }
    },
  };

  function buildColorSwatchesHtml(product, shopifyProduct) {
    if (!enableGroupColors) return '';
    var groupKey = productGroupKey(product.tags);
    if (!groupKey) return '';
    var soortFp = layoutFingerprintForSwatches(
      product.tags,
      product.title || (shopifyProduct && shopifyProduct.title) || ''
    );
    var pvctypeFp = pvctypeFingerprintForSwatches(product.tags);
    var pid =
      (shopifyProduct && shopifyProduct.id) || product.id || '';
    return (
      '<div class="uf-lf-buy-colors uf-lf-product__options uf-lf-product__options--swatches-only">' +
      '<div class="uf-lf-option uf-lf-option--color-swatches">' +
      '<span class="uf-lf-option__label">' +
      escapeHtml(colorOptionLabel) +
      '</span>' +
      '<div class="uf-lf-color-swatches uf-lf-color-swatches--loading" role="list" data-uf-lf-color-swatches data-uf-orient-color-swatches data-uf-group-key="' +
      escapeHtml(groupKey) +
      '" data-uf-soort-fp="' +
      escapeHtml(soortFp) +
      '" data-uf-match-soort="' +
      (matchSoortForColors ? 'true' : 'false') +
      '" data-uf-pvctype-fp="' +
      escapeHtml(pvctypeFp) +
      '" data-uf-current-id="' +
      escapeHtml(String(pid)) +
      '"></div></div></div>'
    );
  }

  function templateHtml(selector) {
    var tpl = root.querySelector(selector);
    if (!tpl) return '';
    return tpl.innerHTML || '';
  }

  function destroyGallery() {
    if (galleryController && typeof galleryController.destroy === 'function') {
      galleryController.destroy();
    }
    galleryController = null;
  }

  function bindGallery(galleryRoot, images) {
    destroyGallery();
    if (!galleryRoot || !images || images.length < 1) return;

    var imgEl = galleryRoot.querySelector('[data-uf-orient-gallery-hero]');
    var thumbs = galleryRoot.querySelectorAll('.uf-lf-gallery__thumb');
    var dots = galleryRoot.querySelectorAll('.uf-lf-gallery__dot');
    var viewport = galleryRoot.querySelector('[data-uf-orient-gallery-viewport]');
    var prevBtn = galleryRoot.querySelector('[data-uf-orient-gallery-prev]');
    var nextBtn = galleryRoot.querySelector('[data-uf-orient-gallery-next]');
    var idx = 0;
    var slideInterval = null;
    var userStopped = false;
    var SLIDE_MS = 5000;
    var listeners = [];

    function on(el, type, fn, opts) {
      if (!el) return;
      el.addEventListener(type, fn, opts);
      listeners.push({ el: el, type: type, fn: fn, opts: opts });
    }

    function setIndex(i, opts) {
      opts = opts || {};
      var fromSlideshow = opts.fromSlideshow === true;
      var immediate = opts.immediate === true;
      if (!images.length || !imgEl || !viewport) return;
      var prevIdx = idx;
      idx = (i + images.length) % images.length;
      var item = images[idx];
      if (!item) return;

      var reduceMotion =
        window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (immediate || reduceMotion || prevIdx === idx) {
        imgEl.alt = item.alt || '';
        imgEl.src = item.src;
      } else {
        var dir = i > prevIdx ? 'left' : 'right';
        if (Math.abs(i - prevIdx) > 1) {
          dir = idx > prevIdx ? 'left' : 'right';
        }
        var incoming = imgEl.cloneNode(false);
        incoming.removeAttribute('data-uf-orient-gallery-hero');
        incoming.className =
          'uf-lf-gallery__hero--incoming' + (dir === 'right' ? ' from-left' : '');
        incoming.alt = item.alt || '';
        incoming.src = item.src;
        viewport.appendChild(incoming);
        imgEl.classList.remove('is-swipe-out-left', 'is-swipe-out-right');
        window.requestAnimationFrame(function () {
          imgEl.classList.add(
            dir === 'left' ? 'is-swipe-out-left' : 'is-swipe-out-right'
          );
          incoming.classList.add(
            dir === 'left' ? 'is-swipe-in-left' : 'is-swipe-in-right'
          );
        });
        var done = false;
        function finishSwap() {
          if (done) return;
          done = true;
          if (imgEl.parentNode) imgEl.remove();
          incoming.classList.remove(
            'uf-lf-gallery__hero--incoming',
            'is-swipe-in-left',
            'is-swipe-in-right',
            'from-left'
          );
          incoming.classList.add('uf-lf-gallery__hero');
          incoming.setAttribute('data-uf-orient-gallery-hero', '');
          imgEl = incoming;
        }
        incoming.addEventListener('transitionend', finishSwap, { once: true });
        window.setTimeout(finishSwap, 520);
      }

      Array.prototype.forEach.call(thumbs, function (t, j) {
        t.classList.toggle('is-active', j === idx);
        t.setAttribute('aria-selected', j === idx ? 'true' : 'false');
      });
      Array.prototype.forEach.call(dots, function (d, j) {
        d.classList.toggle('is-active', j === idx);
        d.setAttribute('aria-selected', j === idx ? 'true' : 'false');
      });
      if (!fromSlideshow) {
        var ta = thumbs[idx];
        if (ta && ta.scrollIntoView) {
          ta.scrollIntoView({
            block: 'nearest',
            inline: 'nearest',
            behavior: 'smooth',
          });
        }
      }
    }

    function stopSlideshow() {
      userStopped = true;
      if (slideInterval !== null) {
        window.clearInterval(slideInterval);
        slideInterval = null;
      }
    }

    function startSlideshow() {
      if (userStopped || images.length <= 1) return;
      if (slideInterval !== null) return;
      if (
        window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ) {
        return;
      }
      if (typeof document !== 'undefined' && document.hidden) return;
      slideInterval = window.setInterval(function () {
        if (userStopped || (typeof document !== 'undefined' && document.hidden)) {
          return;
        }
        setIndex(idx + 1, { fromSlideshow: true });
      }, SLIDE_MS);
    }

    function onVisibility() {
      if (userStopped || images.length <= 1) return;
      if (document.hidden) {
        if (slideInterval !== null) {
          window.clearInterval(slideInterval);
          slideInterval = null;
        }
      } else {
        startSlideshow();
      }
    }

    Array.prototype.forEach.call(thumbs, function (t) {
      on(t, 'click', function () {
        stopSlideshow();
        var i = parseInt(t.getAttribute('data-index'), 10);
        if (!isNaN(i)) setIndex(i);
      });
    });
    on(prevBtn, 'click', function () {
      stopSlideshow();
      setIndex(idx - 1);
    });
    on(nextBtn, 'click', function () {
      stopSlideshow();
      setIndex(idx + 1);
    });
    Array.prototype.forEach.call(dots, function (d) {
      on(d, 'click', function () {
        stopSlideshow();
        var di = parseInt(d.getAttribute('data-index'), 10);
        if (!isNaN(di)) setIndex(di);
      });
    });

    var touchX = null;
    if (viewport && images.length > 1) {
      on(
        viewport,
        'touchstart',
        function (e) {
          stopSlideshow();
          touchX = e.changedTouches[0].clientX;
        },
        { passive: true }
      );
      on(
        viewport,
        'touchend',
        function (e) {
          if (touchX == null) return;
          var dx = e.changedTouches[0].clientX - touchX;
          touchX = null;
          if (Math.abs(dx) < 45) return;
          if (dx > 0) setIndex(idx - 1);
          else setIndex(idx + 1);
        },
        { passive: true }
      );
      on(viewport, 'keydown', function (e) {
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') stopSlideshow();
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          setIndex(idx - 1);
        }
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          setIndex(idx + 1);
        }
      });
      on(viewport, 'click', function () {
        stopSlideshow();
      });
    }

    on(document, 'visibilitychange', onVisibility);
    startSlideshow();

    galleryController = {
      destroy: function () {
        stopSlideshow();
        listeners.forEach(function (L) {
          try {
            L.el.removeEventListener(L.type, L.fn, L.opts);
          } catch (err) {}
        });
        listeners = [];
      },
    };
  }

  function findCatalogByShopifyId(id) {
    var n = Number(id);
    if (!n) return null;
    if (catalogById[n]) return catalogById[n];
    for (var i = 0; i < catalog.length; i++) {
      if (Number(catalog[i].id) === n) return catalog[i];
    }
    return null;
  }

  function findCatalogByHandle(handle) {
    var h = String(handle || '')
      .trim()
      .toLowerCase();
    if (!h) return null;
    for (var i = 0; i < catalog.length; i++) {
      if (String(catalog[i].handle || '').toLowerCase() === h) return catalog[i];
    }
    return null;
  }

  function handleFromProductUrl(url) {
    var m = String(url || '').match(/\/products\/([^/?#]+)/i);
    return m ? decodeURIComponent(m[1]) : '';
  }

  function bindColorSwatchNavigation(scope) {
    var host = (scope || els.detailBody).querySelector(
      '[data-uf-orient-color-swatches]'
    );
    if (!host) return;

    function wireClicks() {
      host.querySelectorAll('a.uf-lf-color-swatch:not(.is-current)').forEach(
        function (a) {
          a.addEventListener('click', function (e) {
            var id = a.getAttribute('data-product-id');
            var hit =
              findCatalogByShopifyId(id) ||
              findCatalogByHandle(handleFromProductUrl(a.getAttribute('href')));
            if (!hit) return;
            e.preventDefault();
            showProduct(hit.id, { scrollDetailTop: true, source: 'swatch' });
          });
        }
      );
    }

    host.addEventListener('uf-lf-color-swatches:rendered', wireClicks);

    function tryRender(attempt) {
      if (window.UF_LF_COLOR_SWATCHES && window.UF_LF_COLOR_SWATCHES.render) {
        window.UF_LF_COLOR_SWATCHES.render(host);
        return;
      }
      if (attempt >= 25) {
        wireClicks();
        return;
      }
      window.setTimeout(function () {
        tryRender(attempt + 1);
      }, 40);
    }
    tryRender(0);
  }

  function formatWasteDisplay(n) {
    var x = Number(n);
    if (!isFinite(x)) return '10';
    return String(x).replace('.', ',');
  }

  function wastePairFor(pattern) {
    var row = wasteMatrix[pattern] || wasteMatrix.default || { diy: 15, pro: 10 };
    return {
      pro: isFinite(Number(row.pro)) ? Number(row.pro) : 10,
      diy: isFinite(Number(row.diy)) ? Number(row.diy) : 15,
    };
  }

  function detectInstallFromProduct(product) {
    var tags = (product && product.tags) || [];
    var install = '';
    var i;
    for (i = 0; i < tags.length; i++) {
      var tv = tagHeadVal(tags[i]);
      var head = tv.head || '';
      var val = String(tv.val || '').toLowerCase();
      if (
        head === 'soort filter' ||
        head === 'soort' ||
        head === 'pvctype' ||
        head === 'assortiment' ||
        head === 'type'
      ) {
        if (
          val === 'dryback' ||
          val === 'dry-back' ||
          val === 'plak' ||
          val.indexOf('plak') !== -1 ||
          val.indexOf('dryback') !== -1
        ) {
          install = 'plak';
          break;
        }
        if (val.indexOf('click') !== -1 || val === 'klik' || val.indexOf('klik') !== -1) {
          install = 'click';
          break;
        }
        if (val.indexOf('loose') !== -1) {
          install = 'loose';
          break;
        }
      }
    }
    if (!install) {
      var pv = productPvctypeKeys(tags);
      if (pv.indexOf('plak') !== -1) install = 'plak';
      else if (pv.indexOf('click') !== -1) install = 'click';
      else if (pv.indexOf('loose lay') !== -1) install = 'loose';
    }
    if (!install) {
      var titleL = String((product && product.title) || '').toLowerCase();
      if (
        titleL.indexOf('dryback') !== -1 ||
        titleL.indexOf('dry-back') !== -1 ||
        titleL.indexOf(' plak') !== -1
      ) {
        install = 'plak';
      } else if (
        titleL.indexOf('click') !== -1 ||
        titleL.indexOf('klik') !== -1 ||
        titleL.indexOf('rigid') !== -1
      ) {
        install = 'click';
      } else if (
        titleL.indexOf('loose lay') !== -1 ||
        titleL.indexOf('loose-lay') !== -1
      ) {
        install = 'loose';
      }
    }
    return install;
  }

  function adviceTipFamily(product, install) {
    var pattern = inferPatternFromProduct(product);
    if (pattern === 'hongaarse' || pattern === 'weense') return 'point';
    if (pattern === 'visgraat') return 'visgraat';
    if (pattern === 'rechte' || pattern === 'tegel') return 'rechte';
    if (install) return 'general';
    return '';
  }

  function buildSpecialistAdviceHtml(product) {
    if (!product || !product.id) return '';
    var install = detectInstallFromProduct(product);
    var tipFamily = adviceTipFamily(product, install);
    if (!tipFamily) return '';

    var pattern = inferPatternFromProduct(product);
    var pair = wastePairFor(pattern);
    var wPro = formatWasteDisplay(pair.pro);
    var wDiy = formatWasteDisplay(pair.diy);
    var title = String(product.title || '');
    var titleHtml = '<strong>' + escapeHtml(title) + '</strong>';
    var kleurKeys = productKleurKeys(product.tags);
    var kleur = kleurKeys.length
      ? filterOptionLabel('kleur', kleurKeys[0])
      : propFromTags(product.tags, ['kleur', 'kleur groep']) || '';
    var kleurDisp = kleur ? String(kleur).toLowerCase() : '';
    var dikteKeys = productDikteKeys(product.tags);
    var slijtKeys = productSlijtlaagKeys(product.tags);
    var dikte = dikteKeys.length ? dikteKeys[0] : '';
    var slijt = slijtKeys.length ? slijtKeys[0] : '';
    var pak = '';
    if (product.packAreaM2 != null && Number(product.packAreaM2) > 0) {
      pak = formatWasteDisplay(product.packAreaM2);
    } else {
      var pakRaw = propFromTags(product.tags, ['pakinhoud', 'pak inhoud', 'm2 per pak']);
      if (pakRaw) pak = String(pakRaw).replace('.', ',');
    }

    var patVisgraat = tipFamily === 'visgraat';
    var patPoint = tipFamily === 'point';
    var story = Math.abs(Number(product.id) || 0) % 8;

    function mmBits(opts) {
      opts = opts || {};
      var parts = '';
      if (dikte) {
        parts +=
          (opts.colon ? ': ' : opts.parenOpen ? ' (' : ', met een totale dikte van ') +
          '<strong>' +
          escapeHtml(dikte) +
          ' mm</strong>' +
          (opts.totalWord ? ' totaal' : opts.dikWord ? ' dik' : opts.totaleDikte ? ' totale dikte' : '');
        if (slijt) {
          parts +=
            (opts.slijtWhose ? ', waarvan ' : ', slijtlaag ') +
            '<strong>' +
            escapeHtml(slijt) +
            ' mm</strong>' +
            (opts.slijtWhose ? ' slijtlaag' : '');
        }
        if (opts.parenClose) parts += ')';
      } else if (slijt) {
        parts +=
          (opts.parenOpen ? ' (' : ', met een slijtlaag van ') +
          (opts.parenOpen ? 'slijtlaag ' : '') +
          '<strong>' +
          escapeHtml(slijt) +
          ' mm</strong>' +
          (opts.parenClose ? ')' : '');
      }
      if (pak) {
        if (dikte && opts.pakAfterComma) {
          parts +=
            ', <strong>' + escapeHtml(pak) + ' m²</strong> per pak';
        } else if (dikte && opts.pakWith) {
          parts +=
            ', met <strong>' + escapeHtml(pak) + ' m²</strong> per pak';
        } else if (!dikte && opts.pakColon) {
          parts +=
            ': <strong>' + escapeHtml(pak) + ' m²</strong> per pak';
        } else if (opts.pakSentence) {
          parts +=
            '. Per pak reken je op <strong>' +
            escapeHtml(pak) +
            ' m²</strong> vloeroppervlak';
        } else if (pak) {
          parts +=
            ', met <strong>' + escapeHtml(pak) + ' m²</strong> per pak';
        }
      }
      return parts;
    }

    var installPhrase = '';
    if (install === 'plak') installPhrase = ' in plakuitvoering (dryback)';
    else if (install === 'click') installPhrase = ' in click-uitvoering';
    else if (install === 'loose') installPhrase = ' als loose lay';

    var kleurIn =
      kleurDisp !== ''
        ? ' in <strong>' + escapeHtml(kleurDisp) + '</strong>'
        : '';
    var kleurParen =
      kleurDisp !== ''
        ? ' (<strong>' + escapeHtml(kleurDisp) + '</strong>)'
        : '';

    var lead = '';
    if (story === 0) {
      if (kleurDisp) {
        lead =
          'In de kleur <strong>' +
          escapeHtml(kleurDisp) +
          '</strong> komt de ' +
          titleHtml +
          ' het best tot zijn recht als PVC-vloer' +
          installPhrase +
          mmBits({ pakSentence: true, slijtWhose: true }) +
          '.';
      } else {
        lead =
          'De ' +
          titleHtml +
          ' is op z’n mooist als PVC-vloer' +
          installPhrase +
          mmBits({ pakSentence: true, slijtWhose: true }) +
          '.';
      }
      lead +=
        ' Droom je van een sfeervolle, ruimtelijke basis? Deze favoriet onder onze adviseurs voelt warm aan, is 100% waterbestendig en geschikt voor intensief gebruik — van woonkamer tot keuken.';
    } else if (story === 1) {
      var layHint =
        install === 'click' || install === 'loose'
          ? 'zelf kunt leggen'
          : 'strak kunt laten verlijmen';
      var midBits = '';
      if (dikte || pak) {
        midBits = ' (';
        if (dikte) {
          midBits +=
            '<strong>' +
            escapeHtml(dikte) +
            ' mm</strong> totaal' +
            (slijt
              ? ', slijtlaag <strong>' + escapeHtml(slijt) + ' mm</strong>'
              : '');
        }
        if (pak) {
          midBits +=
            (dikte ? ', ' : '') +
            '<strong>' +
            escapeHtml(pak) +
            ' m²</strong> per pak';
        }
        midBits += ')';
      }
      lead =
        'Zoek je een vloer die je ' +
        layHint +
        '? De ' +
        titleHtml +
        kleurIn +
        midBits +
        ' is een sterke renovatiekeuze: stabiel, comfortabel en 100% waterproof. Ideaal wanneer je zonder gedoe een rustige, moderne uitstraling wilt.';
    } else if (story === 2) {
      if (kleurDisp) {
        lead =
          'De ' +
          titleHtml +
          ' in <strong>' +
          escapeHtml(kleurDisp) +
          '</strong> combineert een natuurgetrouw decor met lage warmteweerstand' +
          mmBits({ colon: true, totalWord: true, pakAfterComma: true, pakColon: true }) +
          '.';
      } else {
        lead =
          'Met de ' +
          titleHtml +
          ' kies je een PVC-vloer met lage warmteweerstand' +
          mmBits({ colon: true, totalWord: true, pakAfterComma: true, pakColon: true }) +
          '.';
      }
      lead +=
        ' Daardoor werkt hij uitstekend met vloerverwarming: snel warmtecomfort, geen koude voeten, en een egale temperatuur in de hele ruimte.';
    } else if (story === 3) {
      lead =
        'Wil je één doorlopende vloer van woonkamer naar keuken' +
        (install !== 'loose' ? ' of badkamer' : '') +
        '? De ' +
        titleHtml +
        kleurIn +
        ' is 100% waterbestendig' +
        mmBits({ parenOpen: true, parenClose: true, totalWord: true, pakWith: true }) +
        '. Geen drempels, geen overgangen die de ruimte breken — wel een hygiënisch, makkelijk te reinigen oppervlak dat tegen een stootje kan.';
    } else if (story === 4) {
      if (kleurDisp) {
        lead =
          'Voor een naadloos en kleurvast resultaat adviseren wij de ' +
          titleHtml +
          ' in <strong>' +
          escapeHtml(kleurDisp) +
          '</strong>' +
          mmBits({ colon: true, dikWord: true, pakAfterComma: true, pakColon: true }) +
          '.';
      } else {
        lead =
          'Voor een naadloos en kleurvast resultaat adviseren wij de ' +
          titleHtml +
          mmBits({ colon: true, dikWord: true, pakAfterComma: true, pakColon: true }) +
          '.';
      }
      lead +=
        ' Onze kwaliteitsgarantie: we leveren je volledige bestelling uit één productiebatch, zodat nerf, tint en glansgraad overal gelijk blijven — ook bij grotere oppervlakken.';
    } else if (story === 5) {
      lead =
        'Heb je een druk huishouden of een ruimte met veel loopverkeer? De ' +
        titleHtml +
        kleurParen +
        ' is gebouwd voor intensief dagelijks gebruik';
      if (dikte) {
        lead +=
          ': <strong>' +
          escapeHtml(dikte) +
          ' mm</strong> totale dikte' +
          (slijt
            ? ' met <strong>' + escapeHtml(slijt) + ' mm</strong> slijtlaag'
            : '');
      }
      if (pak) {
        lead += ', <strong>' + escapeHtml(pak) + ' m²</strong> per pak';
      }
      lead +=
        '. Krasbestendig, stil onder de voet en onderhoudsarm — een praktische keuze voor gezinnen, kantoren en projecten.';
    } else if (story === 6) {
      if (patPoint) {
        lead =
          'De ' +
          titleHtml +
          kleurIn +
          ' is een statement voor wie kiest voor Hongaarse of Weense punt' +
          mmBits({ colon: true, totalWord: true, slijtWhose: true, pakWith: true }) +
          '. Planken onder 45° of 60° geven een symmetrisch, hotel-chique lijnenspel.';
      } else if (patVisgraat) {
        lead =
          'De ' +
          titleHtml +
          kleurIn +
          ' is dé visgraat (of walvisgraat) voor wie een speels, ruimtelijk patroon wil' +
          mmBits({ colon: true, totalWord: true, pakAfterComma: true, pakColon: true }) +
          '. Het zigzag-patroon trekt de blik en maakt compacte kamers optisch groter.';
      } else {
        lead =
          'De ' +
          titleHtml +
          kleurIn +
          ' is een rustige PVC-vloer' +
          (dikte
            ? ' van <strong>' +
              escapeHtml(dikte) +
              ' mm</strong> totale dikte' +
              (slijt
                ? ' (slijtlaag <strong>' + escapeHtml(slijt) + ' mm</strong>)'
                : '')
            : '') +
          (pak ? ', met <strong>' + escapeHtml(pak) + ' m²</strong> per pak' : '') +
          '. Ideaal voor Scandinavische rust, een warme eikenlook of een stoere betonlook tegel — zonder drukke overgangen.';
      }
      lead +=
        ' Waterbestendig, geschikt voor vloerverwarming en klaar voor jarenlang dagelijks wooncomfort.';
    } else {
      lead =
        'Goed calculeren begint bij de juiste vloerkeuze. Voor de ' +
        titleHtml +
        kleurIn +
        (pak
          ? ' reken je met <strong>' + escapeHtml(pak) + ' m²</strong> per pak'
          : '') +
        (dikte
          ? ' en een opbouw van <strong>' +
            escapeHtml(dikte) +
            ' mm</strong>' +
            (slijt
              ? ' (slijtlaag <strong>' + escapeHtml(slijt) + ' mm</strong>)'
              : '')
          : '') +
        '. Onze specialisten kijken mee naar legpatroon, snijverlies en ondergrond, zodat je niet tekort komt en geen onnodige restpartijen overhoudt. Het resultaat: een strakke PVC-vloer die eruitziet alsof hij op maat voor jouw woning is gekozen.';
    }

    var tip = '';
    if (tipFamily === 'visgraat') {
      if (install === 'click') {
        tip =
          '<strong>Legadvies &amp; snijverlies:</strong> door de hoek van 45° is er extra verlies aan de randen. Reken op <strong>' +
          escapeHtml(wPro) +
          '% snijverlies</strong> met een professionele legger, of <strong>' +
          escapeHtml(wDiy) +
          '%</strong> bij zelf leggen. Wij leveren uit één batch, zodat elke plank qua kleur en nerfpatroon naadloos op elkaar aansluit.';
      } else {
        tip =
          '<strong>Legadvies &amp; snijverlies:</strong> door het schuine legpatroon heb je langs de wanden extra zaagwerk. Onze calculator rekent automatisch mee: <strong>' +
          escapeHtml(wPro) +
          '% snijverlies</strong> bij professionele legservice, of <strong>' +
          escapeHtml(wDiy) +
          '%</strong> als je zelf legt. Dankzij onze kwaliteitsgarantie leveren we je volledige bestelling uit één productiebatch, voor een naadloos en kleurvast resultaat.';
      }
    } else if (tipFamily === 'rechte') {
      if (install === 'click' || install === 'loose') {
        tip =
          '<strong>Legadvies &amp; snijverlies:</strong> bij rechte banen is het verlies minimaal. Plan <strong>' +
          escapeHtml(wPro) +
          '% extra materiaal</strong> met een professionele legger, of <strong>' +
          escapeHtml(wDiy) +
          '%</strong> bij zelf leggen voor strakke hoeken bij drempels en kozijnen. Alle pakken uit dezelfde batch, zodat kleur en houtnerf mooi doorlopen.';
      } else {
        tip =
          '<strong>Legadvies &amp; snijverlies:</strong> parallel aan de muur blijft het snijverlies beperkt; reststukken zijn vaak herbruikbaar. Onze calculator hanteert <strong>' +
          escapeHtml(wPro) +
          '% snijverlies</strong> voor een vakman en <strong>' +
          escapeHtml(wDiy) +
          '%</strong> bij zelf snijden. De gehele order komt uit één productiebatch, wat essentieel is voor een egale, rustige vloer bij grote tegels of strakke stroken.';
      }
    } else if (tipFamily === 'point') {
      tip =
        '<strong>Legadvies &amp; snijverlies:</strong> dit patroon vraagt precisie: langs alle muren ontstaan veel schuine sneden. Dat is het hoogste snijverlies in ons assortiment. Reken op <strong>' +
        escapeHtml(wPro) +
        '% extra</strong> met een professionele legger, of <strong>' +
        escapeHtml(wDiy) +
        '%</strong> bij zelf leggen. Onze kwaliteitsgarantie (één productiebatch) is hier onmisbaar voor perfecte kleursymmetrie.';
    } else {
      tip =
        '<strong>Legadvies &amp; snijverlies:</strong> plan <strong>' +
        escapeHtml(wPro) +
        '% snijverlies</strong> met een professionele legger, of <strong>' +
        escapeHtml(wDiy) +
        '%</strong> bij zelf leggen. Gebruik onze m²-calculator voor een exacte pakberekening; wij leveren bij voorkeur uit één productiebatch voor een egale kleur.';
    }

    return (
      '<div class="uf-lf-specialist-advice-host uf-orient__specialist-advice">' +
      '<details class="uf-lf-specialist-advice" id="uf-specialist-advice-' +
      escapeHtml(String(product.id)) +
      '">' +
      '<summary class="uf-lf-specialist-advice__summary">Advies van onze specialist</summary>' +
      '<div class="uf-lf-specialist-advice__body" data-uf-no-auto-cap>' +
      '<p class="uf-lf-specialist-advice__lead">' +
      lead +
      '</p>' +
      '<p class="uf-lf-specialist-advice__tip">' +
      tip +
      '</p>' +
      '</div></details>' +
      '<button type="button" class="uf-orient__btn uf-orient__btn--ghost uf-orient__advice-wish' +
      (isFavorite(product.id) ? ' is-on' : '') +
      '" data-uf-orient-detail-fav="' +
      escapeHtml(String(product.id)) +
      '">' +
      '<span class="uf-orient__advice-wish-heart">' +
      wishlistHeartIconsHtml() +
      '</span>' +
      '<span class="uf-orient__advice-wish-label">' +
      (isFavorite(product.id) ? 'Op je wishlist' : 'Voeg toe aan wishlist') +
      '</span>' +
      '</button></div>'
    );
  }

  function activeGalleryRoot() {
    if (
      isOrientPanelLayout() &&
      els.spec &&
      !root.classList.contains('is-product-sheet-open')
    ) {
      return els.spec.querySelector('[data-uf-orient-gallery]');
    }
    return els.detailBody ? els.detailBody.querySelector('[data-uf-orient-gallery]') : null;
  }

  function setSpecTab(name) {
    if (!els.spec) return;
    var tab = name || 'overview';
    var card = els.spec.querySelector('.uf-orient__spec-card');
    if (card) {
      card.classList.toggle('is-spec-tab-desc', tab === 'desc');
      card.classList.toggle('is-spec-tab-specs', tab === 'specs');
    }
    els.spec.querySelectorAll('[data-uf-orient-spec-tab]').forEach(function (btn) {
      var on = btn.getAttribute('data-uf-orient-spec-tab') === tab;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    els.spec.querySelectorAll('[data-uf-orient-spec-panel]').forEach(function (panel) {
      var on = panel.getAttribute('data-uf-orient-spec-panel') === tab;
      panel.hidden = !on;
    });
    var panels = els.spec.querySelector('.uf-orient__spec-panels');
    if (panels) panels.scrollTop = 0;
  }

  function setSpecInfoTab(name) {
    if (!els.spec) return;
    var tab = name || 'packs';
    els.spec.querySelectorAll('[data-uf-orient-info-tab]').forEach(function (btn) {
      var on = btn.getAttribute('data-uf-orient-info-tab') === tab;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    els.spec.querySelectorAll('[data-uf-orient-info-panel]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-uf-orient-info-panel') !== tab;
    });
  }

  function renderSpecCard(p, sp, images, totals, opts) {
    if (!els.spec) return;
    var favOn = opts.favOn;
    var descInner = opts.descInner || '<p class="uf-orient__spec-empty">Geen beschrijving.</p>';
    var specsHtml = opts.specsHtml || '';
    var belowInner = opts.belowInner || '';
    var available = opts.available;
    var variant = opts.variant;
    var cartQty = opts.cartQty;
    var cartLabel = opts.cartLabel;
    var brand = opts.brand || '';
    var specCartLabel =
      available && isOrientPanelLayout() && cartQty > 1
        ? 'Winkelwagen · ' + cartQty + ' pak'
        : cartLabel || (available ? 'Toevoegen aan winkelwagen' : 'Uitverkocht');
    var specActionsHtml =
      '<div class="uf-orient__spec-actions">' +
      '<button type="button" class="uf-lf-btn-cart" data-uf-orient-add-cart' +
      (variant && variant.id && available ? '' : ' disabled') +
      ' data-variant-id="' +
      escapeHtml(variant && variant.id ? String(variant.id) : '') +
      '" data-quantity="' +
      escapeHtml(String(cartQty || 1)) +
      '">' +
      escapeHtml(specCartLabel) +
      '</button>' +
      '<button type="button" class="uf-orient__btn uf-orient__btn--ghost uf-orient__offerte-select' +
      (isOfferteSelected(p.id) ? ' is-on' : '') +
      '" data-uf-orient-offerte-select="' +
      escapeHtml(String(p.id)) +
      '" aria-pressed="' +
      (isOfferteSelected(p.id) ? 'true' : 'false') +
      '">' +
      offerteIconHtml() +
      '<span>Offerte selectie</span></button></div>';
    els.spec.hidden = false;
    els.spec.innerHTML =
      '<div class="uf-orient__spec-card">' +
      '<div class="uf-orient__spec-media">' +
      buildGalleryHtml(images, p.title || '', productActieEligible(p), {
        showColorCta: productHasColorGroup(p),
      }) +
      '</div>' +
      '<div class="uf-orient__spec-ui">' +
      '<div class="uf-orient__spec-grow" aria-hidden="true"></div>' +
      '<div class="uf-orient__spec-tabs" role="tablist" aria-label="Productinformatie">' +
      '<button type="button" class="uf-orient__spec-tab is-active" data-uf-orient-spec-tab="overview" role="tab" aria-selected="true">Overzicht</button>' +
      '<button type="button" class="uf-orient__spec-tab" data-uf-orient-spec-tab="desc" role="tab" aria-selected="false">Info</button>' +
      '<button type="button" class="uf-orient__spec-tab" data-uf-orient-spec-tab="specs" role="tab" aria-selected="false">Specs</button>' +
      '<button type="button" class="uf-orient__spec-tab uf-orient__spec-tab--meer" data-uf-orient-open-pdp aria-label="Volledige productpagina">Meer</button>' +
      '</div>' +
      '<div class="uf-orient__spec-panels">' +
      '<div class="uf-orient__spec-panel" data-uf-orient-spec-panel="overview" role="tabpanel">' +
      '<div class="uf-orient__spec-sheet">' +
      '<div class="uf-orient__spec-title-row">' +
      '<div class="uf-orient__spec-title-copy">' +
      (brand ? '<p class="uf-orient__spec-brand">' + escapeHtml(brand) + '</p>' : '') +
      '<h2 class="uf-orient__spec-title">' +
      escapeHtml(p.title || '') +
      '</h2>' +
      buildPdpPriceRow(p, sp) +
      '</div>' +
      '<button type="button" class="uf-lf-wishlist' +
      (favOn ? ' is-active' : '') +
      '" data-uf-orient-detail-fav="' +
      escapeHtml(String(p.id)) +
      '" aria-pressed="' +
      (favOn ? 'true' : 'false') +
      '" aria-label="' +
      (favOn ? 'Verwijder uit favorieten' : 'Bewaar als favoriet') +
      '">' +
      wishlistHeartIconsHtml() +
      '</button></div>' +
      '<div data-uf-orient-spec-metrics>' +
      buildSpecMetricsHtml(p, totals) +
      '</div></div></div>' +
      '<div class="uf-orient__spec-panel" data-uf-orient-spec-panel="desc" role="tabpanel" hidden>' +
      '<div class="uf-orient__spec-sheet">' +
      buildSpecInfoHtml(p, totals, opts.pattern, opts.waste, specActionsHtml) +
      '</div></div>' +
      '<div class="uf-orient__spec-panel" data-uf-orient-spec-panel="specs" role="tabpanel" hidden>' +
      '<div class="uf-orient__spec-sheet">' +
      buildSpecCardSpecsHtml(p) +
      '</div></div></div></div></div>';
    setSpecTab('overview');
  }

  function renderDetail(catalogProduct, shopifyProduct) {
    parkActieBar();
    var p = catalogProduct;
    var sp = shopifyProduct || {};
    var totals = calcTotals(p);
    var images = collectGalleryImages(sp, p);
    var available =
      sp.available === true ||
      (sp.variants &&
        sp.variants.some(function (v) {
          return v.available;
        }));
    var variant =
      (sp.variants &&
        sp.variants.find(function (v) {
          return v.available;
        })) ||
      (sp.variants && sp.variants[0]) ||
      null;
    var kleurKeys = productKleurKeys(p.tags);
    var kleur = kleurKeys.length
      ? filterOptionLabel('kleur', kleurKeys[0])
      : propFromTags(p.tags, ['kleur', 'kleur groep']) || '';
    var brand = brandOf(p);
    var pattern = inferPatternFromProduct(p);
    var waste = wastePctFor(pattern);
    var calcSummary = buildCalcSummaryHtml(p, totals, pattern, waste);
    var cartQty = totals.hasPack && totals.packCount ? totals.packCount : 1;
    var favOn = isFavorite(p.id);
    var variantLine = brand || kleur || '';
    var cartLabel = available
      ? isOrientPanelLayout() && cartQty > 1
        ? 'Winkelwagen · ' + cartQty + ' pak'
        : 'Toevoegen aan winkelwagen'
      : 'Uitverkocht';

    var foldsOpen = !isOrientPanelLayout();
    var desc = '';
    if (sp.description) {
      desc = foldHtml(
        'Beschrijving',
        '<div class="uf-lf-product__desc-wrap uf-lf-product__desc-panel">' +
          '<div class="uf-lf-product__description-card">' +
          '<span class="uf-lf-product__desc-eyebrow">Productbeschrijving</span>' +
          '<h2 class="uf-lf-product__title uf-lf-product__title--media">' +
          escapeHtml(p.title || '') +
          '</h2>' +
          '<div class="uf-lf-product__description rte">' +
          formatDescriptionHtml(sp.description) +
          '</div></div></div>',
        foldsOpen
      );
    }

    var sku = '';
    if (variant && variant.sku) sku = String(variant.sku).trim();
    else if (sp.variants && sp.variants[0] && sp.variants[0].sku) {
      sku = String(sp.variants[0].sku).trim();
    }

    var hasColorGroup = productHasColorGroup(p);
    var bulletsHtml = buildSpecBulletsHtml(p.tags);
    var specsHtml = buildSpecsTableHtml(p.tags, sku);
    var galleryHtml = buildGalleryHtml(images, p.title || '', productActieEligible(p), {
      showColorCta: hasColorGroup,
    });
    var swatchesHtml = buildColorSwatchesHtml(p, sp);
    var adviceHtml = buildSpecialistAdviceHtml(p);
    var promisesHtml = templateHtml('[data-uf-orient-promises-tpl]');
    var uspsHtml = templateHtml('[data-uf-orient-usps-tpl]');
    var previewImagesJson = '<div hidden data-uf-orient-preview-images></div>';

    lastDetailImages = images;
    lastDetailProduct = p;
    lastDetailShopify = sp;
    destroyGallery();

    /* Swatches live in the buy panel (hidden host for overlay clone); not again under “Meer over”. */
    var belowInner =
      bulletsHtml + promisesHtml + uspsHtml + adviceHtml;
    var belowDescHtml = belowInner
      ? foldHtml('Meer over deze vloer', '<div class="uf-orient__detail-below">' + belowInner + '</div>', foldsOpen)
      : '';

    var buyHeadHtml =
      '<div class="uf-lf-buy-head">' +
      '<div class="uf-lf-product__title-row">' +
      '<h2 class="uf-lf-product__title">' +
      escapeHtml(p.title || '') +
      '</h2>' +
      '<button type="button" class="uf-lf-wishlist' +
      (favOn ? ' is-active' : '') +
      '" data-uf-orient-detail-fav="' +
      escapeHtml(String(p.id)) +
      '" aria-pressed="' +
      (favOn ? 'true' : 'false') +
      '" aria-label="' +
      (favOn ? 'Verwijder uit favorieten' : 'Bewaar als favoriet') +
      '">' +
      wishlistHeartIconsHtml() +
      '</button></div>' +
      '<div class="uf-orient__buy-meta">' +
      (variantLine
        ? '<p class="uf-lf-product__variant-line">' + escapeHtml(variantLine) + '</p>'
        : '') +
      buildPdpPriceRow(p, sp) +
      '</div>' +
      (available ? '' : '<p class="uf-orient__buy-stock">Niet op voorraad</p>') +
      '</div>';

    var buyActionsHtml =
      '<div class="uf-orient__buy-actions">' +
      '<button type="button" class="uf-lf-btn-cart" data-uf-orient-add-cart' +
      (variant && variant.id && available ? '' : ' disabled') +
      ' data-variant-id="' +
      escapeHtml(variant && variant.id ? String(variant.id) : '') +
      '" data-quantity="' +
      escapeHtml(String(cartQty)) +
      '">' +
      cartLabel +
      '</button>' +
      '<button type="button" class="uf-orient__btn uf-orient__btn--ghost uf-orient__offerte-select' +
      (isOfferteSelected(p.id) ? ' is-on' : '') +
      '" data-uf-orient-offerte-select="' +
      escapeHtml(String(p.id)) +
      '" aria-pressed="' +
      (isOfferteSelected(p.id) ? 'true' : 'false') +
      '">' +
      offerteIconHtml() +
      '<span>Offerte selectie</span></button>' +
      (isOrientPanelLayout()
        ? ''
        : '<a class="uf-orient__btn uf-orient__btn--ghost uf-orient__staal-link" href="/pages/kleurstalen">Staal aanvragen</a>') +
      '<button type="button" class="uf-orient__btn uf-orient__btn--ghost uf-orient__fav-text' +
      (favOn ? ' is-on' : '') +
      '" data-uf-orient-detail-fav="' +
      escapeHtml(String(p.id)) +
      '">' +
      (favOn ? 'Opgeslagen als favoriet' : 'Opslaan als favoriet') +
      '</button></div>';

    if (isOrientPanelLayout()) {
      var overlayDesc =
        '<h2 class="uf-lf-product__title uf-orient__overlay-title">' +
        escapeHtml(p.title || '') +
        '</h2>' +
        (sp.description
          ? '<div class="uf-lf-product__description rte">' +
            formatDescriptionHtml(sp.description) +
            '</div>'
          : '');
      els.detailBody.innerHTML =
        '<div class="uf-orient__overlay-pdp uf-lf-product">' +
        previewImagesJson +
        '<div class="uf-orient__overlay-sec uf-orient__overlay-sec--gallery">' +
        galleryHtml +
        '</div>' +
        '<section class="uf-orient__overlay-sec uf-orient__overlay-sec--desc">' +
        overlayDesc +
        '</section>' +
        '<section class="uf-orient__overlay-sec uf-orient__overlay-sec--specs">' +
        specsHtml +
        '</section>' +
        '<section class="uf-orient__overlay-sec uf-orient__overlay-sec--cta uf-orient__buy uf-lf-product__buy">' +
        buyHeadHtml +
        swatchesHtml +
        '<div data-uf-orient-calc-overview>' +
        buildPackOverviewHtml(p, totals, pattern, waste) +
        '</div>' +
        buyActionsHtml +
        '</section>' +
        (adviceHtml
          ? '<section class="uf-orient__overlay-sec uf-orient__overlay-sec--advice">' +
            adviceHtml +
            '</section>'
          : '') +
        '<section class="uf-orient__overlay-sec uf-orient__overlay-sec--trust">' +
        promisesHtml +
        uspsHtml +
        '</section></div>';
    } else {
      els.detailBody.innerHTML =
        '<div class="uf-orient__detail-top uf-lf-product">' +
        previewImagesJson +
        '<div class="uf-orient__detail-main">' +
        '<a class="uf-orient__back" href="/collections/' +
        escapeHtml(collectionHandle) +
        '">Collectie</a>' +
        galleryHtml +
        desc +
        belowDescHtml +
        '</div>' +
        '<div class="uf-orient__buy uf-lf-product__buy">' +
        buyHeadHtml +
        '<div class="uf-orient__actie-slot" data-uf-orient-actie-slot></div>' +
        swatchesHtml +
        '<hr class="uf-lf-divider uf-lf-divider--accent" aria-hidden="true">' +
        '<div data-uf-orient-calc-overview>' +
        buildPackOverviewHtml(p, totals, pattern, waste) +
        '</div>' +
        buyActionsHtml +
        '<a class="uf-orient__btn uf-orient__btn--ghost uf-orient__pdp-link" href="' +
        escapeHtml(productPageUrl(p.url || '/products/' + (p.handle || ''))) +
        '">Volledige productpagina</a>' +
        '<div data-uf-orient-calc-summary>' +
        calcSummary +
        '</div>' +
        foldHtml('Specificaties', specsHtml, foldsOpen) +
        '</div></div>';
    }

    syncColorPreviewOverlay(p);
    syncActieBarPlacement();

    if (els.detailEmpty) {
      els.detailEmpty.hidden = true;
      els.detailEmpty.setAttribute('aria-hidden', 'true');
    }
    if (els.detailSkeleton) els.detailSkeleton.hidden = true;
    if (els.detailBody) els.detailBody.hidden = false;

    var previewPayload = els.detailBody
      ? els.detailBody.querySelector('[data-uf-orient-preview-images]')
      : null;
    if (previewPayload) {
      previewPayload.textContent = JSON.stringify(
        (images || []).map(function (item) {
          return { src: item.src || '', alt: item.alt || '' };
        })
      );
    }

    renderSpecCard(p, sp, images, totals, {
      favOn: favOn,
      descInner: sp.description
        ? '<div class="uf-lf-product__description rte">' +
          formatDescriptionHtml(sp.description) +
          '</div>'
        : '',
      specsHtml: specsHtml,
      belowInner: belowInner,
      available: available,
      variant: variant,
      cartQty: cartQty,
      cartLabel: cartLabel,
      brand: brand,
      pattern: pattern,
      waste: waste,
    });

    bindDetailEvents(p, images);
    mountSheetChrome();
    if (window.UfReviewScore && typeof window.UfReviewScore.refresh === 'function') {
      window.UfReviewScore.refresh();
    }
  }

  function calcSummaryRow(label, value) {
    return (
      '<div class="uf-lf-product__calc-summary-row"><dt>' +
      escapeHtml(label) +
      '</dt><dd>' +
      escapeHtml(value) +
      '</dd></div>'
    );
  }

  function roundPacks(n) {
    return Math.round(Number(n) * 10) / 10;
  }

  function packOverviewParts(product, totals, waste) {
    var packArea = product && product.packAreaM2 ? Number(product.packAreaM2) : 0;
    var netArea = Number(state.areaM2) || 0;
    var netPacks = packArea > 0 && netArea > 0 ? netArea / packArea : 0;
    var wastePacks = netPacks * (Number(waste) / 100);
    var exact = netPacks + wastePacks;
    var packCount = totals.hasPack && totals.packCount ? Number(totals.packCount) : 0;
    var netShown = roundPacks(netPacks);
    var wasteShown = roundPacks(wastePacks);
    if (packCount > 0 && netShown + wasteShown > packCount + 0.001) {
      var overflow = roundPacks(netShown + wasteShown - packCount);
      if (wasteShown >= overflow) wasteShown = roundPacks(wasteShown - overflow);
      else {
        netShown = roundPacks(netShown - (overflow - wasteShown));
        wasteShown = 0;
      }
    }
    var roundShown = packCount > 0 ? roundPacks(packCount - netShown - wasteShown) : 0;
    if (roundShown < 0) roundShown = 0;
    var totalM2 = totals.hasPack && totals.orderedArea ? totals.orderedArea : totals.requiredArea;
    return {
      packArea: packArea,
      exact: exact,
      netShown: netShown,
      wasteShown: wasteShown,
      roundShown: roundShown,
      extra: packCount > 0 ? packCount - exact : 0,
      totalM2: totalM2,
      wastePacks: wasteShown,
      priceCents: totals.hasPack ? totals.totalCents : totals.estimatedCents,
      waste: waste,
    };
  }

  function wasteTitle(waste) {
    var num = Number(waste);
    var digits = Math.abs(num - Math.round(num)) < 0.05 ? 0 : 1;
    return nlNum(num, digits) + '% snijverlies';
  }

  function packsLabel(n) {
    return nlNum(n, 1) + ' ' + packWord(n);
  }

  function signedPacksLabel(n) {
    var rounded = roundPacks(n);
    var text = packsLabel(rounded);
    return rounded > 0 ? '+' + text : text;
  }

  /** Percentage van de actie die nu loopt (0 als er geen actie actief is). */
  function activeCartDiscountPct() {
    var api = window.UF_LF_ACTIE;
    if (!api || typeof api.findState !== 'function') return 0;
    var state = api.findState(new Date());
    if (!state || state.mode !== 'active' || !state.entry) return 0;
    var pct = Number(state.entry.pct) || 0;
    return pct > 0 ? pct : 0;
  }

  function packTile(title, value, modifier, sub, equation, trail) {
    var shown = equation ? equation.sum : value;
    var noteHtml = equation
      ? '<span class="uf-orient__pack-eq">' + escapeHtml(equation.note) + '</span>'
      : trail || '<span class="uf-orient__pack-eq"></span>';
    var valueHtml =
      modifier && modifier.indexOf('uf-orient__pack-tile--row') !== -1
        ? '<span class="uf-orient__pack-tile-figures">' +
          '<strong class="uf-orient__pack-tile-value">' +
          escapeHtml(shown) +
          '</strong>' +
          noteHtml +
          '</span>'
        : '<strong class="uf-orient__pack-tile-value">' + escapeHtml(shown) + '</strong>';
    return (
      '<div class="uf-orient__pack-tile' +
      (modifier ? ' ' + modifier : '') +
      '">' +
      '<span class="uf-orient__pack-tile-copy">' +
      '<span class="uf-orient__pack-tile-label">' +
      escapeHtml(title) +
      '</span>' +
      valueHtml +
      (sub
        ? '<span class="uf-orient__pack-tile-sub">' + escapeHtml(sub) + '</span>'
        : '') +
      '</span>' +
      '</div>'
    );
  }

  function packHelpButtonHtml(helpId) {
    helpId = helpId || 'uf-orient-pack-help';
    return (
      '<button type="button" class="uf-orient__pack-help-btn" data-uf-orient-pack-help aria-expanded="false" aria-controls="' +
      escapeHtml(helpId) +
      '" aria-label="Uitleg over snijverlies en afronding">' +
      '<svg class="uf-orient__pack-help-icon" viewBox="0 0 16 16" aria-hidden="true" focusable="false">' +
      '<circle class="uf-orient__pack-help-ring" cx="8" cy="8" r="6.25" />' +
      '<circle class="uf-orient__pack-help-dot" cx="8" cy="5.2" r="0.8" />' +
      '<path class="uf-orient__pack-help-stem" d="M8 7.25v4.05" />' +
      '</svg>' +
      '</button>'
    );
  }

  function packHelpWhy(pattern, install) {
    if (pattern === 'visgraat') {
      if (install === 'click') {
        return 'De planken liggen onder 45°. Langs de randen blijft daardoor extra rest over.';
      }
      return 'Door het schuine legpatroon heb je langs de wanden extra zaagwerk.';
    }
    if (pattern === 'hongaarse' || pattern === 'weense') {
      return 'Langs alle muren ontstaan veel schuine sneden — het hoogste snijverlies in ons assortiment.';
    }
    if (pattern === 'tegel') {
      return 'De tegels blijven recht t.o.v. de muur. Verlies zit vooral bij randen, drempels en kozijnen.';
    }
    if (install === 'click' || install === 'loose') {
      return 'Bij rechte banen is het verlies minimaal. Extra materiaal is vooral nodig bij drempels en kozijnen.';
    }
    return 'Parallel aan de muur blijft het snijverlies beperkt. Reststukken zijn vaak herbruikbaar.';
  }

  function packHelpPanelHtml(product, pattern, helpId) {
    helpId = helpId || 'uf-orient-pack-help';
    pattern = pattern || (product ? inferPatternFromProduct(product) : state.patternHint);
    var install = product ? detectInstallFromProduct(product) : '';
    var pair = wastePairFor(pattern);
    var wPro = formatWasteDisplay(pair.pro);
    var wDiy = formatWasteDisplay(pair.diy);
    var installPhrase = '';
    if (install === 'plak') installPhrase = ' · plak (dryback)';
    else if (install === 'click') installPhrase = ' · click';
    else if (install === 'loose') installPhrase = ' · loose lay';
    var productUrl = productPageUrl(
      (product && product.url) ||
        (product && product.handle ? '/products/' + product.handle : '')
    );
    var pageLink = productUrl
      ? '<a class="uf-orient__pack-help-link" href="' +
        escapeHtml(productUrl) +
        '">productpagina</a>'
      : 'productpagina';
    var isPro = state.wasteMode === 'pro';
    var nowLabel = isPro ? 'professioneel leggen' : 'zelf leggen';
    var nowPct = isPro ? wPro : wDiy;
    return (
      '<div id="' +
      escapeHtml(helpId) +
      '" class="uf-orient__pack-help" data-uf-orient-pack-help-panel data-uf-no-auto-cap hidden>' +
      '<p class="uf-orient__pack-help-lead">' +
      '<span class="uf-orient__pack-help-type">' +
      escapeHtml(patternLabel(pattern)) +
      escapeHtml(installPhrase) +
      '</span>' +
      '<span class="uf-orient__pack-help-why">' +
      packHelpWhy(pattern, install) +
      '</span>' +
      '</p>' +
      '<div class="uf-orient__pack-help-rates" role="group" aria-label="Snijverliespercentages">' +
      '<div class="uf-orient__pack-help-rate' +
      (isPro ? '' : ' is-active') +
      '">' +
      '<span class="uf-orient__pack-help-rate-pct">' +
      escapeHtml(wDiy) +
      '%</span>' +
      '<span class="uf-orient__pack-help-rate-label">Zelf leggen</span>' +
      '</div>' +
      '<div class="uf-orient__pack-help-rate' +
      (isPro ? ' is-active' : '') +
      '">' +
      '<span class="uf-orient__pack-help-rate-pct">' +
      escapeHtml(wPro) +
      '%</span>' +
      '<span class="uf-orient__pack-help-rate-label">Professioneel</span>' +
      '</div>' +
      '</div>' +
      '<p class="uf-orient__pack-help-now">Nu gerekend: <strong>' +
      escapeHtml(nowPct) +
      '%</strong> (' +
      escapeHtml(nowLabel) +
      '). Industriestandaard voor dit type vloer.</p>' +
      '<dl class="uf-orient__pack-help-defs">' +
      '<div class="uf-orient__pack-help-def">' +
      '<dt>Snijverlies</dt>' +
      '<dd>Extra vloer voor zaagsnedes, legpatroon en kleine maatverschillen.</dd>' +
      '</div>' +
      '<div class="uf-orient__pack-help-def">' +
      '<dt>Afronding</dt>' +
      '<dd>We verkopen alleen hele pakken — afronden naar het volgende pak.</dd>' +
      '</div>' +
      '</dl>' +
      '<p class="uf-orient__pack-help-foot">Andere percentages? Pas ze aan op de ' +
      pageLink +
      '.</p>' +
      '</div>'
    );
  }
  function packStep(add, sum) {
    if (!(Math.abs(Number(add)) > 0.001)) return null;
    return {
      note: '+ ' + nlNum(add, 1),
      sum: nlNum(sum, 1),
    };
  }

  function cartDiscountTile(pct) {
    var label = String(pct).replace('.', ',') + '%';
    return (
      '<div class="uf-orient__pack-tile uf-orient__pack-tile--cart">' +
      '<span class="uf-orient__pack-tile-copy">' +
      '<span class="uf-orient__pack-tile-label">' +
      '<span class="uf-orient__actie-hint-check" title="Komt in aanmerking voor de lopende actie" aria-hidden="true">✓</span>' +
      '</span>' +
      '<strong class="uf-orient__pack-tile-value">' +
      escapeHtml(label) +
      '</strong>' +
      '</span></div>'
    );
  }

  function specCalcRow(label, value) {
    return (
      '<div class="uf-orient__spec-calc-row"><span>' +
      escapeHtml(label) +
      '</span><strong>' +
      escapeHtml(value) +
      '</strong></div>'
    );
  }

  function buildSpecMetricsHtml(product, totals) {
    totals = totals || calcTotals(product);
    if (!(Number(state.areaM2) > 0)) {
      return '<p class="uf-orient__spec-metrics-empty">Vul je m² in</p>';
    }
    var parts = packOverviewParts(
      product,
      totals,
      wastePctFor(inferPatternFromProduct(product))
    );
    var packs = totals.hasPack && totals.packCount ? String(totals.packCount) : '—';
    var m2 = nlNum(parts.totalM2, 1).replace(/,0$/, '');
    var html =
      '<div class="uf-orient__spec-metrics">' +
      '<div class="uf-orient__spec-metric"><span class="uf-orient__spec-metric-label">Pakken</span><strong>' +
      escapeHtml(packs) +
      '</strong></div>' +
      '<div class="uf-orient__spec-metric"><span class="uf-orient__spec-metric-label">Totale m²</span><strong>' +
      escapeHtml(m2) +
      '</strong></div>' +
      '<div class="uf-orient__spec-metric uf-orient__spec-metric--price"><span class="uf-orient__spec-metric-label">Totaal</span><strong>' +
      escapeHtml(formatMoney(parts.priceCents)) +
      '</strong></div></div>';
    if (totals.savingsCents > 0) {
      html +=
        '<p class="uf-orient__spec-save">Bespaar ' +
        escapeHtml(formatMoney(totals.savingsCents)) +
        '</p>';
    }
    return html;
  }

  function buildSpecCalcHtml(product, totals, pattern, waste) {
    totals = totals || calcTotals(product);
    pattern = pattern || inferPatternFromProduct(product);
    waste = waste != null ? waste : wastePctFor(pattern);
    if (!(Number(state.areaM2) > 0)) {
      return '<p class="uf-orient__spec-metrics-empty">Vul je m² in</p>';
    }
    var parts = packOverviewParts(product, totals, waste);
    var areaInput = nlNum(state.areaM2, 1).replace(/,0$/, '');
    var rows =
      specCalcRow('Benodigd', areaInput + ' m²') +
      specCalcRow(
        wasteTitle(waste),
        parts.packArea > 0 ? nlNum(parts.wasteShown, 1) : '—'
      );
    if (totals.hasPack) {
      var roundShown = roundPacks(parts.roundShown);
      rows += specCalcRow(
        'Afronding',
        (roundShown > 0 ? '+' : '') + nlNum(roundShown, 1)
      );
    }
    return '<div class="uf-orient__spec-calc">' + rows + '</div>';
  }

  function specInfoTabBtn(id, label, active) {
    return (
      '<button type="button" class="uf-orient__spec-info-tab' +
      (active ? ' is-active' : '') +
      '" data-uf-orient-info-tab="' +
      id +
      '" role="tab" aria-selected="' +
      (active ? 'true' : 'false') +
      '">' +
      label +
      '</button>'
    );
  }

  function buildSpecInfoPacksHtml(product, totals, pattern, waste) {
    totals = totals || calcTotals(product);
    pattern = pattern || inferPatternFromProduct(product);
    waste = waste != null ? waste : wastePctFor(pattern);
    if (!(Number(state.areaM2) > 0)) {
      return '<p class="uf-orient__spec-metrics-empty">Vul je m² in</p>';
    }
    var parts = packOverviewParts(product, totals, waste);
    var areaInput = nlNum(state.areaM2, 1).replace(/,0$/, '');
    var afterWaste = roundPacks(parts.netShown + parts.wasteShown);
    var wasteVal = '—';
    if (parts.packArea > 0) {
      wasteVal = nlNum(afterWaste, 1);
      if (parts.wasteShown > 0) wasteVal += '  +' + nlNum(parts.wasteShown, 1);
    }
    var rows =
      specCalcRow('Benodigd', areaInput + ' m²') +
      specCalcRow('Pakken voor m²', parts.packArea > 0 ? nlNum(parts.netShown, 1) : '—') +
      specCalcRow(wasteTitle(waste), wasteVal);
    if (totals.hasPack) {
      var roundShown = roundPacks(parts.roundShown);
      rows += specCalcRow(
        'Afronding',
        (roundShown > 0 ? '+' : '') + nlNum(roundShown, 1)
      );
    }
    if (totals.hasPack && totals.packCount) {
      rows += specCalcRow('Totale pakken', String(totals.packCount));
    }
    rows += specCalcRow(
      'Totale m²',
      nlNum(parts.totalM2, 1).replace(/,0$/, '') + ' m²'
    );
    return (
      '<div class="uf-orient__spec-calc uf-orient__spec-calc--info">' +
      rows +
      packHelpButtonHtml('uf-orient-spec-pack-help') +
      packHelpPanelHtml(product, pattern, 'uf-orient-spec-pack-help') +
      '</div>'
    );
  }

  function buildSpecInfoPriceHtml(product, totals, pattern, waste) {
    totals = totals || calcTotals(product);
    pattern = pattern || inferPatternFromProduct(product);
    waste = waste != null ? waste : wastePctFor(pattern);
    if (!(Number(state.areaM2) > 0)) {
      return '<p class="uf-orient__spec-metrics-empty">Vul je m² in</p>';
    }
    var parts = packOverviewParts(product, totals, waste);
    var cartPct = productActieEligible(product) ? activeCartDiscountPct() : 0;
    var rows = specCalcRow('Totaal', formatMoney(parts.priceCents));
    if (totals.savingsCents > 0) {
      rows += specCalcRow('Bespaar', formatMoney(totals.savingsCents));
    }
    if (totals.hasPack && totals.packCount) {
      rows += specCalcRow('Pakken', String(totals.packCount));
    }
    if (cartPct > 0) {
      rows += specCalcRow('Actie', String(cartPct).replace('.', ',') + '%');
    }
    return '<div class="uf-orient__spec-calc uf-orient__spec-calc--info">' + rows + '</div>';
  }

  function buildSpecInfoHtml(product, totals, pattern, waste, actionsHtml) {
    return (
      '<div class="uf-orient__spec-info" data-uf-orient-spec-info>' +
      '<div class="uf-orient__spec-info-tabs" role="tablist" aria-label="Berekening">' +
      specInfoTabBtn('packs', 'Pakken', true) +
      specInfoTabBtn('price', 'Prijs', false) +
      specInfoTabBtn('buy', 'Bestellen', false) +
      '</div>' +
      '<div class="uf-orient__spec-info-panel" data-uf-orient-info-panel="packs" data-uf-orient-spec-info-packs role="tabpanel">' +
      buildSpecInfoPacksHtml(product, totals, pattern, waste) +
      '</div>' +
      '<div class="uf-orient__spec-info-panel" data-uf-orient-info-panel="price" data-uf-orient-spec-info-price role="tabpanel" hidden>' +
      buildSpecInfoPriceHtml(product, totals, pattern, waste) +
      '</div>' +
      '<div class="uf-orient__spec-info-panel" data-uf-orient-info-panel="buy" role="tabpanel" hidden>' +
      (actionsHtml || '') +
      '</div></div>'
    );
  }

  function buildPackOverviewHtml(product, totals, pattern, waste, helpId) {
    totals = totals || calcTotals(product);
    pattern = pattern || inferPatternFromProduct(product);
    waste = waste != null ? waste : wastePctFor(pattern);
    helpId = helpId || 'uf-orient-pack-help';
    if (!(Number(state.areaM2) > 0)) {
      return '<p class="uf-orient__buy-calc-empty">Vul bovenaan je m² in om de berekening te zien.</p>';
    }
    var parts = packOverviewParts(product, totals, waste);
    var areaInput = nlNum(state.areaM2, 1).replace(/,0$/, '');
    var rows = '';
    var afterWaste = roundPacks(parts.netShown + parts.wasteShown);
    rows += packTile(
      'Aantal pakken voor benodigde m²',
      parts.packArea > 0 ? nlNum(parts.netShown, 1) : '—',
      'uf-orient__pack-tile--row',
      '',
      null,
      packHelpButtonHtml(helpId)
    );
    rows += packHelpPanelHtml(product, pattern, helpId);
    rows += packTile(
      wasteTitle(waste),
      parts.packArea > 0 ? nlNum(parts.wasteShown, 1) : '—',
      'uf-orient__pack-tile--row',
      '',
      parts.packArea > 0 ? packStep(parts.wasteShown, afterWaste) : ''
    );
    if (totals.hasPack) {
      var roundShown = roundPacks(parts.roundShown);
      var roundText = (roundShown > 0 ? '+' : '') + nlNum(roundShown, 1);
      var afterRound = roundPacks(afterWaste + roundShown);
      rows += packTile(
        'Afronding',
        roundText,
        'uf-orient__pack-tile--row',
        '',
        packStep(roundShown, afterRound)
      );
    }
    var result = '';
    if (totals.hasPack && totals.packCount) {
      result =
        '<div class="uf-orient__pack-result">' +
        packTile('Totale pakken', String(totals.packCount), 'uf-orient__pack-tile--total') +
        packTile(
          'Totale m²',
          nlNum(parts.totalM2, 1).replace(/,0$/, '') + ' m²',
          'uf-orient__pack-tile--for'
        ) +
        '</div>';
    } else {
      result =
        '<div class="uf-orient__pack-result uf-orient__pack-result--single">' +
        packTile(
          'Totale m²',
          nlNum(parts.totalM2, 1).replace(/,0$/, '') + ' m²',
          'uf-orient__pack-tile--for'
        ) +
        '</div>';
    }
    var metaTiles = '';
    var showSave = totals.savingsCents > 0;
    var cartPct = productActieEligible(product) ? activeCartDiscountPct() : 0;
    if (showSave) {
      metaTiles += packTile(
        'Bespaar',
        formatMoney(totals.savingsCents),
        'uf-orient__pack-tile--save'
      );
    }
    if (showSave && cartPct > 0 && totals.hasPack && totals.packCount) {
      metaTiles += packTile('Pakken', String(totals.packCount), 'uf-orient__pack-tile--count');
    }
    if (cartPct > 0) metaTiles += cartDiscountTile(cartPct);
    var metaClass = '';
    if (showSave && cartPct > 0) metaClass = ' uf-orient__pack-price-meta--trio';
    else if (showSave || cartPct > 0) metaClass = ' uf-orient__pack-price-meta--duo';
    return (
      '<div class="uf-orient__pack-overview">' +
      '<div class="uf-orient__pack-head">' +
      '<div class="uf-orient__pack-head-copy">' +
      '<p class="uf-orient__pack-heading">Aantal pakken</p>' +
      '<span class="uf-orient__pack-tile-label">Benodigde m²</span>' +
      '</div>' +
      '<span class="uf-orient__pack-tile-figures">' +
      '<strong class="uf-orient__pack-tile-value">' +
      escapeHtml(areaInput) +
      '</strong>' +
      '<span class="uf-orient__pack-eq">m²</span>' +
      '</span></div>' +
      '<div class="uf-orient__pack-breakdown">' +
      rows +
      '</div>' +
      '</div>' +
      result +
      '<div class="uf-orient__pack-split" role="separator" aria-hidden="true"></div>' +
      '<div class="uf-orient__pack-price">' +
      (showSave ? '<div class="uf-orient__pack-price-sale">' : '') +
      '<p class="uf-orient__pack-heading">Totale prijs</p>' +
      (metaTiles
        ? '<div class="uf-orient__pack-price-meta' + metaClass + '">' + metaTiles + '</div>'
        : '') +
      (showSave ? '</div>' : '') +
      packTile('Totaal', formatMoney(parts.priceCents), 'uf-orient__pack-tile--amount') +
      '</div>'
    );
  }

  function buildCalcSummaryHtml(product, totals, pattern, waste) {
    totals = totals || calcTotals(product);
    pattern = pattern || inferPatternFromProduct(product);
    waste = waste != null ? waste : wastePctFor(pattern);
    if (!(Number(state.areaM2) > 0)) return '';
    var parts = packOverviewParts(product, totals, waste);
    var areaInput = nlNum(state.areaM2, 1);
    var rows = '';
    if (parts.packArea > 0) {
      rows += calcSummaryRow('Dekking per verpakking', nlNum(parts.packArea, 1) + ' m²');
    }
    rows += calcSummaryRow('Benodigde vloer', areaInput + ' m²');
    if (totals.hasPack || parts.netShown > 0) {
      rows += calcSummaryRow('Benodigde pakken', packsLabel(parts.netShown));
    }
    rows += calcSummaryRow(
      wasteTitle(waste),
      (parts.packArea > 0 ? packsLabel(parts.wasteShown) : '—') +
        ' · ' +
        wasteModeLabel() +
        ' · ' +
        patternLabel(pattern)
    );
    if (totals.hasPack) {
      rows += calcSummaryRow('Afronding', signedPacksLabel(parts.roundShown));
      rows += calcSummaryRow(
        'Aantal pakken',
        String(totals.packCount) + ' ' + packWord(totals.packCount)
      );
    }
    rows += calcSummaryRow('Totale m²', nlNum(parts.totalM2, 1) + ' m²');
    return (
      '<details class="uf-lf-product__calc-summary">' +
      '<summary class="uf-lf-product__calc-summary-heading">Uw berekening</summary>' +
      '<div class="uf-lf-product__calc-summary-body"><dl class="uf-lf-product__calc-summary-dl">' +
      rows +
      '</dl></div></details>'
    );
  }

  function refreshCalcSummary(product) {
    if (!product) return;
    var pattern = inferPatternFromProduct(product);
    var waste = wastePctFor(pattern);
    var totals = calcTotals(product);
    function fillOverview(overview) {
      if (!overview) return;
      var keepHelp = !!overview.querySelector(
        '[data-uf-orient-pack-help][aria-expanded="true"]'
      );
      overview.innerHTML = buildPackOverviewHtml(product, totals, pattern, waste);
      if (keepHelp) {
        var helpBtn = overview.querySelector('[data-uf-orient-pack-help]');
        var helpPanel = overview.querySelector('[data-uf-orient-pack-help-panel]');
        if (helpBtn && helpPanel) {
          helpBtn.setAttribute('aria-expanded', 'true');
          helpPanel.hidden = false;
        }
      }
    }
    fillOverview(els.detailBody && els.detailBody.querySelector('[data-uf-orient-calc-overview]'));
    var specPacks = els.spec && els.spec.querySelector('[data-uf-orient-spec-info-packs]');
    if (specPacks) specPacks.innerHTML = buildSpecInfoPacksHtml(product, totals, pattern, waste);
    var specPrice = els.spec && els.spec.querySelector('[data-uf-orient-spec-info-price]');
    if (specPrice) specPrice.innerHTML = buildSpecInfoPriceHtml(product, totals, pattern, waste);
    var specMetrics = els.spec && els.spec.querySelector('[data-uf-orient-spec-metrics]');
    if (specMetrics) specMetrics.innerHTML = buildSpecMetricsHtml(product, totals);
    var specCalc = els.spec && els.spec.querySelector('[data-uf-orient-spec-calc]');
    if (specCalc) specCalc.innerHTML = buildSpecCalcHtml(product, totals, pattern, waste);
    var box = els.detailBody && els.detailBody.querySelector('[data-uf-orient-calc-summary]');
    if (box) {
      var keepOpen = !!(box.querySelector('details') && box.querySelector('details').open);
      box.innerHTML = buildCalcSummaryHtml(product, totals, pattern, waste);
      if (keepOpen) {
        var details = box.querySelector('details');
        if (details) details.open = true;
      }
    }
    var qty = totals.hasPack && totals.packCount ? totals.packCount : 1;
    var cartBtns = [];
    [els.sheetDock, els.detailBody, els.spec].forEach(function (host) {
      if (!host) return;
      host.querySelectorAll('[data-uf-orient-add-cart]').forEach(function (btn) {
        cartBtns.push(btn);
      });
    });
    cartBtns.forEach(function (cartBtn) {
      if (cartBtn.textContent.indexOf('Toegevoegd') !== -1) return;
      cartBtn.setAttribute('data-quantity', String(qty));
      if (isOrientPanelLayout() && qty > 1 && cartBtn.textContent.indexOf('Winkelwagen') === 0) {
        cartBtn.textContent = 'Winkelwagen · ' + qty + ' pak';
      }
    });
  }

  function bindDetailEvents(product, images) {
    lastDetailImages = images || [];
    bindGallery(activeGalleryRoot(), lastDetailImages);
    if (els.detailBody) bindColorSwatchNavigation(els.detailBody);
    if (els.spec) bindColorSwatchNavigation(els.spec);
    var host = els.detail || els.detailBody;

    function syncDetailFav(on) {
      host.querySelectorAll('[data-uf-orient-detail-fav]').forEach(function (btn) {
        if (btn.classList.contains('uf-lf-wishlist')) {
          btn.classList.toggle('is-active', on);
          btn.setAttribute('aria-pressed', on ? 'true' : 'false');
          btn.setAttribute('aria-label', on ? 'Verwijder uit favorieten' : 'Bewaar als favoriet');
        } else if (btn.classList.contains('uf-orient__advice-wish')) {
          btn.classList.toggle('is-on', on);
          var wishLabel = btn.querySelector('.uf-orient__advice-wish-label');
          if (wishLabel) wishLabel.textContent = on ? 'Op je wishlist' : 'Voeg toe aan wishlist';
        } else {
          btn.classList.toggle('is-on', on);
          btn.textContent = on ? 'Opgeslagen als favoriet' : 'Opslaan als favoriet';
        }
      });
      syncDetailOfferteSelect();
    }

    function syncDetailOfferteSelect() {
      host.querySelectorAll('[data-uf-orient-offerte-select]').forEach(function (btn) {
        var on = isOfferteSelected(product.id);
        btn.classList.toggle('is-on', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    host.querySelectorAll('[data-uf-orient-detail-fav]').forEach(function (favBtn) {
      favBtn.addEventListener('click', function () {
        toggleFavorite(product.id, product);
        syncDetailFav(isFavorite(product.id));
        applyAndRender({ skipDetail: true });
      });
    });

    host.querySelectorAll('[data-uf-orient-offerte-select]').forEach(function (offerteSelectBtn) {
      offerteSelectBtn.addEventListener('click', function () {
        likeAndSelectForOfferte(product.id, product);
        syncDetailFav(isFavorite(product.id));
        applyAndRender({ skipDetail: true });
      });
    });

    host.querySelectorAll('[data-uf-orient-add-cart]').forEach(function (cartBtn) {
      cartBtn.addEventListener('click', function () {
        var vid = cartBtn.getAttribute('data-variant-id');
        if (!vid) return;
        var qty = Number(cartBtn.getAttribute('data-quantity'));
        if (!isFinite(qty) || qty < 1) qty = 1;
        cartBtn.disabled = true;
        persistAreaM2();
        var addPayload = { id: Number(vid), quantity: qty };
        if (state.areaM2 > 0 && window.UfRoomState && typeof window.UfRoomState.buildProperties === 'function') {
          var roomProps = window.UfRoomState.buildProperties({
            areaM2: state.areaM2,
            wastePct: activeWastePct(product),
            wasteMode: state.wasteMode,
            totalM2: requiredArea(product)
          });
          if (roomProps) addPayload.properties = roomProps;
        }
        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(addPayload),
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Toevoegen mislukt');
            cartBtn.textContent = 'Toegevoegd ✓';
            trackOrient('orient_cart', {
              step: 'Winkelwagen',
              choice: product.title || '',
              handle: product.handle || '',
              productTitle: product.title || '',
              qty: qty,
            });
            trackOrient('add_to_cart', {
              handle: product.handle || '',
              productTitle: product.title || '',
              qty: qty,
              source: 'orientatie',
            });
            setTimeout(function () {
              cartBtn.textContent = isOrientPanelLayout()
                ? qty > 1
                  ? 'Winkelwagen · ' + qty + ' pak'
                  : 'Winkelwagen'
                : 'Toevoegen aan winkelwagen';
              cartBtn.disabled = false;
            }, 1600);
          })
          .catch(function () {
            cartBtn.textContent = 'Probeer opnieuw';
            cartBtn.disabled = false;
          });
      });
    });
  }

  function syncToolbarRoomUi() {
    var areaVal = state.areaM2 > 0 ? String(state.areaM2).replace('.', ',') : '';
    if (els.area && document.activeElement !== els.area) els.area.value = areaVal;
    if (els.browseArea && document.activeElement !== els.browseArea) {
      els.browseArea.value = areaVal;
    }
    if (els.wasteModeBtns && els.wasteModeBtns.length) {
      els.wasteModeBtns.forEach(function (btn) {
        var on = btn.getAttribute('data-uf-orient-waste-mode') === state.wasteMode;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    if (els.settingsDot) {
      els.settingsDot.hidden = state.wasteMode !== 'pro';
    }
    if (els.settingsOpen) {
      els.settingsOpen.classList.toggle('is-pro', state.wasteMode === 'pro');
    }
    if (els.browseWasteBtns && els.browseWasteBtns.length) {
      els.browseWasteBtns.forEach(function (btn) {
        var on = btn.getAttribute('data-uf-orient-browse-waste-mode') === state.wasteMode;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
  }

  function onRoomStateChanged() {
    syncToolbarRoomUi();
    persistAreaM2();
    syncPdpLinkHrefs();
    var product = catalogById[Number(state.selectedProductId)];
    if (product) refreshCalcSummary(product);
    writeUrl();
    refreshBrowseOverlays();
  }

  function roomWasteHintText(mode) {
    return mode === 'pro'
      ? 'Bij laten leggen rekenen we minder snijverlies.'
      : 'Bij zelf leggen rekenen we iets meer snijverlies.';
  }

  function syncRoomDialogUi() {
    if (els.roomArea && !state.roomUseDims) {
      els.roomArea.value =
        state.areaM2 > 0 ? String(state.areaM2).replace('.', ',') : els.roomArea.value;
    }
    if (els.roomWasteBtns && els.roomWasteBtns.length) {
      els.roomWasteBtns.forEach(function (btn) {
        var on = btn.getAttribute('data-uf-orient-room-waste-mode') === state.wasteMode;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    if (els.roomWasteHint) {
      els.roomWasteHint.textContent = roomWasteHintText(state.wasteMode);
    }
    if (els.roomDims) els.roomDims.hidden = !state.roomUseDims;
    if (els.roomToggleDims) {
      els.roomToggleDims.textContent = state.roomUseDims
        ? 'Direct m²'
        : 'Lengte × breedte';
      els.roomToggleDims.setAttribute('aria-expanded', state.roomUseDims ? 'true' : 'false');
      els.roomToggleDims.classList.toggle('is-on', !!state.roomUseDims);
    }
    if (els.roomArea) els.roomArea.disabled = !!state.roomUseDims;
    if (els.roomError) els.roomError.hidden = true;
  }

  function calcRoomDimsM2() {
    var len = parseDecimal(els.roomLen && els.roomLen.value);
    var wid = parseDecimal(els.roomWid && els.roomWid.value);
    if (!(isFinite(len) && len > 0 && isFinite(wid) && wid > 0)) return null;
    return Math.round(((len * wid) / 10000) * 100) / 100;
  }

  function updateRoomDimsResult() {
    if (!els.roomDimsResult) return;
    var m2 = calcRoomDimsM2();
    if (m2 == null) {
      els.roomDimsResult.textContent = 'Vul lengte en breedte in.';
      return;
    }
    els.roomDimsResult.textContent =
      'Oppervlakte: ' + String(m2).replace('.', ',') + ' m²';
    if (els.roomArea) els.roomArea.value = String(m2).replace('.', ',');
  }

  function openRoomDialog() {
    if (!els.roomDialog) return;
    state.roomUseDims = false;
    syncRoomDialogUi();
    if (els.roomArea && state.areaM2 > 0) {
      els.roomArea.value = String(state.areaM2).replace('.', ',');
    }
    els.roomDialog.hidden = false;
    root.classList.add('is-room-open');
    if (els.roomConfirm) {
      els.roomConfirm.textContent = state.roomSetupDone ? 'Toepassen' : 'Bekijk vloeren';
    }
    trackOrient('orient_room_open', { step: 'Ruimte' });
    trackOrientModal('open', 'room');
    try {
      document.documentElement.style.overflow = 'hidden';
    } catch (e) {
      /* ignore */
    }
    window.setTimeout(function () {
      if (els.roomArea && !els.roomArea.disabled) els.roomArea.focus();
    }, 40);
  }

  function closeRoomDialog(reason) {
    if (!els.roomDialog) return;
    var wasOpen = !els.roomDialog.hidden;
    els.roomDialog.hidden = true;
    root.classList.remove('is-room-open');
    try {
      document.documentElement.style.overflow = '';
    } catch (e) {
      /* ignore */
    }
    if (wasOpen && reason && reason !== 'succeed') {
      trackOrientModal('close', 'room', { reason: reason });
    }
  }

  function confirmRoomDialog() {
    var area = state.roomUseDims
      ? calcRoomDimsM2()
      : parseDecimal(els.roomArea && els.roomArea.value);
    if (!(isFinite(area) && area > 0)) {
      if (els.roomError) els.roomError.hidden = false;
      if (els.roomArea && !state.roomUseDims) els.roomArea.focus();
      else if (els.roomLen) els.roomLen.focus();
      return;
    }
    state.areaM2 = Math.round(area * 100) / 100;
    state.roomSetupDone = true;
    if (els.roomError) els.roomError.hidden = true;
    closeRoomDialog('succeed');
    onRoomStateChanged();
    trackOrient('orient_room_confirm', {
      step: 'Ruimte bevestigd',
      choice: String(state.areaM2).replace('.', ',') + ' m² · ' + (state.wasteMode || ''),
    });
    trackOrientModal('succeed', 'room', {
      choice: String(state.areaM2).replace('.', ',') + ' m²',
    });
  }

  function bindRoomDialog() {
    if (!els.roomDialog) return;

    if (els.roomToggleDims) {
      els.roomToggleDims.addEventListener('click', function () {
        state.roomUseDims = !state.roomUseDims;
        syncRoomDialogUi();
        if (state.roomUseDims) {
          updateRoomDimsResult();
          if (els.roomLen) els.roomLen.focus();
        } else if (els.roomArea) {
          els.roomArea.focus();
        }
      });
    }

    if (els.roomLen) {
      els.roomLen.addEventListener('input', updateRoomDimsResult);
    }
    if (els.roomWid) {
      els.roomWid.addEventListener('input', updateRoomDimsResult);
    }

    if (els.roomArea) {
      els.roomArea.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          confirmRoomDialog();
        }
      });
    }

    if (els.roomWasteBtns && els.roomWasteBtns.length) {
      els.roomWasteBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var mode = btn.getAttribute('data-uf-orient-room-waste-mode');
          if (mode !== 'diy' && mode !== 'pro') return;
          state.wasteMode = mode;
          syncRoomDialogUi();
          persistAreaM2();
          trackOrient('orient_waste', {
            step: 'Legwijze',
            choice: mode === 'pro' ? 'professionele legger' : 'zelf leggen',
          });
        });
      });
    }

    if (els.roomConfirm) {
      els.roomConfirm.addEventListener('click', confirmRoomDialog);
    }
  }

  function showProduct(id, opts) {
    opts = opts || {};
    var product = catalogById[Number(id)];
    if (!product) {
      showNoSelection();
      return;
    }
    var productChanged = String(state.selectedProductId) !== String(product.id);
    state.selectedProductId = product.id;
    state.patternHint = inferPatternFromProduct(product);
    if (productChanged) {
      var fromAutoplay = !!opts.fromTimer;
      var productSource =
        opts.source || (fromAutoplay ? 'slideshow' : 'unknown');
      trackOrient('orient_product', {
        step: 'Product',
        choice: product.title || '',
        handle: product.handle || '',
        productTitle: product.title || '',
        source: productSource,
        autoplay: fromAutoplay,
      });
      // view_item alleen bij bewuste selectie — niet tijdens slideshow/autoplay
      if (!fromAutoplay) {
        trackOrient('view_item', {
          handle: product.handle || '',
          productTitle: product.title || '',
          source: 'orientatie',
        });
      }
    }

    if (opts.scrollDetailTop && els.detailScroll) {
      els.detailScroll.scrollTop = 0;
    }

    // Update selected row without rebuilding list (preserve scroll) when possible
    if (els.list) {
      els.list.querySelectorAll('[data-uf-orient-row]').forEach(function (row) {
        var on = String(row.getAttribute('data-product-id')) === String(product.id);
        row.classList.toggle('is-selected', on);
        row.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    setDetailLoading(true);
    var handle = product.handle;
    fetchProductJs(handle)
      .then(function (sp) {
        if (String(state.selectedProductId) !== String(product.id)) return;
        renderDetail(product, sp);
        writeUrl();
      })
      .catch(function () {
        if (String(state.selectedProductId) !== String(product.id)) return;
        renderDetail(product, null);
        writeUrl();
      });
  }

  function updateFavoriteUi() {
    if (els.list) {
      els.list.querySelectorAll('[data-uf-orient-fav]').forEach(function (btn) {
        var id = Number(btn.getAttribute('data-uf-orient-fav'));
        var on = isFavorite(id);
        btn.classList.toggle('is-on', on);
        btn.textContent = on ? '♥' : '♡';
      });
      els.list.querySelectorAll('[data-uf-orient-cmp]').forEach(function (btn) {
        var id = Number(btn.getAttribute('data-uf-orient-cmp'));
        btn.classList.toggle('is-on', isCompare(id));
      });
    }
  }

  function renderWishlistBar() {
    var ids = state.favoriteProductIds;
    if (els.wishlistCount) els.wishlistCount.textContent = String(ids.length);
    if (els.favBadge) {
      if (ids.length) {
        els.favBadge.hidden = false;
        els.favBadge.textContent = String(ids.length);
      } else {
        els.favBadge.hidden = true;
      }
    }
    if (els.compareCount) {
      els.compareCount.textContent = String(state.comparisonProductIds.length);
    }
    if (els.compareOpen) {
      els.compareOpen.disabled = state.comparisonProductIds.length < 2;
    }
    var likeSelected = selectedFromLikeListIds().length;
    if (els.offerteCount) {
      els.offerteCount.textContent = String(likeSelected);
    }
    if (els.offerteOpen) {
      els.offerteOpen.disabled = likeSelected < 1;
    }
    if (!els.wishlistThumbs) return;
    els.wishlistThumbs.innerHTML = ids
      .map(function (id) {
        var p = catalogById[id];
        if (!p) return '';
        var img = p.thumb_144 || p.main_600 || '';
        var selected = isCompare(id);
        var idAttr = escapeHtml(String(id));
        var title = escapeHtml(p.title || '');
        return (
          '<article class="uf-orient__wishlist-thumb' +
          (selected ? ' is-compare' : '') +
          '" data-uf-orient-wish-card="' +
          idAttr +
          '">' +
          '<div class="uf-orient__wishlist-thumb-media" data-uf-orient-wish-select="' +
          idAttr +
          '" role="button" tabindex="0" aria-pressed="' +
          (selected ? 'true' : 'false') +
          '" title="' +
          title +
          (selected ? ' (geselecteerd)' : ' — selecteren') +
          '">' +
          (img ? '<img src="' + escapeHtml(img) + '" alt="' + title + '">' : '') +
          '<button type="button" class="uf-orient__wishlist-thumb-x" data-uf-orient-wish-remove="' +
          idAttr +
          '" aria-label="Verwijderen">×</button>' +
          '</div>' +
          '<button type="button" class="uf-orient__wishlist-thumb-select' +
          (selected ? ' is-on' : '') +
          '" data-uf-orient-wish-select="' +
          idAttr +
          '" aria-pressed="' +
          (selected ? 'true' : 'false') +
          '">' +
          (selected ? 'Geselecteerd' : 'Selecteer') +
          '</button></article>'
        );
      })
      .join('');
  }

  function openCompare() {
    var products = state.comparisonProductIds
      .map(function (id) {
        return catalogById[id];
      })
      .filter(Boolean)
      .slice(0, COMPARE_LIMIT);
    if (products.length < 2 || !els.compareDialog || !els.compareBody) return;
    trackOrient('orient_compare_open', {
      step: 'Vergelijking',
      choice: products
        .map(function (product) {
          return product.title;
        })
        .join(' · ')
        .slice(0, 180),
    });
    trackOrientModal('open', 'compare');
    lastFocusBeforeDialog = document.activeElement;
    els.compareBody.innerHTML =
      '<div class="uf-orient__compare-grid" data-cols="' +
      products.length +
      '">' +
      products
        .map(function (p) {
          var totals = calcTotals(p);
          var img = p.main_600 || p.thumb_144 || '';
          var priceDd = buildM2PriceHtml(p);
          var totalDd =
            Number(state.areaM2) > 0
              ? '<span class="uf-orient__price-now">' +
                escapeHtml(formatMoney(totals.totalCents)) +
                '</span>' +
                (totals.savingsCents > 0
                  ? '<span class="uf-orient__price-save"> · Bespaar ' +
                    escapeHtml(formatMoney(totals.savingsCents)) +
                    '</span>'
                  : '')
              : '—';
          if (Number(state.areaM2) > 0 && totals.compareAtTotalCents > totals.totalCents) {
            totalDd =
              '<s class="uf-orient__price-compare">' +
              escapeHtml(formatMoney(totals.compareAtTotalCents)) +
              '</s> ' +
              totalDd;
          }
          return (
            '<article class="uf-orient__compare-card">' +
            (img
              ? '<img src="' + escapeHtml(img) + '" alt="' + escapeHtml(p.title || '') + '">'
              : '') +
            '<h3>' +
            escapeHtml(p.title || '') +
            '</h3>' +
            '<dl>' +
            '<dt>Prijs / m²</dt><dd>' +
            priceDd +
            '</dd>' +
            '<dt>Vloerprijs</dt><dd>' +
            totalDd +
            '</dd>' +
            '<dt>Legmethode</dt><dd>' +
            escapeHtml(propFromTags(p.tags, ['pvctype', 'type']) || '—') +
            '</dd>' +
            '<dt>Totale dikte</dt><dd>' +
            escapeHtml(propFromTags(p.tags, ['dikte', 'totale dikte']) || '—') +
            '</dd>' +
            '<dt>Slijtlaag</dt><dd>' +
            escapeHtml(propFromTags(p.tags, ['slijtlaag']) || '—') +
            '</dd>' +
            '<dt>Vloerverwarming</dt><dd>' +
            escapeHtml(
              propFromTags(p.tags, ['vloerverwarming', 'vvw']) ||
                (productVvwKeys(p.tags)[0]
                  ? displayLabel(productVvwKeys(p.tags)[0])
                  : '—')
            ) +
            '</dd></dl></article>'
          );
        })
        .join('') +
      '</div>';
    els.compareDialog.hidden = false;
    var closeBtn = els.compareDialog.querySelector('[data-uf-orient-compare-close]');
    if (closeBtn) closeBtn.focus();
  }

  function closeCompare(reason) {
    if (!els.compareDialog) return;
    var wasOpen = !els.compareDialog.hidden;
    els.compareDialog.hidden = true;
    if (wasOpen) {
      trackOrientModal('close', 'compare', { reason: reason || 'dismiss' });
    }
    if (lastFocusBeforeDialog && lastFocusBeforeDialog.focus) {
      try {
        lastFocusBeforeDialog.focus();
      } catch (e) {
        /* ignore */
      }
    }
  }

  function selectedFromLikeListIds() {
    return state.comparisonProductIds
      .filter(function (id) {
        return isFavorite(id);
      })
      .slice(0, COMPARE_LIMIT);
  }

  function selectedWishlistProducts() {
    return selectedFromLikeListIds()
      .map(function (id) {
        return catalogById[id];
      })
      .filter(Boolean);
  }

  function trackerApiBase() {
    var endpoint = '';
    try {
      endpoint =
        (window.UF_ANALYTICS && window.UF_ANALYTICS.endpoint) ||
        'https://tracker.urbanfloors.nl';
    } catch (e) {
      endpoint = 'https://tracker.urbanfloors.nl';
    }
    return String(endpoint || 'https://tracker.urbanfloors.nl').replace(/\/$/, '');
  }

  function ufFetch(url, opts) {
    if (window.UF_OFFLINE && typeof window.UF_OFFLINE.fetch === 'function') {
      return window.UF_OFFLINE.fetch(url, opts);
    }
    return fetch(url, opts);
  }

  function activeOffertePromoCode() {
    var api = window.UF_LF_ACTIE;
    if (!api || typeof api.findState !== 'function') return '';
    try {
      var st = api.findState(new Date());
      if (!st || st.mode !== 'active' || !st.entry) return '';
      return String(st.entry.code || st.entry.promo || st.entry.name || '').trim();
    } catch (e) {
      return '';
    }
  }

  function openOfferte() {
    var products = selectedWishlistProducts();
    if (!products.length || !els.offerteDialog || !els.offerteBody) return;
    trackOrient('orient_offerte_open', {
      step: 'Offerte',
      choice: products
        .map(function (product) {
          return product.title;
        })
        .join(' · ')
        .slice(0, 180),
    });
    trackOrientModal('open', 'offerte');
    lastFocusBeforeDialog = document.activeElement;
    var areaVal =
      state.areaM2 > 0 ? String(Math.round(state.areaM2 * 100) / 100).replace('.', ',') : '';
    var countLabel =
      products.length === 1
        ? '1 geselecteerde vloer'
        : products.length + ' geselecteerde vloeren';
    var picksHtml = products
      .map(function (p, index) {
        var img = p.thumb_144 || p.main_600 || '';
        var brand = brandOf(p);
        var waste = wastePctFor(inferPatternFromProduct(p));
        return (
          '<article class="uf-orient__offerte-pick">' +
          '<span class="uf-orient__offerte-pick-index">' +
          (index + 1) +
          '</span>' +
          (img
            ? '<img src="' + escapeHtml(img) + '" alt="' + escapeHtml(p.title || '') + '">'
            : '<span class="uf-orient__offerte-pick-ph" aria-hidden="true"></span>') +
          '<div class="uf-orient__offerte-pick-copy">' +
          '<strong>' +
          escapeHtml(p.title || '') +
          '</strong>' +
          '<span>' +
          escapeHtml(
            (brand ? brand + ' · ' : '') + 'snijverlies ' + String(waste).replace('.', ',') + '%'
          ) +
          '</span></div></article>'
        );
      })
      .join('');
    els.offerteBody.innerHTML =
      '<form class="uf-orient__offerte-form" data-uf-orient-offerte-form novalidate>' +
      '<div class="uf-orient__offerte-scroll">' +
      '<section class="uf-orient__offerte-section">' +
      '<div class="uf-orient__offerte-section-head">' +
      '<h3>Geselecteerde vloeren</h3>' +
      '<span class="uf-orient__offerte-badge">' +
      escapeHtml(countLabel) +
      '</span></div>' +
      '<p class="uf-orient__offerte-lead">Je ontvangt per vloer een aparte offerte per e-mail, met snijverlies en actuele prijzen.</p>' +
      '<div class="uf-orient__offerte-picks">' +
      picksHtml +
      '</div></section>' +
      '<section class="uf-orient__offerte-section">' +
      '<div class="uf-orient__offerte-section-head"><h3>Ruimte</h3></div>' +
      '<label class="uf-orient__offerte-field"><span>Oppervlakte (m²)<abbr title="verplicht">*</abbr></span>' +
      '<input name="areaM2" type="text" inputmode="decimal" required value="' +
      escapeHtml(areaVal) +
      '" placeholder="bijv. 42"></label>' +
      '<p class="uf-orient__offerte-hint">Snijverlies wordt per vloer berekend voor <strong>' +
      escapeHtml(wasteModeLabel()) +
      '</strong>.</p></section>' +
      '<section class="uf-orient__offerte-section">' +
      '<div class="uf-orient__offerte-section-head"><h3>Jouw gegevens</h3></div>' +
      '<div class="uf-orient__offerte-row">' +
      '<label class="uf-orient__offerte-field"><span>Naam<abbr title="verplicht">*</abbr></span>' +
      '<input name="customerName" type="text" autocomplete="name" required placeholder="Voor- en achternaam"></label>' +
      '<label class="uf-orient__offerte-field"><span>E-mail<abbr title="verplicht">*</abbr></span>' +
      '<input name="customerEmail" type="email" autocomplete="email" required placeholder="naam@email.nl"></label>' +
      '</div>' +
      '<label class="uf-orient__offerte-field"><span>Telefoon</span>' +
      '<input name="customerPhone" type="tel" autocomplete="tel" placeholder="Optioneel"></label>' +
      '<label class="uf-orient__offerte-field"><span>Adres</span>' +
      '<input name="customerAddress" type="text" autocomplete="street-address" placeholder="Straat en huisnummer"></label>' +
      '<div class="uf-orient__offerte-row">' +
      '<label class="uf-orient__offerte-field"><span>Postcode</span>' +
      '<input name="customerZip" type="text" autocomplete="postal-code" placeholder="1234 AB"></label>' +
      '<label class="uf-orient__offerte-field"><span>Plaats</span>' +
      '<input name="customerCity" type="text" autocomplete="address-level2" placeholder="Woonplaats"></label>' +
      '</div></section>' +
      '<p class="uf-orient__offerte-trust">Vrijblijvend · Geen spam · Reactie meestal binnen 1 werkdag</p>' +
      '<p class="uf-orient__offerte-error" data-uf-orient-offerte-error hidden></p>' +
      '<div class="uf-orient__offerte-success" data-uf-orient-offerte-success hidden></div>' +
      '</div>' +
      '<div class="uf-orient__offerte-actions">' +
      '<button type="button" class="uf-orient__offerte-cancel" data-uf-orient-offerte-close>Annuleren</button>' +
      '<button type="submit" class="uf-orient__offerte-submit" data-uf-orient-offerte-submit>' +
      (products.length === 1 ? 'Offerte aanvragen' : 'Offertes aanvragen') +
      '</button></div></form>';
    els.offerteDialog.hidden = false;
    document.documentElement.classList.add('uf-orient-offerte-open');
    var firstInput = els.offerteBody.querySelector(
      state.areaM2 > 0 ? 'input[name="customerName"]' : 'input[name="areaM2"]'
    );
    if (firstInput) firstInput.focus();
  }

  function closeOfferte(reason) {
    if (!els.offerteDialog) return;
    var wasOpen = !els.offerteDialog.hidden;
    els.offerteDialog.hidden = true;
    document.documentElement.classList.remove('uf-orient-offerte-open');
    if (wasOpen) {
      trackOrientModal('close', 'offerte', { reason: reason || 'dismiss' });
    }
    if (lastFocusBeforeDialog && lastFocusBeforeDialog.focus) {
      try {
        lastFocusBeforeDialog.focus();
      } catch (e) {
        /* ignore */
      }
    }
  }

  function parseAreaInput(raw) {
    var n = Number(String(raw || '').replace(/\s/g, '').replace(',', '.'));
    return isFinite(n) && n > 0 ? Math.round(n * 100) / 100 : 0;
  }

  function postOfferteForProduct(product, customer, areaM2, opts) {
    opts = opts || {};
    var handle = product.handle;
    if (!handle) return Promise.reject(new Error('Product zonder handle'));
    var pattern = inferPatternFromProduct(product);
    var wastePct = wastePctFor(pattern);
    var promo = activeOffertePromoCode();
    return fetchProductJs(handle).then(function (sp) {
      var variant =
        (sp.variants &&
          sp.variants.find(function (v) {
            return v.available;
          })) ||
        (sp.variants && sp.variants[0]) ||
        null;
      if (!variant || !variant.id) {
        throw new Error('Geen variant voor ' + (product.title || handle));
      }
      var payload = {
        handle: handle,
        variantId: String(variant.id),
        areaM2: areaM2,
        wastePct: wastePct,
        discountCode: promo,
        discountCodes: promo ? [promo] : [],
        customerName: customer.customerName,
        customerEmail: customer.customerEmail,
        customerPhone: customer.customerPhone,
        customerAddress: customer.customerAddress,
        customerZip: customer.customerZip,
        customerCity: customer.customerCity,
        skipEmail: Boolean(opts.skipEmail),
      };
      return ufFetch(trackerApiBase() + '/api/offertes', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'omit',
        body: JSON.stringify(payload),
      }).then(function (res) {
        return res.text().then(function (text) {
          var body = {};
          if (text) {
            try {
              body = JSON.parse(text);
            } catch (err) {
              throw new Error(
                res.ok
                  ? 'Ongeldig antwoord van de server.'
                  : 'Offerte-server is niet bereikbaar.'
              );
            }
          }
          if (!res.ok) {
            throw new Error(body.error || 'Offerte maken mislukt voor ' + (product.title || handle));
          }
          body._productTitle = product.title || handle;
          return body;
        });
      });
    });
  }

  function createOfferteOverview(customer, results) {
    var tokens = (results || [])
      .map(function (body) {
        return body && body.token ? String(body.token) : '';
      })
      .filter(Boolean);
    if (!tokens.length) {
      return Promise.reject(new Error('Geen offertes om te bundelen'));
    }
    return ufFetch(trackerApiBase() + '/api/offertes/overview', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'omit',
      body: JSON.stringify({
        customerEmail: customer.customerEmail,
        customerName: customer.customerName,
        tokens: tokens,
        sendEmail: true,
      }),
    }).then(function (res) {
      return res.text().then(function (text) {
        var body = {};
        if (text) {
          try {
            body = JSON.parse(text);
          } catch (err) {
            throw new Error(
              res.ok
                ? 'Ongeldig antwoord van de server.'
                : 'Overzicht maken mislukt.'
            );
          }
        }
        if (!res.ok) throw new Error(body.error || 'Overzicht maken mislukt');
        return body;
      });
    });
  }

  function submitOfferteForm(form) {
    var errorEl = form.querySelector('[data-uf-orient-offerte-error]');
    var successEl = form.querySelector('[data-uf-orient-offerte-success]');
    var submitBtn = form.querySelector('[data-uf-orient-offerte-submit]');
    function showError(msg) {
      if (errorEl) {
        errorEl.hidden = false;
        errorEl.textContent = msg;
      }
      if (successEl) successEl.hidden = true;
    }
    function clearError() {
      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }
    }
    var products = selectedWishlistProducts();
    if (!products.length) {
      showError('Selecteer eerst maximaal 3 vloeren in je like-lijst.');
      return;
    }
    var areaM2 = parseAreaInput(form.elements.areaM2 && form.elements.areaM2.value);
    var customerName = String((form.elements.customerName && form.elements.customerName.value) || '').trim();
    var customerEmail = String((form.elements.customerEmail && form.elements.customerEmail.value) || '').trim();
    form.querySelectorAll('.is-invalid').forEach(function (el) {
      el.classList.remove('is-invalid');
    });
    var invalid = false;
    if (!(areaM2 > 0)) {
      if (form.elements.areaM2) form.elements.areaM2.classList.add('is-invalid');
      invalid = true;
    }
    if (customerName.length < 2) {
      if (form.elements.customerName) form.elements.customerName.classList.add('is-invalid');
      invalid = true;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(customerEmail)) {
      if (form.elements.customerEmail) form.elements.customerEmail.classList.add('is-invalid');
      invalid = true;
    }
    if (invalid) {
      showError('Controleer de gemarkeerde velden.');
      return;
    }
    clearError();
    if (successEl) successEl.hidden = true;
    var customer = {
      customerName: customerName,
      customerEmail: customerEmail,
      customerPhone: String((form.elements.customerPhone && form.elements.customerPhone.value) || '').trim(),
      customerAddress: String((form.elements.customerAddress && form.elements.customerAddress.value) || '').trim(),
      customerZip: String((form.elements.customerZip && form.elements.customerZip.value) || '').trim(),
      customerCity: String((form.elements.customerCity && form.elements.customerCity.value) || '').trim(),
    };
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Bezig...';
    }
    var chain = Promise.resolve([]);
    products.forEach(function (product) {
      chain = chain.then(function (results) {
        return postOfferteForProduct(product, customer, areaM2, { skipEmail: true }).then(
          function (body) {
            results.push(body);
            return results;
          }
        );
      });
    });
    chain
      .then(function (results) {
        return createOfferteOverview(customer, results).then(function (overview) {
          return { results: results, overview: overview };
        });
      })
      .then(function (payload) {
        var results = payload.results || [];
        var overview = payload.overview || {};
        var overviewUrl = overview.overviewUrl || '';
        trackOrient('orient_offerte_submit', {
          step: 'Offerte verstuurd',
          choice: String(results.length) + ' offertes',
        });
        trackOrientModal('succeed', 'offerte', {
          choice: String(results.length) + ' offertes',
        });
        if (successEl) {
          successEl.hidden = false;
          successEl.innerHTML =
            '<p class="uf-orient__offerte-success-title">Offerte' +
            (results.length === 1 ? '' : 's') +
            ' verstuurd</p>' +
            '<p>We hebben een overzicht met ' +
            results.length +
            ' offerte' +
            (results.length === 1 ? '' : 's') +
            ' naar <strong>' +
            escapeHtml(customerEmail) +
            '</strong> gestuurd.</p>' +
            (overviewUrl
              ? '<p class="uf-orient__offerte-overview-link"><a href="' +
                escapeHtml(overviewUrl) +
                '" target="_blank" rel="noopener">Open je offerte-overzicht</a></p>'
              : '') +
            '<ul class="uf-orient__offerte-result-list">' +
            results
              .map(function (body) {
                var label = escapeHtml(body._productTitle || body.number || 'Offerte');
                var num = escapeHtml(body.number || '');
                var link = body.printUrl
                  ? '<a href="' +
                    escapeHtml(body.printUrl) +
                    '" target="_blank" rel="noopener">Bekijken</a>'
                  : '';
                return (
                  '<li><span>' +
                  label +
                  (num ? '<small>' + num + '</small>' : '') +
                  '</span>' +
                  link +
                  '</li>'
                );
              })
              .join('') +
            '</ul>';
        }
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Verstuurd';
        }
        form.querySelectorAll('input').forEach(function (inp) {
          inp.disabled = true;
        });
      })
      .catch(function (err) {
        var msg = err && err.message ? err.message : 'Er ging iets mis.';
        var down =
          (window.UF_OFFLINE &&
            typeof window.UF_OFFLINE.isDown === 'function' &&
            window.UF_OFFLINE.isDown(err)) ||
          /failed to fetch|networkerror|load failed|niet bereikbaar/i.test(msg);
        if (down) {
          var shopify =
            window.UF_OFFLINE && typeof window.UF_OFFLINE.postContact === 'function'
              ? window.UF_OFFLINE.postContact({
                  email: customerEmail,
                  name: customerName,
                  phone: customer.customerPhone,
                  tags: 'offerte-aanvraag',
                  body: [
                    'Offerte oriëntatieruimte (Shopify-fallback)',
                    'Naam: ' + customerName,
                    'E-mail: ' + customerEmail,
                    'm²: ' + areaM2,
                    'Producten:',
                    products
                      .map(function (p) {
                        return '- ' + (p.title || p.handle || '');
                      })
                      .join('\n'),
                    '',
                    'UF_OFFERTE_V1',
                    JSON.stringify({
                      customer: customer,
                      areaM2: areaM2,
                      products: products.map(function (p) {
                        return {
                          handle: p.handle,
                          title: p.title,
                          areaM2: areaM2,
                          wastePct: wastePctFor(inferPatternFromProduct(p)),
                        };
                      }),
                    }),
                  ].join('\n'),
                })
              : Promise.reject(new Error('Shopify contact ontbreekt'));
          return shopify
            .then(function () {
              if (successEl) {
                successEl.hidden = false;
                successEl.innerHTML =
                  '<p class="uf-orient__offerte-success-title">Aanvraag ontvangen</p>' +
                  '<p>De offerte-server is even offline. We hebben je aanvraag via Shopify binnengekregen en mailen ' +
                  escapeHtml(customerEmail) +
                  ' zodra de offertes klaarstaan.</p>';
              }
              if (submitBtn) {
                submitBtn.disabled = true;
                submitBtn.textContent = 'Ontvangen';
              }
            })
            .catch(function () {
              msg =
                'Offerte-server is even offline. Mail info@urbanfloors.nl of bel 085-0603648. We openen een mail met je gegevens.';
              if (window.UF_OFFLINE && typeof window.UF_OFFLINE.openMail === 'function') {
                window.UF_OFFLINE.openMail(
                  'Offerte oriëntatieruimte',
                  [
                    'Offerte-aanvraag (dashboard offline)',
                    'Naam: ' + customerName,
                    'E-mail: ' + customerEmail,
                    'm²: ' + areaM2,
                    'Producten:',
                    products
                      .map(function (p) {
                        return '- ' + (p.title || p.handle || '');
                      })
                      .join('\n'),
                    'Pagina: ' + (location.href || ''),
                  ].join('\n')
                );
              }
              showError(msg);
              if (submitBtn) {
                submitBtn.disabled = false;
                submitBtn.textContent = 'Offerte aanvragen';
              }
            });
        }
        showError(msg);
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = 'Offertes aanvragen';
        }
      });
  }

  function flashCompareLimit() {
    var bar = root.querySelector('[data-uf-orient-wishlist-bar]');
    if (!bar) return;
    bar.classList.remove('is-limit-flash');
    void bar.offsetWidth;
    bar.classList.add('is-limit-flash');
    window.setTimeout(function () {
      bar.classList.remove('is-limit-flash');
    }, 700);
  }

  function formatReviewScore(n) {
    var v = Number(n);
    if (!isFinite(v) || v <= 0) return '—';
    return String(Math.round(v * 10) / 10).replace('.', ',');
  }

  function reviewStarsHtml(stars) {
    var full = Math.round(Number(stars) || 0);
    if (full < 0) full = 0;
    if (full > 5) full = 5;
    var out = '';
    for (var i = 1; i <= 5; i++) {
      out +=
        '<span class="uf-orient__review-star' +
        (i <= full ? ' is-on' : '') +
        '" aria-hidden="true">★</span>';
    }
    return '<span class="uf-orient__review-stars" aria-label="' + full + ' van 5">' + out + '</span>';
  }

  /** Eenvoudig gemiddelde: (Trustpilot + Google) / 2. */
  function combinedReviewScore(data) {
    if (!data) return 0;
    var sum = 0;
    var n = 0;
    if (data.trustpilot && Number(data.trustpilot.score) > 0) {
      sum += Number(data.trustpilot.score);
      n += 1;
    }
    if (data.google && Number(data.google.score) > 0) {
      sum += Number(data.google.score);
      n += 1;
    }
    if (!(n > 0)) return 0;
    return Math.round((sum / n) * 10) / 10;
  }

  function updateReviewsChip(data) {
    if (!els.reviewsScore) return;
    var score5 = combinedReviewScore(data);
    /* Sitewide: beoordeling op schaal 10 (= gemiddelde 5★ × 2) */
    var score10 = score5 > 0 ? Math.round(score5 * 2 * 10) / 10 : 0;
    els.reviewsScore.textContent = formatReviewScore(score10);
  }

  function formatReviewRelativeDate(raw) {
    if (!raw) return '';
    var d = new Date(raw);
    if (isNaN(d.getTime())) return String(raw);
    var now = new Date();
    var diffMs = now.getTime() - d.getTime();
    if (diffMs < 0) diffMs = 0;
    var mins = Math.floor(diffMs / 60000);
    var hours = Math.floor(diffMs / 3600000);
    var days = Math.floor(diffMs / 86400000);
    if (mins < 60) return mins <= 1 ? 'zojuist' : mins + ' minuten geleden';
    if (hours < 24) return hours === 1 ? '1 uur geleden' : hours + ' uur geleden';
    if (days < 14) return days === 1 ? '1 dag geleden' : days + ' dagen geleden';
    var weeks = Math.floor(days / 7);
    if (days < 45) {
      return weeks === 1 ? '1 week geleden' : weeks + ' weken geleden';
    }
    var months =
      (now.getFullYear() - d.getFullYear()) * 12 + (now.getMonth() - d.getMonth());
    if (now.getDate() < d.getDate()) months -= 1;
    if (months < 1) months = 1;
    if (months < 18) {
      return months === 1 ? '1 maand geleden' : months + ' maanden geleden';
    }
    var years = Math.floor(months / 12);
    return years === 1 ? '1 jaar geleden' : years + ' jaar geleden';
  }

  function reviewCardHtml(item, source) {
    var dateLabel = formatReviewRelativeDate(item.date);
    return (
      '<article class="uf-orient__review-card" data-source="' +
      escapeHtml(source) +
      '">' +
      '<div class="uf-orient__review-card-top">' +
      reviewStarsHtml(item.stars) +
      '<span class="uf-orient__review-source">' +
      escapeHtml(source === 'google' ? 'Google' : 'Trustpilot') +
      '</span>' +
      '</div>' +
      (item.title
        ? '<h3 class="uf-orient__review-title">' + escapeHtml(item.title) + '</h3>'
        : '') +
      '<p class="uf-orient__review-text">' +
      escapeHtml(item.text || '') +
      '</p>' +
      '<div class="uf-orient__review-meta">' +
      '<span class="uf-orient__review-author">' +
      escapeHtml(item.author || 'Anoniem') +
      '</span>' +
      (dateLabel
        ? '<time class="uf-orient__review-date"' +
          (item.date
            ? ' datetime="' + escapeHtml(String(item.date).slice(0, 10)) + '"'
            : '') +
          '>' +
          escapeHtml(dateLabel) +
          '</time>'
        : '') +
      '</div>' +
      '</article>'
    );
  }

  function sourceSummaryHtml(label, source, key) {
    if (!source) return '';
    return (
      '<button type="button" class="uf-orient__reviews-summary-card' +
      (reviewsTab === key ? ' is-active' : '') +
      '" data-uf-orient-reviews-tab="' +
      escapeHtml(key) +
      '">' +
      '<span class="uf-orient__reviews-summary-label">' +
      escapeHtml(label) +
      '</span>' +
      '<strong class="uf-orient__reviews-summary-score">' +
      escapeHtml(formatReviewScore(source.score)) +
      '</strong>' +
      reviewStarsHtml(source.stars || source.score) +
      '<span class="uf-orient__reviews-summary-count">' +
      escapeHtml(String(source.count || 0)) +
      ' reviews</span>' +
      '</button>'
    );
  }

  function renderReviewsBody() {
    if (!els.reviewsBody) return;
    if (reviewsLoading && !reviewsCache) {
      els.reviewsBody.innerHTML =
        '<p class="uf-orient__reviews-loading">Reviews laden…</p>';
      return;
    }
    if (!reviewsCache || (!reviewsCache.google && !reviewsCache.trustpilot)) {
      els.reviewsBody.innerHTML =
        '<p class="uf-orient__reviews-empty">Reviews zijn tijdelijk niet beschikbaar. Probeer het later opnieuw.</p>';
      return;
    }

    var cards = [];
    if (reviewsTab === 'all' || reviewsTab === 'google') {
      (reviewsCache.google && reviewsCache.google.reviews
        ? reviewsCache.google.reviews
        : []
      ).forEach(function (r) {
        cards.push(reviewCardHtml(r, 'google'));
      });
    }
    if (reviewsTab === 'all' || reviewsTab === 'trustpilot') {
      (reviewsCache.trustpilot && reviewsCache.trustpilot.reviews
        ? reviewsCache.trustpilot.reviews
        : []
      ).forEach(function (r) {
        cards.push(reviewCardHtml(r, 'trustpilot'));
      });
    }

    var tabs =
      '<div class="uf-orient__reviews-tabs" role="tablist">' +
      '<button type="button" class="uf-orient__reviews-tab' +
      (reviewsTab === 'all' ? ' is-active' : '') +
      '" data-uf-orient-reviews-tab="all" role="tab" aria-selected="' +
      (reviewsTab === 'all' ? 'true' : 'false') +
      '">Alles</button>' +
      '<button type="button" class="uf-orient__reviews-tab' +
      (reviewsTab === 'google' ? ' is-active' : '') +
      '" data-uf-orient-reviews-tab="google" role="tab" aria-selected="' +
      (reviewsTab === 'google' ? 'true' : 'false') +
      '" ' +
      (!reviewsCache.google ? 'disabled' : '') +
      '>Google</button>' +
      '<button type="button" class="uf-orient__reviews-tab' +
      (reviewsTab === 'trustpilot' ? ' is-active' : '') +
      '" data-uf-orient-reviews-tab="trustpilot" role="tab" aria-selected="' +
      (reviewsTab === 'trustpilot' ? 'true' : 'false') +
      '" ' +
      (!reviewsCache.trustpilot ? 'disabled' : '') +
      '>Trustpilot</button>' +
      '</div>';

    var footLinks = [];
    if (reviewsCache.google && reviewsCache.google.url) {
      footLinks.push(
        '<a href="' +
          escapeHtml(reviewsCache.google.url) +
          '" target="_blank" rel="noopener">Google</a>'
      );
    }
    if (reviewsCache.trustpilot && reviewsCache.trustpilot.url) {
      footLinks.push(
        '<a href="' +
          escapeHtml(reviewsCache.trustpilot.url) +
          '" target="_blank" rel="noopener">Trustpilot</a>'
      );
    }

    els.reviewsBody.innerHTML =
      '<div class="uf-orient__reviews-summaries">' +
      sourceSummaryHtml('Google', reviewsCache.google, 'google') +
      sourceSummaryHtml('Trustpilot', reviewsCache.trustpilot, 'trustpilot') +
      '</div>' +
      tabs +
      '<div class="uf-orient__reviews-list">' +
      (cards.length
        ? cards.join('')
        : '<p class="uf-orient__reviews-empty">Geen reviews voor deze filter.</p>') +
      '</div>' +
      (footLinks.length
        ? '<p class="uf-orient__reviews-foot">Bekijk alle reviews op ' +
          footLinks.join(' · ') +
          '</p>'
        : '');
  }

  function loadReviews() {
    if (reviewsCache || reviewsLoading) {
      return Promise.resolve(reviewsCache);
    }
    reviewsLoading = true;
    return ufFetch(REVIEWS_API, { credentials: 'omit' })
      .then(function (res) {
        if (!res.ok) throw new Error('reviews ' + res.status);
        return res.json();
      })
      .then(function (data) {
        reviewsCache = data || null;
        updateReviewsChip(reviewsCache);
        return reviewsCache;
      })
      .catch(function () {
        reviewsCache = null;
        return null;
      })
      .finally(function () {
        reviewsLoading = false;
      });
  }

  function openReviews() {
    if (!els.reviewsDialog || !els.reviewsBody) return;
    trackOrient('orient_reviews_open', { step: 'Reviews' });
    trackOrientModal('open', 'reviews');
    lastFocusBeforeDialog = document.activeElement;
    reviewsTab = 'all';
    els.reviewsDialog.hidden = false;
    renderReviewsBody();
    loadReviews().then(function () {
      if (els.reviewsDialog && !els.reviewsDialog.hidden) renderReviewsBody();
    });
    var closeBtn = els.reviewsDialog.querySelector('[data-uf-orient-reviews-close]');
    if (closeBtn) closeBtn.focus();
  }

  function closeReviews(reason) {
    if (!els.reviewsDialog) return;
    var wasOpen = !els.reviewsDialog.hidden;
    els.reviewsDialog.hidden = true;
    if (wasOpen) {
      trackOrientModal('close', 'reviews', { reason: reason || 'dismiss' });
    }
    if (lastFocusBeforeDialog && lastFocusBeforeDialog.focus) {
      try {
        lastFocusBeforeDialog.focus();
      } catch (e) {
        /* ignore */
      }
    }
  }

  function stopBrowseSync() {
    if (browseSyncTimer) {
      window.clearInterval(browseSyncTimer);
      browseSyncTimer = null;
    }
  }

  function startBrowseSync() {
    if (browseSyncTimer) return;
    if (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      return;
    }
    browseSyncTimer = window.setInterval(function () {
      if (!els.browseDialog || els.browseDialog.hidden) {
        stopBrowseSync();
        return;
      }
      if (typeof document !== 'undefined' && document.hidden) return;
      browseControllers.forEach(function (c) {
        if (c && typeof c.next === 'function') c.next();
      });
    }, BROWSE_SLIDE_MS);
  }

  function disconnectBrowseLoadMore() {
    if (browseLoadMoreObserver) {
      browseLoadMoreObserver.disconnect();
      browseLoadMoreObserver = null;
    }
  }

  function watchBrowseLoadMore() {
    disconnectBrowseLoadMore();
    if (!els.browseBody) return;
    if (browseShown >= browseProducts.length) return;
    var cards = els.browseBody.querySelectorAll('[data-uf-orient-browse-card]');
    if (!cards.length) return;
    var last = cards[cards.length - 1];
    if (!('IntersectionObserver' in window)) return;

    browseLoadMoreObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || entry.intersectionRatio < 0.66) return;
          if (browseLoadingMore) return;
          if (browseShown >= browseProducts.length) {
            disconnectBrowseLoadMore();
            return;
          }
          browseLoadingMore = true;
          disconnectBrowseLoadMore();
          appendBrowsePage();
          browseLoadingMore = false;
        });
      },
      { root: els.browseBody, threshold: [0, 0.66, 1] }
    );
    browseLoadMoreObserver.observe(last);
  }

  function destroyBrowseCarousels() {
    stopBrowseSync();
    disconnectBrowseLoadMore();
    browseLoadingMore = false;
    if (browseObserver) {
      browseObserver.disconnect();
      browseObserver = null;
    }
    browseControllers.forEach(function (c) {
      if (c && typeof c.destroy === 'function') c.destroy();
    });
    browseControllers = [];
  }

  function browseMetaForProduct(p) {
    var totals = calcTotals(p);
    var typeKeys = productPvctypeKeys(p.tags);
    var kleurKeys = productKleurKeys(p.tags);
    var soortKeys = productSoortKeys(p.tags);
    var typeLabel = typeKeys.length
      ? filterOptionLabel('pvctype', typeKeys[0])
      : propFromTags(p.tags, ['pvctype', 'type', 'soort filter']) || '—';
    var kleurLabel = kleurKeys.length
      ? filterOptionLabel('kleur', kleurKeys[0])
      : propFromTags(p.tags, ['kleur', 'kleur groep']) || '—';
    var merkLabel = brandOf(p) || '—';
    var patroonLabel = soortKeys.length
      ? filterOptionLabel('soort', soortKeys[0])
      : patternLabel(inferPatternFromProduct(p)) || '—';
    var packsLabel =
      totals.hasPack && totals.packCount
        ? String(totals.packCount)
        : state.areaM2 > 0
          ? '—'
          : 'vul m² in';
    var m2Label =
      totals.hasPack && totals.orderedArea
        ? nlNum(totals.orderedArea, 2) + ' m²'
        : state.areaM2 > 0
          ? nlNum(totals.requiredArea || state.areaM2, 2) + ' m²'
          : 'vul m² in';
    var totalLabel =
      totals.totalCents > 0
        ? formatMoney(totals.totalCents)
        : state.areaM2 > 0
          ? '—'
          : 'vul m² in';
    return {
      packs: packsLabel,
      m2: m2Label,
      total: totalLabel,
      type: typeLabel,
      kleur: kleurLabel,
      merk: merkLabel,
      patroon: patroonLabel,
    };
  }

  function browseOverlayHtml(meta) {
    return (
      '<div class="uf-orient__browse-overlay" aria-hidden="true">' +
      '<div class="uf-orient__browse-overlay-col uf-orient__browse-overlay-col--totals">' +
      '<span class="uf-orient__browse-overlay-item"><span class="uf-orient__browse-overlay-label">Pakken</span><strong>' +
      escapeHtml(meta.packs) +
      '</strong></span>' +
      '<span class="uf-orient__browse-overlay-item"><span class="uf-orient__browse-overlay-label">m²</span><strong>' +
      escapeHtml(meta.m2) +
      '</strong></span>' +
      '<span class="uf-orient__browse-overlay-item uf-orient__browse-overlay-item--total"><span class="uf-orient__browse-overlay-label">Totaal</span><strong>' +
      escapeHtml(meta.total) +
      '</strong></span>' +
      '</div>' +
      '<div class="uf-orient__browse-overlay-col uf-orient__browse-overlay-col--meta">' +
      '<span class="uf-orient__browse-chip">' +
      escapeHtml(meta.type) +
      '</span>' +
      '<span class="uf-orient__browse-chip">' +
      escapeHtml(meta.kleur) +
      '</span>' +
      '<span class="uf-orient__browse-chip">' +
      escapeHtml(meta.merk) +
      '</span>' +
      '<span class="uf-orient__browse-chip">' +
      escapeHtml(meta.patroon) +
      '</span>' +
      '</div>' +
      '</div>'
    );
  }

  function refreshBrowseOverlays() {
    if (!els.browseBody || !els.browseDialog || els.browseDialog.hidden) return;
    els.browseBody.querySelectorAll('[data-uf-orient-browse-card]').forEach(function (card) {
      var id = card.getAttribute('data-product-id');
      var p = catalogById[id] || catalogById[Number(id)];
      if (!p) return;
      var overlay = card.querySelector('.uf-orient__browse-overlay');
      if (!overlay) return;
      var wrap = document.createElement('div');
      wrap.innerHTML = browseOverlayHtml(browseMetaForProduct(p));
      if (wrap.firstChild) overlay.replaceWith(wrap.firstChild);
    });
  }

  function browseCardHtml(p) {
    var id = String(p.id);
    var img = p.main_600 || p.thumb_144 || '';
    var selected = String(state.selectedProductId) === id;
    var meta = browseMetaForProduct(p);
    return (
      '<article class="uf-orient__browse-card' +
      (selected ? ' is-selected' : '') +
      '" data-uf-orient-browse-card data-product-id="' +
      escapeHtml(id) +
      '" data-product-handle="' +
      escapeHtml(p.handle || '') +
      '" tabindex="0" role="button" aria-label="' +
      escapeHtml(p.title || 'Product') +
      '">' +
      '<div class="uf-orient__browse-carousel" data-uf-orient-browse-carousel>' +
      '<div class="uf-orient__browse-viewport" data-uf-orient-browse-viewport>' +
      (img
        ? '<img src="' +
          escapeHtml(img) +
          '" alt="' +
          escapeHtml(p.main_alt || p.title || '') +
          '" data-uf-orient-browse-hero loading="lazy">'
        : '<img alt="" data-uf-orient-browse-hero>') +
      '<h3 class="uf-orient__browse-card-title">' +
      escapeHtml(p.title || '') +
      '</h3>' +
      browseOverlayHtml(meta) +
      '</div>' +
      '</div>' +
      '</article>'
    );
  }

  function bindBrowseCarousel(card, images) {
    var rootEl = card.querySelector('[data-uf-orient-browse-carousel]');
    var viewport = card.querySelector('[data-uf-orient-browse-viewport]');
    var imgEl = card.querySelector('[data-uf-orient-browse-hero]');
    if (!rootEl || !viewport || !imgEl || !images || !images.length) return null;

    var existingNav = rootEl.querySelectorAll('[data-uf-orient-browse-nav]');
    Array.prototype.forEach.call(existingNav, function (n) {
      if (n.parentNode) n.parentNode.removeChild(n);
    });

    var idx = 0;
    var animating = false;
    var destroyed = false;

    function setIndexImmediate(i) {
      if (!images.length || !imgEl) return;
      idx = ((i % images.length) + images.length) % images.length;
      var item = images[idx];
      if (!item) return;
      imgEl.src = item.src;
      imgEl.alt = item.alt || '';
    }

    function slideToNext() {
      if (destroyed || animating || images.length <= 1 || !imgEl || !viewport) return;
      if (
        window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ) {
        setIndexImmediate(idx + 1);
        return;
      }

      var nextIdx = (idx + 1) % images.length;
      var item = images[nextIdx];
      if (!item) return;
      animating = true;

      var incoming = imgEl.cloneNode(false);
      incoming.removeAttribute('data-uf-orient-browse-hero');
      incoming.className = 'uf-orient__browse-hero--incoming';
      incoming.alt = item.alt || '';
      incoming.src = item.src;
      viewport.appendChild(incoming);

      imgEl.classList.remove('is-browse-slide-out');
      window.requestAnimationFrame(function () {
        if (destroyed) return;
        imgEl.classList.add('is-browse-slide-out');
        incoming.classList.add('is-browse-slide-in');
      });

      var done = false;
      function finishSwap() {
        if (done || destroyed) return;
        done = true;
        animating = false;
        idx = nextIdx;
        if (imgEl && imgEl.parentNode) imgEl.remove();
        incoming.classList.remove(
          'uf-orient__browse-hero--incoming',
          'is-browse-slide-in'
        );
        incoming.setAttribute('data-uf-orient-browse-hero', '');
        imgEl = incoming;
      }

      incoming.addEventListener('transitionend', finishSwap, { once: true });
      window.setTimeout(finishSwap, 480);
    }

    setIndexImmediate(0);
    startBrowseSync();
    return {
      next: slideToNext,
      destroy: function () {
        destroyed = true;
      },
    };
  }

  function hydrateBrowseCard(card) {
    if (!card || card.getAttribute('data-browse-hydrated') === '1') return;
    card.setAttribute('data-browse-hydrated', '1');
    var handle = card.getAttribute('data-product-handle');
    var id = card.getAttribute('data-product-id');
    var catalogProduct = catalogById[id] || catalogById[Number(id)];
    var fallback = [];
    if (catalogProduct && (catalogProduct.main_600 || catalogProduct.thumb_144)) {
      fallback.push({
        src: catalogProduct.main_600 || catalogProduct.thumb_144,
        alt: catalogProduct.main_alt || catalogProduct.title || '',
      });
    }
    if (!handle) {
      var ctrl0 = bindBrowseCarousel(card, fallback);
      if (ctrl0) browseControllers.push(ctrl0);
      return;
    }
    fetchProductJs(handle)
      .then(function (sp) {
        if (!els.browseDialog || els.browseDialog.hidden) return;
        if (!card.isConnected) return;
        var images = collectGalleryImages(sp, catalogProduct);
        if (!images.length) images = fallback;
        var ctrl = bindBrowseCarousel(card, images);
        if (ctrl) browseControllers.push(ctrl);
      })
      .catch(function () {
        var ctrl = bindBrowseCarousel(card, fallback);
        if (ctrl) browseControllers.push(ctrl);
      });
  }

  function observeBrowseCards(scope) {
    if (!els.browseBody) return;
    var rootScope = scope || els.browseBody;
    var cards = rootScope.querySelectorAll
      ? rootScope.querySelectorAll('[data-uf-orient-browse-card]:not([data-browse-observed])')
      : [];
    if (!cards.length && rootScope.matches && rootScope.matches('[data-uf-orient-browse-card]')) {
      cards = [rootScope];
    }
    if (!cards.length) return;
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(cards, function (card) {
        card.setAttribute('data-browse-observed', '1');
        hydrateBrowseCard(card);
      });
      return;
    }
    if (!browseObserver) {
      browseObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            hydrateBrowseCard(entry.target);
            browseObserver.unobserve(entry.target);
          });
        },
        { root: els.browseBody, rootMargin: '160px 0px', threshold: 0.01 }
      );
    }
    Array.prototype.forEach.call(cards, function (card) {
      card.setAttribute('data-browse-observed', '1');
      browseObserver.observe(card);
    });
  }

  function appendBrowsePage() {
    if (!els.browseBody || !browseProducts.length) return;
    var next = browseProducts.slice(browseShown, browseShown + BROWSE_PAGE);
    if (!next.length) return;
    var wrap = document.createElement('div');
    wrap.innerHTML = next.map(browseCardHtml).join('');
    var frag = document.createDocumentFragment();
    while (wrap.firstChild) frag.appendChild(wrap.firstChild);
    var moreBtn = els.browseBody.querySelector('[data-uf-orient-browse-more]');
    if (moreBtn) {
      els.browseBody.insertBefore(frag, moreBtn);
    } else {
      els.browseBody.appendChild(frag);
    }
    browseShown += next.length;
    updateBrowseMoreBtn();
    observeBrowseCards(els.browseBody);
    watchBrowseLoadMore();
  }

  function updateBrowseMoreBtn() {
    if (!els.browseBody) return;
    var remaining = browseProducts.length - browseShown;
    var btn = els.browseBody.querySelector('[data-uf-orient-browse-more]');
    if (remaining <= 0) {
      if (btn && btn.parentNode) btn.parentNode.removeChild(btn);
      disconnectBrowseLoadMore();
      return;
    }
    if (!btn) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'uf-orient__browse-more';
      btn.setAttribute('data-uf-orient-browse-more', '');
      els.browseBody.appendChild(btn);
    }
    btn.textContent = 'Meer laden (' + remaining + ' over)';
  }

  function renderBrowseBody() {
    if (!els.browseBody) return;
    destroyBrowseCarousels();
    browseProducts = filteredCatalog();
    browseShown = 0;
    if (els.browseCount) {
      els.browseCount.textContent =
        browseProducts.length === 1 ? '1 vloer' : browseProducts.length + ' vloeren';
    }
    if (!browseProducts.length) {
      els.browseBody.innerHTML =
        '<p class="uf-orient__browse-empty">Geen vloeren gevonden. Pas je filters aan.</p>';
      return;
    }
    els.browseBody.innerHTML = '';
    appendBrowsePage();
  }

  function ensureBrowseEls() {
    if (!els.browseOpen) els.browseOpen = root.querySelector('[data-uf-orient-browse-open]');
    if (!els.browseDialog) {
      els.browseDialog =
        root.querySelector('[data-uf-orient-browse-dialog]') ||
        document.querySelector('[data-uf-orient-browse-dialog]');
    }
    if (els.browseDialog) {
      if (!els.browseBody) {
        els.browseBody = els.browseDialog.querySelector('[data-uf-orient-browse-body]');
      }
      if (!els.browseCount) {
        els.browseCount = els.browseDialog.querySelector('[data-uf-orient-browse-count]');
      }
      if (!els.browseArea) {
        els.browseArea = els.browseDialog.querySelector('[data-uf-orient-browse-area]');
      }
      if (!els.browseSort) {
        els.browseSort = els.browseDialog.querySelector('[data-uf-orient-browse-sort]');
      }
      els.browseWasteBtns = els.browseDialog.querySelectorAll(
        '[data-uf-orient-browse-waste-mode]'
      );
    }
  }

  function syncBrowseSortUi() {
    var val = state.sortBy || 'featured';
    if (els.sort) els.sort.value = val;
    if (els.browseSort) els.browseSort.value = val;
  }

  function setSortBy(next, opts) {
    opts = opts || {};
    state.sortBy = next || 'featured';
    syncBrowseSortUi();
    applyAndRender({ scrollDetailTop: true });
    writeUrl();
    if (els.browseDialog && !els.browseDialog.hidden) renderBrowseBody();
    if (!opts.silent) {
      trackOrient('orient_sort', { step: 'Sortering', choice: state.sortBy });
    }
  }

  function applyBrowseAreaValue(raw) {
    var n = parseDecimal(raw);
    if (isFinite(n) && n > 0) {
      state.areaM2 = Math.round(n * 100) / 100;
      state.roomSetupDone = true;
    } else if (String(raw || '').trim() === '') {
      state.areaM2 = 0;
    } else {
      return;
    }
    onRoomStateChanged();
    trackOrientArea('browse');
  }

  function bindBrowseRoomControls() {
    ensureBrowseEls();
    if (els.browseArea && !els.browseArea.getAttribute('data-uf-bound')) {
      els.browseArea.setAttribute('data-uf-bound', '1');
      var onBrowseAreaEdit = function () {
        applyBrowseAreaValue(els.browseArea.value);
      };
      els.browseArea.addEventListener('input', onBrowseAreaEdit);
      els.browseArea.addEventListener('change', onBrowseAreaEdit);
      els.browseArea.addEventListener('keyup', onBrowseAreaEdit);
    }
    if (els.browseWasteBtns && els.browseWasteBtns.length) {
      els.browseWasteBtns.forEach(function (btn) {
        if (btn.getAttribute('data-uf-bound')) return;
        btn.setAttribute('data-uf-bound', '1');
        btn.addEventListener('click', function () {
          var mode = btn.getAttribute('data-uf-orient-browse-waste-mode');
          if (mode !== 'diy' && mode !== 'pro') return;
          state.wasteMode = mode;
          onRoomStateChanged();
          trackOrient('orient_waste', {
            step: 'Legwijze',
            choice: mode === 'pro' ? 'professionele legger' : 'zelf leggen',
          });
        });
      });
    }
    if (els.browseSort && !els.browseSort.getAttribute('data-uf-bound')) {
      els.browseSort.setAttribute('data-uf-bound', '1');
      els.browseSort.addEventListener('change', function () {
        setSortBy(els.browseSort.value || 'featured');
      });
    }
  }

  function openBrowse() {
    ensureBrowseEls();
    if (!els.browseDialog || !els.browseBody) return;
    if (slideshowPlaying) stopSlideshow();
    trackOrient('orient_browse_open', { step: 'Vergroot' });
    trackOrientModal('open', 'browse');
    lastFocusBeforeDialog = document.activeElement;
    /* Los van .uf-orient stacking context, anders overlappen sidebar/lijst de modal */
    if (!browseDialogHome) browseDialogHome = els.browseDialog.parentNode;
    if (els.browseDialog.parentNode !== document.body) {
      document.body.appendChild(els.browseDialog);
    }
    root.classList.add('is-browse-open');
    document.documentElement.classList.add('uf-orient-browse-open');
    els.browseDialog.hidden = false;
    bindBrowseRoomControls();
    syncToolbarRoomUi();
    syncBrowseSortUi();
    renderBrowseBody();
    startBrowseSync();
    var closeBtn = els.browseDialog.querySelector('[data-uf-orient-browse-close]');
    if (closeBtn) closeBtn.focus();
  }

  function closeBrowse(reason) {
    ensureBrowseEls();
    if (!els.browseDialog) return;
    var wasOpen = !els.browseDialog.hidden;
    els.browseDialog.hidden = true;
    destroyBrowseCarousels();
    root.classList.remove('is-browse-open');
    document.documentElement.classList.remove('uf-orient-browse-open');
    if (browseDialogHome && els.browseDialog.parentNode !== browseDialogHome) {
      browseDialogHome.appendChild(els.browseDialog);
    }
    if (wasOpen && reason !== 'select') {
      trackOrientModal('close', 'browse', { reason: reason || 'dismiss' });
    }
    if (lastFocusBeforeDialog && lastFocusBeforeDialog.focus) {
      try {
        lastFocusBeforeDialog.focus();
      } catch (e) {
        /* ignore */
      }
    }
  }

  function selectFromBrowse(productId) {
    if (!productId) return;
    closeBrowse('select');
    trackOrientModal('succeed', 'browse');
    showProduct(productId, {
      keepListScroll: true,
      scrollDetailTop: true,
      source: 'browse',
    });
  }

  function setFiltersOpen(open, reason) {
    var next = !!open;
    var wasOpen = !!state.filtersOpen;
    state.filtersOpen = next;
    root.classList.toggle('is-filters-open', state.filtersOpen);
    if (els.filterPanel) {
      els.filterPanel.setAttribute('aria-hidden', state.filtersOpen ? 'false' : 'true');
    }
    if (els.filterToggle) {
      els.filterToggle.setAttribute('aria-expanded', state.filtersOpen ? 'true' : 'false');
    }
    if (next && !wasOpen) {
      trackOrientModal('open', 'filters');
    } else if (!next && wasOpen) {
      trackOrientModal('close', 'filters', { reason: reason || 'dismiss' });
    }
    if (state.filtersOpen && els.filterClose) {
      try {
        els.filterClose.focus();
      } catch (e) {
        /* ignore */
      }
    }
  }

  function isOrientPanelLayout() {
    return window.matchMedia(
      '(max-width: 1100px) and (orientation: portrait), (max-width: 699px)'
    ).matches;
  }

  function openProductSheet() {
    var wasOpen = root.classList.contains('is-product-sheet-open');
    root.classList.add('is-product-sheet-open');
    if (els.detail) {
      els.detail.setAttribute('aria-hidden', 'false');
      els.detail.style.transform = '';
    }
    document.documentElement.classList.add('uf-orient-sheet-open');
    bindSheetSwipe();
    mountSheetChrome();
    if (els.detailScroll) els.detailScroll.scrollTop = 0;
    bindGallery(
      els.detailBody && els.detailBody.querySelector('[data-uf-orient-gallery]'),
      lastDetailImages
    );
    if (!wasOpen) {
      trackOrient('orient_panel', { step: 'Paneel', choice: 'detail' });
    }
  }

  function closeProductSheet(reason) {
    var wasOpen = root.classList.contains('is-product-sheet-open');
    root.classList.remove('is-product-sheet-open');
    if (els.detail) {
      els.detail.style.transform = '';
      if (!isOrientPanelLayout()) {
        els.detail.setAttribute('aria-hidden', 'true');
      }
    }
    document.documentElement.classList.remove('uf-orient-sheet-open');
    mountSheetChrome();
    bindGallery(activeGalleryRoot(), lastDetailImages);
    if (wasOpen) {
      trackOrient('orient_panel', {
        step: 'Paneel',
        choice: 'list',
        reason: reason || 'dismiss',
      });
    }
  }

  function setMobilePanel(panel) {
    if (panel === 'detail') openProductSheet();
    else closeProductSheet();
  }

  var sheetSwipeBound = false;
  function bindSheetSwipe() {
    if (sheetSwipeBound || !els.detail) return;
    sheetSwipeBound = true;
    var startY = 0;
    var dragging = false;
    els.detail.addEventListener(
      'touchstart',
      function (e) {
        if (!root.classList.contains('is-product-sheet-open')) return;
        if (!e.touches || !e.touches.length) return;
        var t = e.touches[0];
        var scroll = els.detailScroll;
        if (scroll && scroll.scrollTop > 4) return;
        startY = t.clientY;
        dragging = true;
      },
      { passive: true }
    );
    els.detail.addEventListener(
      'touchmove',
      function (e) {
        if (!dragging) return;
        var dy = e.touches[0].clientY - startY;
        if (dy < 0) dy = 0;
        els.detail.style.transform = 'translateY(' + dy + 'px)';
      },
      { passive: true }
    );
    els.detail.addEventListener(
      'touchend',
      function (e) {
        if (!dragging) return;
        dragging = false;
        var dy = (e.changedTouches && e.changedTouches[0] ? e.changedTouches[0].clientY : startY) - startY;
        els.detail.style.transform = '';
        if (dy > 88) closeProductSheet();
      },
      { passive: true }
    );
  }

  function foldHtml(title, inner, startOpen) {
    if (!inner) return '';
    return (
      '<details class="uf-orient__fold"' +
      (startOpen ? ' open' : '') +
      '>' +
      '<summary class="uf-orient__fold-sum">' +
      title +
      '</summary>' +
      '<div class="uf-orient__fold-body">' +
      inner +
      '</div></details>'
    );
  }

  function mountSheetDock() {
    if (!els.sheetDock) return;
    var acts =
      (els.detailBody && els.detailBody.querySelector('.uf-orient__buy-actions')) ||
      (els.sheetDock && els.sheetDock.querySelector('.uf-orient__buy-actions'));
    if (!acts) {
      els.sheetDock.innerHTML = '';
      els.sheetDock.hidden = true;
      return;
    }
    var buy = els.detailBody && els.detailBody.querySelector('.uf-orient__buy');
    var favSlot = root.querySelector('[data-uf-orient-sheet-fav]');
    var heart =
      (els.detailBody && els.detailBody.querySelector('.uf-lf-buy-head .uf-lf-wishlist')) ||
      (favSlot && favSlot.querySelector('.uf-lf-wishlist'));
    if (isOrientPanelLayout() && root.classList.contains('is-product-sheet-open')) {
      if (acts.parentNode !== els.sheetDock) {
        els.sheetDock.innerHTML = '';
        els.sheetDock.appendChild(acts);
      }
      els.sheetDock.hidden = false;
      var titleRow = els.detailBody && els.detailBody.querySelector('.uf-lf-product__title-row');
      if (heart && titleRow && heart.parentNode !== titleRow) titleRow.appendChild(heart);
      if (favSlot) favSlot.innerHTML = '';
    } else {
      if (acts.parentNode === els.sheetDock && buy) buy.appendChild(acts);
      var titleRow = els.detailBody && els.detailBody.querySelector('.uf-lf-product__title-row');
      if (heart && titleRow && heart.parentNode !== titleRow) titleRow.appendChild(heart);
      if (favSlot) favSlot.innerHTML = '';
      els.sheetDock.hidden = true;
    }
  }

  function mountSheetChrome() {
    mountSheetDock();
  }

  function writeUrl() {
    if (writingUrl) return;
    try {
      var url = new URL(window.location.href);
      var q = url.searchParams;
      ['product', 'm2', 'waste', 'sort', 'pattern', 'dims']
        .concat(FILTER_GROUPS)
        .forEach(function (k) {
          q.delete(k);
        });
      if (state.selectedProductId) q.set('product', String(state.selectedProductId));
      if (state.areaM2 > 0) q.set('m2', String(Math.round(state.areaM2 * 100) / 100));
      if (state.wasteMode === 'pro') q.set('waste', 'pro');
      if (state.sortBy && state.sortBy !== 'featured') q.set('sort', state.sortBy);
      FILTER_GROUPS.forEach(function (g) {
        if (state.filters[g] && state.filters[g].length) {
          q.set(g, state.filters[g].join('|'));
        }
      });
      var next = url.pathname + (q.toString() ? '?' + q.toString() : '') + url.hash;
      window.history.replaceState({}, '', next);
    } catch (e) {
      /* ignore */
    }
  }

  function readUrl() {
    try {
      var q = new URL(window.location.href).searchParams;
      var m2 = parseDecimal(q.get('m2'));
      if (isFinite(m2) && m2 > 0) {
        state.areaM2 = m2;
        state.roomSetupDone = true;
      }
      var waste = q.get('waste');
      if (waste === 'pro' || waste === 'diy') {
        state.wasteMode = waste;
        wasteFromUrl = true;
      } else {
        var wastePct = parseDecimal(waste);
        // Oude URL's met percentage negeren; modus blijft diy/pro.
        if (isFinite(wastePct) && wastePct >= 0) {
          /* ignore numeric override */
        }
      }
      var sort = q.get('sort');
      if (sort) {
        state.sortBy = sort === 'recommended' ? 'featured' : sort;
        syncBrowseSortUi();
      }
      var product = q.get('product');
      if (product) state.selectedProductId = Number(product) || product;
      FILTER_GROUPS.forEach(function (g) {
        var raw = q.get(g);
        if (raw) {
          state.filters[g] = raw
            .split('|')
            .map(normalizeKey)
            .filter(Boolean);
        }
      });

      // Homepage keuzehulp → filters
      var patroon = q.get('patroon');
      if (patroon && !(state.filters.soort && state.filters.soort.length)) {
        var map = {
          visgraat: 'visgraat',
          'rechte-plank': 'rechte plank',
          'hongaarse-punt': 'hongaarse punt',
          'walvisgraat-xl': 'walvisgraat xl',
          tegellook: 'tegel',
          'tegel-betonlook': 'tegel',
          tegel: 'tegel',
          'weense-punt': 'weense punt',
        };
        var mapped = map[String(patroon).toLowerCase()];
        if (mapped) state.filters.soort = [mapped];
      }
    } catch (e) {
      /* ignore */
    }
  }

  var advisorBundles = [];

  var ADVISOR_KLEUR = {
    'licht-eiken': ['licht', 'beige & zand'],
    'naturel-warm-eiken': ['eiken', 'bruin', 'beige & zand'],
    'naturel-eiken': ['eiken', 'bruin', 'beige & zand'],
    'warm-eiken': ['eiken', 'bruin', 'beige & zand'],
    'donker-eiken': ['donker', 'bruin'],
    eiken: ['eiken', 'bruin'],
    'licht-grijs': ['grijs', 'licht'],
    grijs: ['grijs'],
    'grijs-beton': ['grijs'],
    'beton-grijs': ['grijs'],
    'greige-taupe': ['grijs', 'beige & zand'],
  };

  var ADVISOR_PATROON = {
    visgraat: 'Visgraat',
    'rechte-plank': 'Rechte plank',
    'hongaarse-punt': 'Hongaarse punt',
    'walvisgraat-xl': 'Walvisgraat XL',
    tegellook: 'Tegel (Betonlook)',
    'tegel-betonlook': 'Tegel (Betonlook)',
    tegel: 'Tegel (Betonlook)',
    'weense-punt': 'Weense punt',
  };

  var ADVISOR_LABELS = {
    'licht-eiken': 'Licht eiken',
    'naturel-warm-eiken': 'Naturel / warm eiken',
    'naturel-eiken': 'Naturel eiken',
    'warm-eiken': 'Warm eiken',
    'donker-eiken': 'Donker eiken',
    eiken: 'Eiken',
    'licht-grijs': 'Licht grijs',
    grijs: 'Grijs',
    'grijs-beton': 'Grijs / Beton',
    'beton-grijs': 'Grijs / Beton',
    'vloerverwarming-aanwezig': 'Vloerverwarming aanwezig',
    vloerverwarming: 'Vloerverwarming aanwezig',
    'appartement-10db-geluidsnorm': 'Appartement (10dB)',
    'stil-wonen': 'Appartement (10dB)',
    'intensief-gebruik-kinderen-huisdieren': 'Intensief gebruik',
    'natte-ruimtes-badkamer': 'Natte ruimtes',
  };

  function advisorSlug(label) {
    return String(label || '')
      .toLowerCase()
      .replace(/&/g, 'en')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function liveAdvisorBundles() {
    return advisorBundles.filter(function (b) {
      if (!b.values.length) return false;
      /* Soft eisen: altijd zichtbaar als chip, geen harde filter */
      if (b.soft) return true;
      var selected = state.filters[b.group] || [];
      return b.values.every(function (v) {
        return selected.indexOf(v) !== -1;
      });
    });
  }

  function pickExistingKeys(wanted, have) {
    var values = [];
    (wanted || []).forEach(function (k) {
      var key = normalizeKey(k);
      if (have.indexOf(key) !== -1 && values.indexOf(key) === -1) values.push(key);
    });
    return values;
  }

  function assignAdvisorBundle(id, label, group, wanted, optionKeys, soft) {
    var have = optionKeys[group] || [];
    var values = pickExistingKeys(wanted, have);
    if (!values.length || !label) return false;
    if (!soft) {
      state.filters[group] = values.slice();
    }
    advisorBundles.push({
      id: id,
      label: label,
      group: group,
      values: values.slice(),
      soft: !!soft,
    });
    return true;
  }

  function numericKeysAtLeast(keys, min) {
    return (keys || []).filter(function (k) {
      var n = parseFloat(String(k).replace(',', '.'));
      return isFinite(n) && n >= min;
    });
  }

  function eigKind(slug) {
    var s = String(slug || '').toLowerCase();
    if (s.indexOf('vloerverwarming') !== -1) return 'vvw';
    if (s.indexOf('appartement') !== -1 || s.indexOf('10db') !== -1 || s === 'stil-wonen') {
      return 'geluid';
    }
    if (s.indexOf('intensief') !== -1 || s.indexOf('kinderen') !== -1) return 'slijtlaag';
    if (s.indexOf('natte') !== -1 || s.indexOf('badkamer') !== -1) return 'water';
    return '';
  }

  function readAdvisorProfile() {
    var profile = {
      advisor: false,
      kleurPref: '',
      patroon: '',
      eigs: [],
    };
    try {
      var q = new URL(window.location.href).searchParams;
      profile.advisor = q.get('advisor') === '1';
      profile.kleurPref = q.get('kleur_pref') || '';
      profile.patroon = q.get('patroon') || '';
      profile.eigs = (q.get('eigenschappen') || '')
        .split(',')
        .map(function (s) {
          return s.trim();
        })
        .filter(Boolean);
      if (profile.advisor) {
        sessionStorage.removeItem('uf_orient_advisor_cleared');
      }
      var fromKeuzehulp =
        profile.advisor ||
        profile.kleurPref ||
        profile.patroon ||
        profile.eigs.length > 0;
      if (!fromKeuzehulp) return profile;
      var raw = sessionStorage.getItem('uf_floor_advisor_profile');
      var labels = raw ? JSON.parse(raw).labels || [] : [];
      labels.forEach(function (label) {
        var slug = advisorSlug(label);
        if (!profile.kleurPref && ADVISOR_KLEUR[slug]) profile.kleurPref = slug;
        if (!profile.patroon && ADVISOR_PATROON[slug]) profile.patroon = slug;
        if (eigKind(slug) && profile.eigs.indexOf(slug) === -1) {
          profile.eigs.push(slug);
        }
      });
      profile.advisor = true;
    } catch (e) {
      /* ignore */
    }
    return profile;
  }

  function applyAdvisorFilters(optionKeys) {
    advisorBundles = [];
    var profile = readAdvisorProfile();
    if (!profile.advisor) return;

    if (profile.patroon && ADVISOR_PATROON[profile.patroon] && (state.filters.soort || []).length) {
      advisorBundles.push({
        id: 'patroon',
        label: ADVISOR_PATROON[profile.patroon],
        group: 'soort',
        values: state.filters.soort.slice(),
      });
    }

    if (profile.kleurPref && ADVISOR_KLEUR[profile.kleurPref]) {
      assignAdvisorBundle(
        'kleur_pref',
        ADVISOR_LABELS[profile.kleurPref] || 'Kleurgroep',
        'kleur',
        ADVISOR_KLEUR[profile.kleurPref],
        optionKeys
      );
    }

    profile.eigs.forEach(function (slug) {
      var kind = eigKind(slug);
      if (kind === 'vvw') {
        assignAdvisorBundle(
          'eig-vloerverwarming',
          ADVISOR_LABELS[slug] || ADVISOR_LABELS.vloerverwarming,
          'vvw',
          ['ja'],
          optionKeys
        );
      } else if (kind === 'geluid') {
        /* Soft: boost ≥10 dB, niet hard filteren */
        assignAdvisorBundle(
          'eig-appartement',
          ADVISOR_LABELS[slug] || ADVISOR_LABELS['appartement-10db-geluidsnorm'],
          'geluid',
          numericKeysAtLeast(optionKeys.geluid, 10),
          optionKeys,
          true
        );
      } else if (kind === 'slijtlaag') {
        /* Soft: boost slijtlaag ≥0.55, niet hard filteren */
        assignAdvisorBundle(
          'eig-intensief',
          ADVISOR_LABELS[slug] || 'Intensief gebruik',
          'slijtlaag',
          numericKeysAtLeast(optionKeys.slijtlaag, 0.55),
          optionKeys,
          true
        );
      } else if (kind === 'water') {
        assignAdvisorBundle(
          'eig-natte-ruimtes',
          ADVISOR_LABELS[slug] || 'Natte ruimtes',
          'waterbestendig',
          ['ja'],
          optionKeys
        );
      }
    });

    var order = {
      patroon: 0,
      kleur_pref: 1,
      'eig-vloerverwarming': 2,
      'eig-appartement': 3,
      'eig-intensief': 4,
      'eig-natte-ruimtes': 5,
    };
    advisorBundles.sort(function (a, b) {
      return (order[a.id] == null ? 9 : order[a.id]) - (order[b.id] == null ? 9 : order[b.id]);
    });
  }

  function replaceSearchParams(mutator) {
    try {
      var url = new URL(window.location.href);
      mutator(url.searchParams);
      var next = url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : '') + url.hash;
      window.history.replaceState({}, '', next);
    } catch (e) {
      /* ignore */
    }
  }

  function forgetAdvisorSource(id) {
    replaceSearchParams(function (q) {
      if (id === 'kleur_pref') q.delete('kleur_pref');
      else if (id === 'patroon') q.delete('patroon');
      else if (
        id === 'eig-vloerverwarming' ||
        id === 'eig-appartement' ||
        id === 'eig-intensief' ||
        id === 'eig-natte-ruimtes' ||
        id === 'eig-stil-wonen'
      ) {
        var drop = {
          'eig-vloerverwarming': ['vloerverwarming', 'vloerverwarming-aanwezig'],
          'eig-appartement': ['appartement-10db-geluidsnorm', 'stil-wonen'],
          'eig-stil-wonen': ['appartement-10db-geluidsnorm', 'stil-wonen'],
          'eig-intensief': ['intensief-gebruik-kinderen-huisdieren'],
          'eig-natte-ruimtes': ['natte-ruimtes-badkamer'],
        };
        var dropSlugs = drop[id] || [];
        var parts = (q.get('eigenschappen') || '')
          .split(',')
          .map(function (s) {
            return s.trim();
          })
          .filter(function (s) {
            return s && dropSlugs.indexOf(s) === -1 && eigKind(s) !== (
              id === 'eig-vloerverwarming'
                ? 'vvw'
                : id === 'eig-appartement' || id === 'eig-stil-wonen'
                  ? 'geluid'
                  : id === 'eig-intensief'
                    ? 'slijtlaag'
                    : 'water'
            );
          });
        if (parts.length) q.set('eigenschappen', parts.join(','));
        else q.delete('eigenschappen');
      }
      if (!q.get('kleur_pref') && !q.get('patroon') && !q.get('eigenschappen')) {
        q.delete('advisor');
      }
    });
  }

  function stripAdvisorParams() {
    try {
      sessionStorage.setItem('uf_orient_advisor_cleared', '1');
    } catch (e) {
      /* ignore */
    }
    replaceSearchParams(function (q) {
      ['advisor', 'smaak', 'kleur_pref', 'eigenschappen', 'patroon'].forEach(function (k) {
        q.delete(k);
      });
    });
  }

  function removeAdvisorBundle(id) {
    var bundle = null;
    advisorBundles = advisorBundles.filter(function (b) {
      if (b.id === id) {
        bundle = b;
        return false;
      }
      return true;
    });
    if (!bundle) return;
    if (!bundle.soft) {
      state.filters[bundle.group] = (state.filters[bundle.group] || []).filter(function (v) {
        return bundle.values.indexOf(v) === -1;
      });
      var list = els.filterLists[bundle.group];
      if (list) {
        list.querySelectorAll('input').forEach(function (inp) {
          if (bundle.values.indexOf(inp.value) !== -1) inp.checked = false;
        });
      }
    }
    forgetAdvisorSource(id);
    updateFilterChrome();
    updateFilterCounts();
    applyAndRender({ scrollDetailTop: true });
    writeUrl();
    trackOrient('orient_filter', { step: 'Filter', choice: filterSummary() || 'chip weg' });
  }

  function fetchAllProducts() {
    var products = [];
    function fetchPage(page) {
      var url =
        '/collections/' +
        encodeURIComponent(collectionHandle) +
        '?view=uf-filter-data&page=' +
        page;
      return fetch(url, { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('Catalogus laden mislukt (' + res.status + ')');
          return res.json();
        })
        .then(function (data) {
          var chunk = (data && data.products) || [];
          products = products.concat(chunk);
          var pages = (data && data.pages) || 1;
          if (page < pages) return fetchPage(page + 1);
          return products;
        });
    }
    return fetchPage(1);
  }

  function bind() {
    bindRoomDialog();

    if (els.detailBody) {
      els.detailBody.addEventListener('click', function (e) {
        var helpBtn = e.target.closest('[data-uf-orient-pack-help]');
        if (!helpBtn) return;
        var panel = els.detailBody.querySelector('#' + helpBtn.getAttribute('aria-controls'));
        if (!panel) return;
        var open = helpBtn.getAttribute('aria-expanded') !== 'true';
        helpBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        panel.hidden = !open;
        trackOrientDetail('pack_help');
        if (open) trackOrientModal('open', 'pack_help');
        else trackOrientModal('close', 'pack_help', { reason: 'toggle' });
      });
    }

    if (els.area) {
      els.area.addEventListener('input', function () {
        var n = parseDecimal(els.area.value);
        if (isFinite(n) && n > 0) {
          state.areaM2 = Math.round(n * 100) / 100;
          state.roomSetupDone = true;
        } else if (els.area.value.trim() === '') {
          state.areaM2 = 0;
        }
        onRoomStateChanged();
        trackOrientArea('toolbar');
      });
    }
    if (els.wasteModeBtns && els.wasteModeBtns.length) {
      els.wasteModeBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var mode = btn.getAttribute('data-uf-orient-waste-mode');
          if (mode !== 'diy' && mode !== 'pro') return;
          state.wasteMode = mode;
          onRoomStateChanged();
          trackOrient('orient_waste', {
            step: 'Legwijze',
            choice: mode === 'pro' ? 'professionele legger' : 'zelf leggen',
          });
        });
      });
    }

    if (els.filterToggle) {
      els.filterToggle.addEventListener('click', function () {
        if (!state.filtersOpen) closeProductSheet('filters');
        setFiltersOpen(!state.filtersOpen, 'toggle');
      });
    }
    if (els.filterTabs) {
      els.filterTabs.addEventListener('click', function (e) {
        var tab = e.target.closest('[data-uf-orient-filter-tab]');
        if (!tab) return;
        setFilterPane(tab.getAttribute('data-uf-orient-filter-tab'));
      });
    }
    if (els.filterClose) {
      els.filterClose.addEventListener('click', function () {
        setFiltersOpen(false, 'close');
      });
    }
    if (els.filterBackdrop) {
      els.filterBackdrop.addEventListener('click', function () {
        setFiltersOpen(false, 'backdrop');
      });
    }
    if (els.filterApply) {
      els.filterApply.addEventListener('click', function () {
        setFiltersOpen(false, 'apply');
      });
    }
    if (els.reset) {
      els.reset.addEventListener('click', function () {
        state.filters = emptyFilters();
        advisorBundles = [];
        stripAdvisorParams();
        Object.keys(els.filterLists).forEach(function (g) {
          var list = els.filterLists[g];
          if (!list) return;
          list.querySelectorAll('input').forEach(function (inp) {
            inp.checked = false;
          });
        });
        updateFilterChrome();
        updateFilterCounts();
        applyAndRender({ scrollDetailTop: true });
        writeUrl();
        trackOrient('orient_reset', { step: 'Filters gewist' });
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        if (els.browseDialog && !els.browseDialog.hidden) {
          closeBrowse('escape');
          return;
        }
        if (els.reviewsDialog && !els.reviewsDialog.hidden) {
          closeReviews('escape');
          return;
        }
        if (els.offerteDialog && !els.offerteDialog.hidden) {
          closeOfferte('escape');
          return;
        }
        if (els.compareDialog && !els.compareDialog.hidden) {
          closeCompare('escape');
          return;
        }
        if (state.filtersOpen) {
          setFiltersOpen(false, 'escape');
          return;
        }
        if (root.classList.contains('is-product-sheet-open')) {
          closeProductSheet('escape');
        }
      }
    });

    if (els.chips) {
      els.chips.addEventListener('click', function (e) {
        var advisorBtn = e.target.closest('[data-uf-orient-advisor-chip]');
        if (advisorBtn) {
          removeAdvisorBundle(advisorBtn.getAttribute('data-uf-orient-advisor-chip'));
          return;
        }
        var btn = e.target.closest('[data-uf-orient-chip-remove]');
        if (!btn) return;
        var g = btn.getAttribute('data-uf-orient-chip-remove');
        var val = btn.getAttribute('data-value');
        state.filters[g] = (state.filters[g] || []).filter(function (v) {
          return v !== val;
        });
        var list = els.filterLists[g];
        if (list) {
          list.querySelectorAll('input').forEach(function (inp) {
            if (inp.value === val) inp.checked = false;
          });
        }
        updateFilterChrome();
        applyAndRender({ scrollDetailTop: true });
        writeUrl();
        trackOrient('orient_filter', { step: 'Filter', choice: filterSummary() || 'chip weg' });
      });
    }

    if (els.list) {
      els.list.addEventListener('scroll', syncScrollHint, { passive: true });
      window.addEventListener('resize', syncScrollHint);
      if (typeof window.ResizeObserver === 'function') {
        new ResizeObserver(syncScrollHint).observe(els.list);
      }
      els.list.addEventListener('click', function (e) {
        var fav = e.target.closest('[data-uf-orient-fav]');
        if (fav) {
          e.preventDefault();
          e.stopPropagation();
          var fid = Number(fav.getAttribute('data-uf-orient-fav'));
          toggleFavorite(fid, catalogById[fid]);
          applyAndRender({ skipDetail: true });
          return;
        }
        var cmp = e.target.closest('[data-uf-orient-cmp]');
        if (cmp) {
          e.preventDefault();
          e.stopPropagation();
          var cid = Number(cmp.getAttribute('data-uf-orient-cmp'));
          if (!toggleCompare(cid)) flashCompareLimit();
          applyAndRender({ skipDetail: true });
          return;
        }
        var row = e.target.closest('[data-uf-orient-row]');
        if (row) {
          var listId = row.getAttribute('data-product-id');
          var listProduct = catalogById[Number(listId)];
          trackOrient('orient_list_click', {
            step: 'Lijst',
            choice: (listProduct && listProduct.title) || '',
            handle: (listProduct && listProduct.handle) || '',
            source: 'list',
          });
          showProduct(listId, {
            keepListScroll: true,
            scrollDetailTop: true,
            source: 'list',
          });
          if (slideshowPlaying) restartSlideshowTimer();
        }
      });
      els.list.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        var row = e.target.closest('[data-uf-orient-row]');
        if (!row) return;
        e.preventDefault();
        var listId = row.getAttribute('data-product-id');
        var listProduct = catalogById[Number(listId)];
        trackOrient('orient_list_click', {
          step: 'Lijst',
          choice: (listProduct && listProduct.title) || '',
          handle: (listProduct && listProduct.handle) || '',
          source: 'list',
        });
        showProduct(listId, {
          keepListScroll: true,
          scrollDetailTop: true,
          source: 'list',
        });
        if (slideshowPlaying) restartSlideshowTimer();
      });
    }

    if (els.sort) {
      els.sort.addEventListener('change', function () {
        setSortBy(els.sort.value || 'featured');
      });
    }

    function copyShareLink(btn) {
      trackOrient('orient_share', { step: 'Delen' });
      var url = window.location.href;
      var label = btn && btn.textContent ? btn.textContent : 'Deel selectie';
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () {
          if (btn) btn.textContent = 'Link gekopieerd';
          setTimeout(function () {
            if (btn) btn.textContent = label;
          }, 1600);
        });
      } else {
        window.prompt('Kopieer deze link:', url);
      }
    }
    root.addEventListener('click', function (e) {
      var shareBtn = e.target.closest('[data-uf-orient-share]');
      if (shareBtn) {
        e.preventDefault();
        copyShareLink(shareBtn);
      }
    });
    if (els.settingsOpen) {
      els.settingsOpen.addEventListener('click', function () {
        closeProductSheet();
        openRoomDialog();
      });
    }
    if (els.sheetClose) {
      els.sheetClose.addEventListener('click', function () {
        closeProductSheet('close');
      });
    }

    if (els.wishlistThumbs) {
      els.wishlistThumbs.addEventListener('click', function (e) {
        var rem = e.target.closest('[data-uf-orient-wish-remove]');
        if (rem) {
          e.preventDefault();
          e.stopPropagation();
          toggleFavorite(Number(rem.getAttribute('data-uf-orient-wish-remove')));
          applyAndRender({ skipDetail: true });
          return;
        }
        var sel = e.target.closest('[data-uf-orient-wish-select]');
        if (sel) {
          e.preventDefault();
          var sid = Number(sel.getAttribute('data-uf-orient-wish-select'));
          showProduct(sid, {
            keepListScroll: true,
            scrollDetailTop: true,
            source: 'wishlist',
          });
          if (!toggleCompare(sid)) {
            flashCompareLimit();
            return;
          }
          applyAndRender({ skipDetail: true });
        }
      });
      els.wishlistThumbs.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        if (e.target.closest('[data-uf-orient-wish-remove]')) return;
        var sel = e.target.closest('[data-uf-orient-wish-select]');
        if (!sel) return;
        e.preventDefault();
        var sid = Number(sel.getAttribute('data-uf-orient-wish-select'));
        showProduct(sid, {
          keepListScroll: true,
          scrollDetailTop: true,
          source: 'wishlist',
        });
        if (!toggleCompare(sid)) {
          flashCompareLimit();
          return;
        }
        applyAndRender({ skipDetail: true });
      });
    }

    if (els.slidePrev) {
      els.slidePrev.addEventListener('click', function () {
        slideBy(-1);
        trackOrient('orient_slideshow', { step: 'Slideshow', choice: 'prev' });
      });
    }
    if (els.slideNext) {
      els.slideNext.addEventListener('click', function () {
        slideBy(1);
        trackOrient('orient_slideshow', { step: 'Slideshow', choice: 'next' });
      });
    }
    if (els.slideToggle) {
      els.slideToggle.addEventListener('click', toggleSlideshow);
    }

    if (els.compareOpen) {
      els.compareOpen.addEventListener('click', openCompare);
    }
    root.querySelectorAll('[data-uf-orient-compare-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        closeCompare(
          btn.classList && btn.classList.contains('uf-orient__compare-backdrop')
            ? 'backdrop'
            : 'close'
        );
      });
    });

    if (els.offerteOpen) {
      els.offerteOpen.addEventListener('click', openOfferte);
    }
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-uf-orient-offerte-close]')) {
        e.preventDefault();
        closeOfferte(
          e.target.closest('.uf-orient__offerte-backdrop') ? 'backdrop' : 'close'
        );
      }
    });
    if (els.offerteBody) {
      els.offerteBody.addEventListener('submit', function (e) {
        var form = e.target.closest('[data-uf-orient-offerte-form]');
        if (!form) return;
        e.preventDefault();
        submitOfferteForm(form);
      });
    }

    if (els.reviewsOpen) {
      els.reviewsOpen.addEventListener('click', openReviews);
    }
    root.querySelectorAll('[data-uf-orient-reviews-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        closeReviews(
          btn.classList && String(btn.className || '').indexOf('backdrop') !== -1
            ? 'backdrop'
            : 'close'
        );
      });
    });
    if (els.reviewsBody) {
      els.reviewsBody.addEventListener('click', function (e) {
        var tab = e.target.closest('[data-uf-orient-reviews-tab]');
        if (!tab || tab.disabled) return;
        var next = tab.getAttribute('data-uf-orient-reviews-tab') || 'all';
        reviewsTab = next;
        renderReviewsBody();
      });
    }
    loadReviews();

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-uf-orient-browse-open]')) {
        e.preventDefault();
        openBrowse();
        return;
      }
      if (e.target.closest('[data-uf-orient-browse-close]')) {
        e.preventDefault();
        closeBrowse(
          e.target.closest('.uf-orient__browse-backdrop') ? 'backdrop' : 'close'
        );
        return;
      }
      if (e.target.closest('[data-uf-orient-browse-more]')) {
        e.preventDefault();
        appendBrowsePage();
        return;
      }
      if (!els.browseDialog || els.browseDialog.hidden) return;
      var card = e.target.closest('[data-uf-orient-browse-card]');
      if (!card) return;
      selectFromBrowse(card.getAttribute('data-product-id'));
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var card = e.target.closest('[data-uf-orient-browse-card]');
      if (!card || !els.browseDialog || els.browseDialog.hidden) return;
      e.preventDefault();
      selectFromBrowse(card.getAttribute('data-product-id'));
    });

    var panelMq = window.matchMedia(
      '(max-width: 1100px) and (orientation: portrait), (max-width: 699px)'
    );
    function syncOrientPanelMode() {
      if (els.mobileSwitch) els.mobileSwitch.hidden = true;
      if (!panelMq.matches) {
        closeProductSheet();
        mountSheetChrome();
      }
      applyFilterGroupVisibility();
      syncActieBarPlacement();
    }
    if (els.spec) {
      els.spec.addEventListener('click', function (e) {
        var tab = e.target.closest('[data-uf-orient-spec-tab]');
        if (tab) {
          setSpecTab(tab.getAttribute('data-uf-orient-spec-tab'));
          return;
        }
        var infoTab = e.target.closest('[data-uf-orient-info-tab]');
        if (infoTab) {
          setSpecInfoTab(infoTab.getAttribute('data-uf-orient-info-tab'));
          return;
        }
        var helpBtn = e.target.closest('[data-uf-orient-pack-help]');
        if (helpBtn) {
          var wrap = helpBtn.closest('[data-uf-orient-spec-info]') || els.spec;
          var panel = wrap.querySelector('[data-uf-orient-pack-help-panel]');
          if (!panel) return;
          var open = helpBtn.getAttribute('aria-expanded') !== 'true';
          helpBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
          panel.hidden = !open;
          trackOrientDetail('pack_help');
          if (open) trackOrientModal('open', 'pack_help');
          else trackOrientModal('close', 'pack_help', { reason: 'toggle' });
          return;
        }
        if (e.target.closest('[data-uf-orient-open-pdp]')) {
          e.preventDefault();
          trackOrientDetail('pdp');
          openProductSheet();
        }
      });
    }
    if (panelMq.addEventListener) panelMq.addEventListener('change', syncOrientPanelMode);
    else if (panelMq.addListener) panelMq.addListener(syncOrientPanelMode);
    syncOrientPanelMode();

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-uf-fa-open]')) closeProductSheet('advisor');
    });

    root.addEventListener('click', function (e) {
      var pdpLink = e.target.closest('a.uf-orient__pdp-link');
      if (pdpLink) {
        trackOrientDetail('pdp');
        return;
      }
      var staalLink = e.target.closest('a.uf-orient__staal-link');
      if (staalLink) {
        trackOrientDetail('stalen');
        return;
      }
      var colorBtn = e.target.closest('[data-uf-lf-color-preview-open]');
      if (colorBtn) {
        var mode = colorBtn.getAttribute('data-uf-lf-color-preview-open') || 'zoom';
        trackOrientDetail(mode === 'color' ? 'kies_kleur' : 'gallery');
        trackOrientModal('open', 'color_preview', { source: mode });
        return;
      }
      var galleryNav = e.target.closest(
        '[data-uf-orient-gallery-prev], [data-uf-orient-gallery-next], .uf-lf-gallery__thumb, .uf-lf-gallery__dot'
      );
      if (galleryNav) {
        trackOrientDetail('gallery');
      }
    });

    document.addEventListener('click', function (e) {
      var closePreview = e.target.closest('[data-uf-lf-color-preview-close]');
      if (!closePreview) return;
      if (!root.contains(closePreview) && !document.documentElement.classList.contains('uf-lf-color-preview-open')) {
        return;
      }
      if (!document.documentElement.classList.contains('uf-lf-color-preview-open')) return;
      trackOrientModal('close', 'color_preview', { reason: 'close' });
    });
  }

  function mountActieBar() {
    var el = els.actieBar;
    if (!el) return;
    var tries = 0;
    function boot() {
      if (window.UfLfPromoCountdown && typeof window.UfLfPromoCountdown.mount === 'function') {
        window.UfLfPromoCountdown.mount(el, {
          days: 'd',
          hours: 'u',
          minutes: 'm',
          seconds: 's',
          headingActive: 'Lopende actie',
          headingUpcoming: 'Volgende actie',
          subActive: 'nog',
          subUpcoming: 'over'
        });
        return;
      }
      if (++tries < 80) window.setTimeout(boot, 40);
    }
    boot();
  }

  function init() {
    loadFavorites();
    loadCompare();
    readUrl();
    if (!(state.areaM2 > 0)) loadStoredAreaM2();
    else persistAreaM2();
    syncToolbarRoomUi();
    mountActieBar();
    bind();
    updateFilterChrome();
    renderWishlistBar();

    if (!state.roomSetupDone || !(state.areaM2 > 0)) {
      openRoomDialog();
    }

    loadPopularityScores();

    fetchAllProducts()
      .then(function (products) {
        catalog = products || [];
        catalogById = {};
        catalog.forEach(function (p) {
          catalogById[Number(p.id)] = p;
        });
        var opts = collectOptions(catalog);
        FILTER_GROUPS.forEach(function (g) {
          var have = opts[g] || [];
          state.filters[g] = (state.filters[g] || []).filter(function (v) {
            return have.indexOf(v) !== -1;
          });
        });
        applyAdvisorFilters(opts);
        FILTER_GROUPS.forEach(function (g) {
          renderFilterList(g, opts[g] || []);
          if (els.filterGroups[g]) {
            var empty = !(opts[g] && opts[g].length);
            els.filterGroups[g].setAttribute(
              'data-uf-filter-empty',
              !FILTER_ALWAYS_SHOW[g] && empty ? '1' : '0'
            );
          }
        });
        applyFilterGroupVisibility();
        if (els.error) els.error.hidden = true;
        updateFilterCounts();
        applyAndRender({ scrollDetailTop: true });
        writeUrl();
        var fromAdvisor = false;
        try {
          fromAdvisor = new URLSearchParams(window.location.search).get('advisor') === '1';
        } catch (advisorErr) {
          fromAdvisor = false;
        }
        trackOrient('orient_view', {
          step: 'Oriëntatie geopend',
          choice: fromAdvisor ? 'via keuzehulp' : 'direct',
        });
      })
      .catch(function (err) {
        if (els.count) els.count.textContent = '0 resultaten';
        if (els.error) {
          els.error.hidden = false;
          els.error.textContent =
            (err && err.message) || 'Kon de productcatalogus niet laden.';
        }
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
